/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * AddMarketAreaDetailReqDTO
 * 新建请求
 */
export interface AddMarketAreaDetailReqDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /** 专区id */
  marketAreaId?: string;
  /** 线索类目名称 */
  sourceCategory?: string;
  /** 线索id */
  sourceCode?: string;
  /** 线索图片 */
  sourceImgUrl?: string;
  /** 线索价格 */
  sourcePrice?: number;
  /**
   * 线索销量
   * @format int32
   */
  sourceSales?: number;
  /**
   * 线索状态
   * @format int32
   */
  sourceStatus?: number;
  /** 线索运营标签 */
  sourceTags?: string;
  /** 线索标题 */
  sourceTitle?: string;
}

/**
 * AddProductExtendReqDTO
 * 新建请求
 */
export interface AddProductExtendReqDTO {
  /**
   * 高
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长
   * @format double
   */
  maintainLength?: number;
  /**
   * 重量
   * @format int64
   */
  maintainWeight?: number;
  /**
   *  宽
   * @format double
   */
  maintainWidth?: number;
  /** 商品属性 */
  productAttribute?: string;
  /** 商品编码 */
  productCode?: string;
  /** 详情图 */
  productDescImgs?: string;
  /** 轮播图 */
  productImageUrl?: string;
  /** 商品名称 */
  productName?: string;
  /** 规格信息 */
  productSku?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
}

/** AddProductLabelVO */
export interface AddProductLabelVO {
  /** 标签英文名称 */
  labelNameEn?: string;
  /** 标签日文名称 */
  labelNameJp?: string;
  /** 标签韩文名称 */
  labelNameKr?: string;
  /** 标签中文名称 */
  labelNameZh?: string;
  /**
   * 上级标签
   * @format int64
   */
  parentId?: number;
}

/** AddProductLinkReqVO */
export interface AddProductLinkReqVO {
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /** 标签列表 */
  labelIds?: number[];
  /** 商品链接 */
  productLink?: string;
}

/**
 * AddSourceProductReqDTO
 * 新增货源
 */
export interface AddSourceProductReqDTO {
  /** @format int64 */
  id?: number;
  /** 商品链接 */
  productUrls?: string[];
  /** 标签 */
  tagCodes?: string[];
}

/**
 * AddSourceReqDTO
 * 新建请求
 */
export interface AddSourceReqDTO {
  /**
   * 上架时间
   * @format date-time
   */
  onLineTime?: string;
  /** 价格（美金） */
  price?: number;
  /** 商品图片 */
  productImg?: string;
  /** 商品名称 */
  productName?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 商品分类 */
  sourceCategory?: string;
  /** 线索链接 */
  sourceUrl?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 线索标签id */
  tagCodes?: string[];
}

/**
 * AddSourceTagReqDTO
 * 新建请求
 */
export interface AddSourceTagReqDTO {
  /** 标签说明 */
  remark?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 标签名称 */
  tagName?: string;
  /**
   * 标签类型：1 线索标签 2 货源标签
   * @format int32
   */
  tagType?: number;
}

/** AddWishListDTO */
export interface AddWishListDTO {
  /** 图册code */
  atlasCode?: string;
}

/** AdjustLabelOpenStatusVO */
export interface AdjustLabelOpenStatusVO {
  /**
   * 标签id
   * @format int64
   */
  labelId?: number;
  /**
   * 开启状态 1-启用 2-停用
   * @format int32
   */
  openStatus?: number;
}

/** AdjustTranslateReqDTO */
export interface AdjustTranslateReqDTO {
  list?: TranslateCommonTextReqDTO[];
}

/** AtlasOrderNotifyReq */
export interface AtlasOrderNotifyReq {
  /** @format int64 */
  customerShopId?: number;
  platformOrderNo?: string;
  productCodes?: string[];
}

/** AtlasProductPriceVO */
export interface AtlasProductPriceVO {
  /** 商品价格说明 */
  priceDesc?: string;
  /** 商品区间结束 */
  priceEnd?: number;
  /** 商品区间开始 */
  priceStart?: number;
}

/** AtlasSupplierRespVO */
export interface AtlasSupplierRespVO {
  /** 供应商code */
  supplierCode?: string;
  /** 供应商名称 */
  supplierName?: string;
}

/** AuditProductAtlasVO */
export interface AuditProductAtlasVO {
  /** 产品图册编码 */
  atlasCode?: string;
  /**
   * 审核结果 2-审核通过 3-审核不通过
   * @format int32
   */
  auditStatus?: number;
  /** 审核人姓名 */
  auditorName?: string;
  /** 审核不通过原因 */
  rejectReason?: string;
}

/** BaseQueryPage */
export interface BaseQueryPage {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
}

/** BizResponse */
export interface BizResponse {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** BrandBannnerQueryRespDTO */
export interface BrandBannnerQueryRespDTO {
  /**
   * 品牌编号
   * @format int64
   */
  brandId?: number;
  /** 品牌Logo */
  brandLogo?: string;
  /** 品牌名称 */
  brandName?: string;
  /** 展示商品主图 */
  displayedProductMainImg?: string;
}

/** BrandDisplayedProductImgDTO */
export interface BrandDisplayedProductImgDTO {
  /**
   * 图片高
   * @format int32
   */
  height?: number;
  /** 主图标识  true：是， false：不是 */
  mainImgFlag?: boolean;
  /** 图片url */
  url?: string;
  /**
   * 图片宽
   * @format int32
   */
  width?: number;
}

/** BrandInfoDTO */
export interface BrandInfoDTO {
  /** @format int32 */
  authStatus?: number;
  /** @format int64 */
  brandId?: number;
  brandName?: string;
  /** @format int32 */
  brandStatus?: number;
  /** @format int32 */
  hasReleased?: number;
  /** @format int32 */
  isAuthorizing?: number;
}

/** BrandInfoReqDTO */
export interface BrandInfoReqDTO {
  productCodeList?: string[];
  shopCodeList?: string[];
  /** @format int64 */
  superCustomerId?: number;
}

/** BrandInfoRespDTO */
export interface BrandInfoRespDTO {
  brandInfo?: BrandInfoDTO;
  productCode?: string;
  shopCode?: string;
}

/** BrandItemDTO */
export interface BrandItemDTO {
  /**
   * 主键id
   * @format int64
   */
  brandId?: number;
  /** 品牌名称 */
  brandName?: string;
}

/**
 * BrandManageDetailRespDTO
 * 后台管理-品牌详情
 */
export interface BrandManageDetailRespDTO {
  /** 最大平均客单价 */
  averagePriceMax?: number;
  /** 最小平均客单价 */
  averagePriceMin?: number;
  /**
   * 签约状态 0-未签订、1-已签订
   * @format int32
   */
  brandAuthContractStatus?: number;
  /**
   * 品牌授权有效期结束时间
   * @format date-time
   */
  brandAuthPeriodEnd?: string;
  /**
   * 品牌授权有效期开始时间
   * @format date-time
   */
  brandAuthPeriodStart?: string;
  /**
   * 品牌授权状态 0未生效、1生效中、2已过期
   * @format int32
   */
  brandAuthStatus?: number;
  /** 品牌授权类型 0-普通授权、1-独家授权、2-简易贩卖授权 */
  brandAuthTypeList?: number[];
  /** 品牌理念(中文) */
  brandConceptCn?: string;
  /** 品牌理念(英文) */
  brandConceptEn?: string;
  /** 品牌理念(日文) */
  brandConceptJp?: string;
  /** 品牌理念(韩文) */
  brandConceptKr?: string;
  /**
   * 主键id
   * @format int64
   */
  brandId?: number;
  /** 品牌logo */
  brandLogo?: string;
  /** 品牌说明书(中文) */
  brandManualCn?: string;
  /** 品牌说明书(英文) */
  brandManualEn?: string;
  /** 品牌说明书(日文) */
  brandManualJp?: string;
  /** 品牌说明书(韩文) */
  brandManualKr?: string;
  /** 品牌名称 */
  brandName?: string;
  /** 店铺列表 */
  brandShopList?: BrandShopRespDTO[];
  /**
   * 品牌发布状态 0草稿 1未发布 2已发布
   * @format int32
   */
  brandStatus?: number;
  /** 品牌风格 */
  brandStyleList?: BrandStyleRespDTO[];
  /**
   * 品牌类别 0:店铺 1:商品
   * @format int32
   */
  brandType?: number;
  /**
   * 是否可联名：0否 1是
   * @format int32
   */
  canJointName?: number;
  /** 市 */
  city?: string;
  /** 国家 */
  country?: string;
  /** 国家编码 */
  countryCode?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  creatorId?: string;
  creatorName?: string;
  /** 最大平均客单价(币种) */
  currencyAveragePriceMax?: number;
  /** 最小平均客单价(币种) */
  currencyAveragePriceMin?: number;
  /** 客户授权条件(中文) */
  customerAuthConditionCn?: string;
  /** 客户授权条件(英文) */
  customerAuthConditionEn?: string;
  /** 客户授权条件(日文) */
  customerAuthConditionJp?: string;
  /** 客户授权条件(韩文) */
  customerAuthConditionKr?: string;
  /** 客户授权类型 0普通授权 1独家授权 2不可授权 */
  customerAuthTypeList?: number[];
  /** 开拓人 */
  developPerson?: string;
  /**
   * 开拓方式
   * @format int32
   */
  developWay?: number;
  /** 展示的商品主图 */
  displayedProductImgList?: BrandDisplayedProductImgDTO[];
  editorId?: string;
  editorName?: string;
  /**
   * 是否删除：0未删除 1已删除
   * @format int32
   */
  isDeleted?: number;
  /** 主营客户端类目 */
  mainCategoryFrontList?: ProductCategoryFrontendRespDTO[];
  /** 主营类目 */
  mainCategoryIdList?: string[];
  /** 省 */
  province?: string;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/**
 * BrandManageInfoRespDTO
 * 后台管理-品牌查询列表
 */
export interface BrandManageInfoRespDTO {
  /** 最大平均客单价 */
  averagePriceMax?: number;
  /** 最小平均客单价 */
  averagePriceMin?: number;
  /**
   * 签约状态 0-未签订、1-已签订
   * @format int32
   */
  brandAuthContractStatus?: number;
  /**
   * 品牌授权有效期结束时间
   * @format date-time
   */
  brandAuthPeriodEnd?: string;
  /**
   * 品牌授权有效期开始时间
   * @format date-time
   */
  brandAuthPeriodStart?: string;
  /**
   * 品牌授权状态 0未生效、1生效中、2已过期
   * @format int32
   */
  brandAuthStatus?: number;
  /** 品牌授权类型 0-普通授权、1-独家授权、2-简易贩卖授权 */
  brandAuthTypeList?: number[];
  /** 品牌理念(中文) */
  brandConceptCn?: string;
  /** 品牌理念(英文) */
  brandConceptEn?: string;
  /** 品牌理念(日文) */
  brandConceptJp?: string;
  /** 品牌理念(韩文) */
  brandConceptKr?: string;
  /**
   * 主键id
   * @format int64
   */
  brandId?: number;
  /** 品牌logo */
  brandLogo?: string;
  /** 品牌说明书(中文) */
  brandManualCn?: string;
  /** 品牌说明书(英文) */
  brandManualEn?: string;
  /** 品牌说明书(日文) */
  brandManualJp?: string;
  /** 品牌说明书(韩文) */
  brandManualKr?: string;
  /** 品牌名称 */
  brandName?: string;
  /**
   * 品牌发布状态 0草稿 1未发布 2已发布
   * @format int32
   */
  brandStatus?: number;
  /** 品牌风格 */
  brandStyleList?: BrandStyleRespDTO[];
  /**
   * 品牌类别 0:店铺 1:商品
   * @format int32
   */
  brandType?: number;
  /**
   * 是否可联名：0否 1是
   * @format int32
   */
  canJointName?: number;
  /** 市 */
  city?: string;
  /** 国家 */
  country?: string;
  /** 国家编码 */
  countryCode?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  creatorId?: string;
  creatorName?: string;
  /** 最大平均客单价(币种) */
  currencyAveragePriceMax?: number;
  /** 最小平均客单价(币种) */
  currencyAveragePriceMin?: number;
  /** 客户授权条件(中文) */
  customerAuthConditionCn?: string;
  /** 客户授权条件(英文) */
  customerAuthConditionEn?: string;
  /** 客户授权条件(日文) */
  customerAuthConditionJp?: string;
  /** 客户授权条件(韩文) */
  customerAuthConditionKr?: string;
  /** 客户授权类型 0普通授权 1独家授权 2不可授权 */
  customerAuthTypeList?: number[];
  /** 开拓人 */
  developPerson?: string;
  /**
   * 开拓方式
   * @format int32
   */
  developWay?: number;
  /** 展示的商品主图 */
  displayedProductImgList?: BrandDisplayedProductImgDTO[];
  editorId?: string;
  editorName?: string;
  /**
   * 是否删除：0未删除 1已删除
   * @format int32
   */
  isDeleted?: number;
  /** 主营客户端类目 */
  mainCategoryFrontList?: ProductCategoryFrontendRespDTO[];
  /** 主营类目 */
  mainCategoryIdList?: string[];
  /** 省 */
  province?: string;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/**
 * BrandManageQueryReqDTO
 * 品牌管理查询
 */
export interface BrandManageQueryReqDTO {
  /** 均价范围-最大平均客单价 */
  averagePriceMax?: number;
  /** 均价范围-最小平均客单价 */
  averagePriceMin?: number;
  /**
   * 签约状态 0-未签订、1-已签订
   * @format int32
   */
  brandAuthContractStatus?: number;
  /**
   * 品牌授权状态 0未生效、1生效中、2已过期
   * @format int32
   */
  brandAuthStatus?: number;
  /**
   * 品牌授权类型 0-普通授权、1-独家授权
   * @format int32
   */
  brandAuthType?: number;
  /** @format int64 */
  brandId?: number;
  brandIdList?: number[];
  /** 品牌名称 */
  brandName?: string;
  /**
   * 品牌发布状态 0草稿 1未发布 2已发布
   * @format int32
   */
  brandStatus?: number;
  /**
   * 品牌风格id
   * @format int64
   */
  brandStyleId?: number;
  /**
   * 品牌类型 0:店铺 1:商品
   * @format int32
   */
  brandType?: number;
  /** 国家 */
  country?: string;
  /**
   * 客户授权类型 0普通授权 1独家授权 2不可授权
   * @format int32
   */
  customerAuthType?: number;
  /** 主营类目 */
  mainCategoryId?: string;
  needQueryDeleted?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 来源平台 */
  platformType?: string;
  platformTypes?: string[];
  /** 店铺url */
  shopUrl?: string;
  /** @format int32 */
  startIndex?: number;
  /** @format int64 */
  superCustomerId?: number;
}

/**
 * BrandOperationReqDTO
 * 品牌操作
 */
export interface BrandOperationReqDTO {
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /** 是否查询店铺商品数量  false-不查询，true-查询 */
  queryShopGoodsNum?: boolean;
}

/**
 * BrandReqDTO
 * 品牌创建
 */
export interface BrandReqDTO {
  /** 最大平均客单价 */
  averagePriceMax?: number;
  /** 最小平均客单价 */
  averagePriceMin?: number;
  /**
   * 签约状态 0-未签订、1-已签订
   * @format int32
   */
  brandAuthContractStatus?: number;
  /**
   * 品牌授权有效期结束时间
   * @format date-time
   */
  brandAuthPeriodEnd?: string;
  /**
   * 品牌授权有效期开始时间
   * @format date-time
   */
  brandAuthPeriodStart?: string;
  /**
   * 品牌授权状态 0未生效、1生效中、2已过期
   * @format int32
   */
  brandAuthStatus?: number;
  /** 品牌授权类型 0-普通授权、1-独家授权、2-简易贩卖授权 */
  brandAuthTypeList?: number[];
  /** 品牌理念(中文) */
  brandConceptCn?: string;
  /** 品牌理念(英文) */
  brandConceptEn?: string;
  /** 品牌理念(日文) */
  brandConceptJp?: string;
  /** 品牌理念(韩文) */
  brandConceptKr?: string;
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /** 品牌logo */
  brandLogo?: string;
  /** 品牌说明书(中文) */
  brandManualCn?: string;
  /** 品牌说明书(英文) */
  brandManualEn?: string;
  /** 品牌说明书(日文) */
  brandManualJp?: string;
  /** 品牌说明书(韩文) */
  brandManualKr?: string;
  /** 品牌名称 */
  brandName?: string;
  /** 店铺列表 */
  brandShopList?: BrandShopReqDTO[];
  /**
   * 品牌发布状态 0草稿 1未发布 2已发布
   * @format int32
   */
  brandStatus?: number;
  /** 品牌风格 */
  brandStyleIdList?: number[];
  /**
   * 品牌类别 0:店铺 1:商品
   * @format int32
   */
  brandType?: number;
  /**
   * 是否可联名：0否 1是
   * @format int32
   */
  canJointName?: number;
  /** 市 */
  city?: string;
  /** 国家 */
  country?: string;
  creatorId?: string;
  creatorName?: string;
  /** 客户授权条件(中文) */
  customerAuthConditionCn?: string;
  /** 客户授权条件(英文) */
  customerAuthConditionEn?: string;
  /** 客户授权条件(日文) */
  customerAuthConditionJp?: string;
  /** 客户授权条件(韩文) */
  customerAuthConditionKr?: string;
  /** 客户授权类型 0普通授权 1独家授权 2不可授权 */
  customerAuthTypeList?: number[];
  /** 开拓人 */
  developPerson?: string;
  /**
   * 开拓方式
   * @format int32
   */
  developWay?: number;
  /** 展示的商品主图 */
  displayedProductImgList?: BrandDisplayedProductImgDTO[];
  editorId?: string;
  editorName?: string;
  /**
   * 是否删除：0未删除 1已删除
   * @format int32
   */
  isDeleted?: number;
  /** 主营类目 */
  mainCategoryIdList?: string[];
  /** 省 */
  province?: string;
}

/**
 * BrandSetInfoRespDTO
 * 客户端-品牌集查询
 */
export interface BrandSetInfoRespDTO {
  /**
   * 授权有效期结束时间
   * @format date-time
   */
  authEndTime?: string;
  /**
   * 授权有效期开始时间
   * @format date-time
   */
  authStartTime?: string;
  /** 授权书链接 */
  authUrl?: string;
  /** 最大平均客单价 */
  averagePriceMax?: number;
  /** 最小平均客单价 */
  averagePriceMin?: number;
  /** 品牌理念(中文) */
  brandConceptCn?: string;
  /** 品牌理念(英文) */
  brandConceptEn?: string;
  /** 品牌理念(日文) */
  brandConceptJp?: string;
  /** 品牌理念(韩文) */
  brandConceptKr?: string;
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /** 品牌logo */
  brandLogo?: string;
  /** 品牌说明书(中文) */
  brandManualCn?: string;
  /** 品牌说明书(英文) */
  brandManualEn?: string;
  /** 品牌说明书(日文) */
  brandManualJp?: string;
  /** 品牌说明书(韩文) */
  brandManualKr?: string;
  /** 品牌名称 */
  brandName?: string;
  /**
   * 品牌状态 0-草稿 1-未发布 2-已发布
   * @format int32
   */
  brandStatus?: number;
  /** 品牌风格 */
  brandStyleList?: BrandStyleRespDTO[];
  /**
   * 品牌类别 0:店铺 1:商品
   * @format int32
   */
  brandType?: number;
  /**
   * 是否可联名：0否 1是
   * @format int32
   */
  canJointName?: number;
  /** 市 */
  city?: string;
  /** 国家 */
  country?: string;
  /** 国家编码 */
  countryCode?: string;
  /** @format date-time */
  createTime?: string;
  /** 最大平均客单价(币种) */
  currencyAveragePriceMax?: number;
  /** 最小平均客单价 */
  currencyAveragePriceMin?: number;
  /** 客户授权条件(中文) */
  customerAuthConditionCn?: string;
  /** 客户授权条件(英文) */
  customerAuthConditionEn?: string;
  /** 客户授权条件(日文) */
  customerAuthConditionJp?: string;
  /** 客户授权条件(韩文) */
  customerAuthConditionKr?: string;
  /** 当前客户授权状态 */
  customerAuthStatus?: string;
  /** 客户授权类型 0普通授权 1独家授权 2不可授权 */
  customerAuthTypeList?: number[];
  /** 展示的商品主图 */
  displayedProductImgList?: BrandDisplayedProductImgDTO[];
  /** 是否收藏 */
  favorite?: boolean;
  /** 主营客户端类目 */
  mainCategoryFrontList?: ProductCategoryFrontendRespDTO[];
  /** 主营类目 */
  mainCategoryIdList?: string[];
  /** 省 */
  province?: string;
  /** @format date-time */
  updateTime?: string;
}

/**
 * BrandSetQueryReqDTO
 * 客户端-品牌集查询
 */
export interface BrandSetQueryReqDTO {
  /** 均价范围-最大平均客单价 */
  averagePriceMax?: number;
  /** 均价范围-最小平均客单价 */
  averagePriceMin?: number;
  /** @format int32 */
  brandAuthStatus?: number;
  /**
   * 品牌
   * @format int64
   */
  brandId?: number;
  brandIdList?: number[];
  /** @format int32 */
  brandStatus?: number;
  /**
   * 品牌风格
   * @format int64
   */
  brandStyleId?: number;
  country?: string;
  countryCode?: string;
  /**
   * 可授权形式 0普通授权 1独家授权 2不可授权
   * @format int32
   */
  customerAuthType?: number;
  /** @format int64 */
  customerId?: number;
  /** 主营类目 */
  mainCategoryId?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 采购市场(来源平台) */
  platformType?: string;
  /**
   * 商品前端类目ID
   * @format int64
   */
  productCategoryFrontendId?: number;
  /** @format int32 */
  startIndex?: number;
  /** 站点 */
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
}

/**
 * BrandSetSearchReqDTO
 * 客户端-品牌集搜索
 */
export interface BrandSetSearchReqDTO {
  /** 均价范围-最大平均客单价 */
  averagePriceMax?: number;
  /** 均价范围-最小平均客单价 */
  averagePriceMin?: number;
  /** @format int32 */
  brandAuthStatus?: number;
  /**
   * 品牌
   * @format int64
   */
  brandId?: number;
  brandIdList?: number[];
  /** @format int32 */
  brandStatus?: number;
  /**
   * 品牌风格
   * @format int64
   */
  brandStyleId?: number;
  country?: string;
  countryCode?: string;
  /**
   * 可授权形式 0普通授权 1独家授权 2不可授权
   * @format int32
   */
  customerAuthType?: number;
  /** @format int64 */
  customerId?: number;
  /** 关键字 */
  keyword?: string;
  /**
   * 语言
   * @format int32
   */
  langType?: number;
  /** 主营类目 */
  mainCategoryId?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 采购市场(来源平台) */
  platformType?: string;
  /**
   * 商品前端类目ID
   * @format int64
   */
  productCategoryFrontendId?: number;
  /** @format int32 */
  startIndex?: number;
  /** 站点 */
  stationCode?: string;
  /** @format int64 */
  superCustomerId?: number;
}

/**
 * BrandShopReqDTO
 * 品牌创建-店铺
 */
export interface BrandShopReqDTO {
  /** 品牌联系方式 */
  brandContactInfo?: string;
  /** 品牌联系人 */
  brandContactPerson?: string;
  /** 品牌折扣 */
  brandDiscount?: string;
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /**
   * 品牌名称
   * @format int64
   */
  brandShopId?: number;
  /** @format date-time */
  createTime?: string;
  /** 介绍人提点 */
  introducerRebate?: string;
  /**
   * 是否删除：0未删除 1已删除
   * @format int32
   */
  isDeleted?: number;
  /** 来源平台 */
  platformType?: string;
  /** 店铺code */
  shopCode?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 店铺url */
  shopUrl?: string;
  /** @format date-time */
  updateTime?: string;
}

/** BrandShopRespDTO */
export interface BrandShopRespDTO {
  /** 品牌联系方式 */
  brandContactInfo?: string;
  /** 品牌联系人 */
  brandContactPerson?: string;
  /** 品牌折扣 */
  brandDiscount?: string;
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /**
   * 品牌店铺id
   * @format int64
   */
  brandShopId?: number;
  /** @format date-time */
  createTime?: string;
  /**
   * 商品数量
   * @format int64
   */
  goodsNum?: number;
  /** 介绍人提点 */
  introducerRebate?: string;
  /**
   * 是否删除：0未删除 1已删除
   * @format int32
   */
  isDeleted?: number;
  /** 来源平台 */
  platformType?: string;
  /** 店铺code */
  shopCode?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 店铺url */
  shopUrl?: string;
  /** @format date-time */
  updateTime?: string;
}

/** BrandStyleReqDTO */
export interface BrandStyleReqDTO {
  /** @format int64 */
  creatorId?: number;
  /** @format int64 */
  editorId?: number;
  /** @format int64 */
  id?: number;
  /** 风格名称(中文) */
  nameCn?: string;
  /** 风格名称(英文) */
  nameEn?: string;
  /** 风格名称(日文) */
  nameJp?: string;
  /** 风格名称(韩文) */
  nameKr?: string;
}

/** BrandStyleRespDTO */
export interface BrandStyleRespDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /** 风格名称(中文) */
  nameCn?: string;
  /** 风格名称(英文) */
  nameEn?: string;
  /** 风格名称(日文) */
  nameJp?: string;
  /** 风格名称(韩文) */
  nameKr?: string;
}

/** CheckSearchAgreeVO */
export interface CheckSearchAgreeVO {
  /**
   * 是否满意 0-否 1-是
   * @format int32
   */
  agreeFlag?: number;
  /**
   * 类目id
   * @format int64
   */
  categoryId?: number;
  /** 不好的点 */
  comments?: string;
  /** 筛选项 */
  filters?: string;
  /** 关键词 */
  keyWords?: string;
  /**
   * 用户id
   * @format int64
   */
  superCustomerId?: number;
}

/** CountryQueryReqDTO */
export interface CountryQueryReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
}

/** CountryRespDTO */
export interface CountryRespDTO {
  /** 国家 */
  country?: string;
  /** 币种 */
  currency?: string;
}

/** CreateProductAtlasVO */
export interface CreateProductAtlasVO {
  /** 商品类目编码 */
  cateCode?: string;
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /** 跟进人id */
  followUserId?: string;
  /** 跟进人姓名 */
  followUserName?: string;
  /** 产品头图 */
  headerImage?: string;
  /** 标签列表 */
  labelIds?: number[];
  /**
   * 最小起订量（几手/几件）
   * @format int32
   */
  minOrderQuantity?: number;
  /**
   * 最小起订量类型 1-童装单sku，2-童装单spu，3-男女装单sku，4-男女装单spu，5-单件可拿
   * @format int32
   */
  minOrderType?: number;
  /**
   * 是否可混批 0-否 1-是
   * @format int32
   */
  mixBatchFlag?: number;
  /**
   * 来源 1-PC 2-H5
   * @format int32
   */
  platformType?: number;
  /** 平台商品SPU */
  productCode?: string;
  /** 产品描述 */
  productDesc?: string;
  /**
   * 产品描述类型 1-1688/TB，2-档口市场、线下渠道，3-品牌
   * @format int32
   */
  productDescType?: number;
  /** 产品图片（上限50张） */
  productImgs?: string[];
  /** 产品链接 */
  productLink?: string;
  /** 商品款号 */
  productNumber?: string;
  /** 商品价格区间 */
  productPrice?: AtlasProductPriceVO[];
  /**
   * 商品价格类型 1-单件，2-多件
   * @format int32
   */
  productPriceType?: number;
  /** 商品规格 */
  productSpece?: string;
  /** 供应商编码 */
  supplierCode?: string;
  /** 供应商名称 */
  supplierName?: string;
  /** 三方平台类型 YS：一手；XZ：四季星座；SE：生意网 */
  thirdPlatformType?: string;
  /** 一手平台唯一编码（一手专用） */
  uniqueCode?: string;
}

/** CreateShareLinkVO */
export interface CreateShareLinkVO {
  /** 产品图册编码列表 */
  atlasCode?: string[];
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /**
   * 分享人客户id
   * @format int64
   */
  customerId?: number;
  /** 分享人客户名称 */
  customerName?: string;
  /**
   * 分享人店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 分享人店铺名称 */
  customerShopName?: string;
  /**
   * 分享人主客户id
   * @format int64
   */
  mainCustomerId?: number;
  /** 备注 */
  remark?: string;
  /**
   * 分享人超级客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 系统来源 1-D2C 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 分享标题 */
  title?: string;
  /** 分享人统一客户全名 */
  unificationCustomerFullName?: string;
}

/** CustomerBehaviorProductPageReqDTO */
export interface CustomerBehaviorProductPageReqDTO {
  /** @format int32 */
  behaviorChannel?: number;
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerBehaviorProductRespDTO */
export interface CustomerBehaviorProductRespDTO {
  /** @format int32 */
  behaviorChannel?: number;
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * 渠道
   * @format int32
   */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  /** 商品销售价格-日元 */
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 店铺编码 */
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerBehaviorProductSaveReqDTO */
export interface CustomerBehaviorProductSaveReqDTO {
  /** @format int32 */
  behaviorChannel?: number;
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int64 */
  customerId?: number;
  productCode?: string;
}

/** CustomerBehaviorShopPageReqDTO */
export interface CustomerBehaviorShopPageReqDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerBehaviorShopRespDTO */
export interface CustomerBehaviorShopRespDTO {
  /** @format int32 */
  behaviorChannel?: number;
  /** @format int32 */
  behaviorFlag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  favoriteFlag?: number;
  platformType?: string;
  shopCode?: string;
  shopMainImg?: string;
  shopName?: string;
  shopUrl?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerBehaviorShopSaveReqDTO */
export interface CustomerBehaviorShopSaveReqDTO {
  /** @format int32 */
  behaviorChannel?: number;
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int64 */
  customerId?: number;
  shopCode?: string;
}

/** CustomerBoughtProductReqDTO */
export interface CustomerBoughtProductReqDTO {
  /** 国家：例如CN（中国）KR（韩国） */
  country?: string;
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerBoughtProductRespDTO */
export interface CustomerBoughtProductRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /** @format int32 */
  carefullySelected?: number;
  /** @format int32 */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /** @format int32 */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productSellQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  shopName?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerBoughtShopReqDTO */
export interface CustomerBoughtShopReqDTO {
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerBoughtShopRespDTO */
export interface CustomerBoughtShopRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  favoriteFlag?: number;
  platformType?: string;
  shopCode?: string;
  shopMainImg?: string;
  shopMajorCateCode?: string;
  shopMajorCateName?: string;
  shopName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerBrandAuthApplyAuditQueryRespDTO */
export interface CustomerBrandAuthApplyAuditQueryRespDTO {
  /** 操作后状态 */
  afterStatus?: string;
  /** @format int64 */
  applyId?: number;
  /** @format int32 */
  auditFlow?: number;
  /**
   * 时间
   * @format date-time
   */
  auditTime?: string;
  /** @format date-time */
  authEndTime?: string;
  /** @format date-time */
  authStartTime?: string;
  /** 授权书链接 */
  authUrl?: string;
  /** @format int32 */
  brandAuthType?: number;
  /** 内容 */
  content?: string;
  currency?: string;
  discount?: string;
  /** 操作人 */
  editorName?: string;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isAgree?: number;
  remark?: string;
}

/** CustomerBrandAuthApplyQueryFrontRespDTO */
export interface CustomerBrandAuthApplyQueryFrontRespDTO {
  /**
   * 申请id
   * @format int64
   */
  applyId?: number;
  /** 申请状态 */
  applyStatus?: string;
  /**
   * 申请日期
   * @format date-time
   */
  applyTime?: string;
  /** 审核状态 */
  auditStatus?: string;
  /**
   * 授权有效期结束时间
   * @format date-time
   */
  authEndTime?: string;
  /**
   * 授权有效期开始时间
   * @format date-time
   */
  authStartTime?: string;
  authTime?: string;
  /** 授权书链接 */
  authUrl?: string;
  /**
   * 申请授权类型
   * @format int32
   */
  brandAuthType?: number;
  /**
   * 品牌ID
   * @format int64
   */
  brandId?: number;
  /** 品牌名称 */
  brandName?: string;
  /** 店铺URL */
  brandShopUrlList?: string[];
  /** 品牌URL */
  brandUrl?: string;
  /**
   * 是否需要联名
   * @format int32
   */
  canJoint?: number;
  /** 用途 */
  content?: string;
  /** 国家 */
  country?: string;
  /** 统一客户全名 */
  customerName?: string;
  /** @format int64 */
  id?: number;
  /** 品牌是否有效 true:有效,品牌存在 false:失效,品牌不存在 */
  invalidBrand?: boolean;
  /** 联名品牌 */
  jointBrand?: string;
  /** 联名需求描述 */
  jointContent?: string;
  /** 品牌主图 */
  mainImgUrl?: string;
  /** 客户等级名称 */
  membershipTemplateName?: string;
  /** 预计月采购额 */
  planMonthPurAmt?: number;
  /** 预计年采购额 */
  planYearPurAmt?: number;
  /** 平台链接 */
  platformUrl?: string;
  /** 其他补充说明 */
  remark?: string;
  /** 销售平台 */
  salePlatform?: string;
  /**
   * 客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** CustomerBrandAuthApplyQueryReqDTO */
export interface CustomerBrandAuthApplyQueryReqDTO {
  /**
   * 申请日期结束时间
   * @format date-time
   */
  applyEndTime?: string;
  /**
   * 申请日期开始时间
   * @format date-time
   */
  applyStartTime?: string;
  /** 申请状态 WAIT待提交 AUDIT审核中 SUCCESS已授权 CANCEL已取消 REJECT已拒绝 OVERDUE已过期 */
  applyStatus?: string;
  /**
   * 审核节点 用于区别初审终审页面 1:初审 2:终审
   * @format int32
   */
  auditFlow?: number;
  /** 审核状态 WAIT待审核 SUCCESS审核通过 REJECT审核拒绝 */
  auditStatus?: string;
  /**
   * 申请授权类型 0普通授权 1独家授权
   * @format int32
   */
  brandAuthType?: number;
  /** 品牌名称 */
  brandName?: string;
  /** 客户名称 */
  customerName?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  /** 站点 日本:JapanStation 韩国KoreaStation 英国UkStation */
  station?: string;
  /**
   * 客户号
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 系统来源 1:d2c,2:b2b
   * @format int32
   */
  systemSource?: number;
}

/** CustomerBrandAuthApplyQueryRespDTO */
export interface CustomerBrandAuthApplyQueryRespDTO {
  /**
   * 申请id
   * @format int64
   */
  applyId?: number;
  /** 申请状态 */
  applyStatus?: string;
  /**
   * 申请日期
   * @format date-time
   */
  applyTime?: string;
  /** 审核状态 */
  auditStatus?: string;
  /**
   * 授权有效期结束时间
   * @format date-time
   */
  authEndTime?: string;
  /**
   * 授权有效期开始时间
   * @format date-time
   */
  authStartTime?: string;
  authTime?: string;
  /** 授权书链接 */
  authUrl?: string;
  /**
   * 申请授权类型
   * @format int32
   */
  brandAuthType?: number;
  /** 品牌信息 */
  brandInfo?: BrandManageInfoRespDTO;
  /** 品牌名称 */
  brandName?: string;
  /** 品牌URL */
  brandUrl?: string;
  /**
   * 是否需要联名
   * @format int32
   */
  canJoint?: number;
  /** 用途 */
  content?: string;
  /** 统一客户全名 */
  customerName?: string;
  /** @format int64 */
  id?: number;
  /** 品牌是否有效 true:有效,品牌存在 false:失效,品牌不存在 */
  invalidBrand?: boolean;
  /** 联名品牌 */
  jointBrand?: string;
  /** 联名需求描述 */
  jointContent?: string;
  /** 客户等级名称 */
  membershipTemplateName?: string;
  /** 预计月采购额 */
  planMonthPurAmt?: number;
  /** 预计年采购额 */
  planYearPurAmt?: number;
  /** 平台链接 */
  platformUrl?: string;
  /** 其他补充说明 */
  remark?: string;
  /** 销售平台 */
  salePlatform?: string;
  /**
   * 客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** CustomerBrandAuthApplyReqDTO */
export interface CustomerBrandAuthApplyReqDTO {
  /** @format int64 */
  applyId?: number;
  /**
   * 申请授权类型 0普通授权 1独家授权
   * @format int32
   */
  brandAuthType?: number;
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /**
   * 是否需要联名
   * @format int32
   */
  canJoint?: number;
  /** 用途 */
  content?: string;
  /** @format int64 */
  customerId?: number;
  /** 联名品牌 */
  jointBrand?: string;
  /** 联名需求描述 */
  jointContent?: string;
  /** @format int64 */
  mainCustomerId?: number;
  /** 预计月采购额 */
  planMonthPurAmt?: number;
  /** 预计年采购额 */
  planYearPurAmt?: number;
  /** 平台链接 */
  platformUrl?: string;
  /** 其他补充说明 */
  remark?: string;
  /** 销售平台 */
  salePlatform?: string;
  /** 站点 日本:JapanStation 韩国KoreaStation 英国UkStation */
  station?: string;
  /** 是否提交 保存不提交:false 保存并提交时:true) */
  submit?: boolean;
  /**
   * 客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 系统来源 1:d2c,2:b2b
   * @format int32
   */
  systemSource?: number;
}

/** CustomerBrandAuthApplyStatisticRespDTO */
export interface CustomerBrandAuthApplyStatisticRespDTO {
  /** @format int64 */
  auditCount?: number;
  /** @format int64 */
  cancelCount?: number;
  /** @format int64 */
  overdueCount?: number;
  /** @format int64 */
  rejectCount?: number;
  /** @format int64 */
  successCount?: number;
  /** @format int64 */
  totalCount?: number;
  /** @format int64 */
  waitCount?: number;
}

/** CustomerBrandAuthAuditReqDTO */
export interface CustomerBrandAuthAuditReqDTO {
  /**
   * 申请id
   * @format int64
   */
  applyId?: number;
  /**
   * 授权结束时间
   * @format date-time
   */
  authEndTime?: string;
  /**
   * 授权开始时间
   * @format date-time
   */
  authStartTime?: string;
  /** 授权链接 */
  authUrl?: string;
  /**
   * 申请授权类型 0普通授权 1独家授权
   * @format int32
   */
  brandAuthType?: number;
  /** @format int64 */
  creatorId?: number;
  creatorName?: string;
  /** 币种 （非中国品牌审核过程，人工可以选择） */
  currency?: string;
  /** 客户折扣 */
  discount?: string;
  /**
   * 审核意见 通过1 不通过0
   * @format int32
   */
  isAgree?: number;
  /** 审核备注 */
  remark?: string;
}

/** CustomerFavoriteBrandReqDTO */
export interface CustomerFavoriteBrandReqDTO {
  /**
   * 店铺编码
   * @format int64
   */
  brandId?: number;
  /** 店铺编码列表 */
  brandIdList?: number[];
  /** 国家：例如中国(CN),韩国(KR) */
  country?: string;
  /**
   * 客户ID; 不传
   * @format int64
   */
  customerId?: number;
  /** 降序 */
  descendOrder?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 排序字段; 默认收藏时间 */
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
}

/** CustomerFavoriteBrandRespDTO */
export interface CustomerFavoriteBrandRespDTO {
  /**
   * 收藏品牌ID
   * @format int64
   */
  brandId?: number;
  /** 品牌logo */
  brandLogo?: string;
  /** 品牌主图 */
  brandMainImg?: string;
  /** 品牌名称 */
  brandName?: string;
  /** 品牌风格 */
  brandStyle?: object[];
  /** 国家 */
  country?: string;
  /** 国家编码 */
  countryCode?: string;
  /** 主营类目 */
  mainCategory?: object[];
}

/** CustomerFavoriteProductReqDTO */
export interface CustomerFavoriteProductReqDTO {
  cateCodeList?: string[];
  /** 国家：例如CN（中国）KR（韩国） */
  country?: string;
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  filterBlackTag?: boolean;
  filterCombinationProduct?: boolean;
  filterNotIsOnline?: boolean;
  filterOemProduct?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  priceEnd?: number;
  priceStart?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  productCode?: string;
  productCodeList?: string[];
  productDetailUrl?: string;
  productTitle?: string;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerFavoriteProductRespDTO */
export interface CustomerFavoriteProductRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /** @format int32 */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /** @format int64 */
  customerFavoriteProductId?: number;
  /** @format int32 */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  /**
   * 1-上架;0-下架;
   * @format int32
   */
  isOnline?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productSellQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  shopName?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerFavoriteShopReqDTO */
export interface CustomerFavoriteShopReqDTO {
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  shopCode?: string;
  shopCodeList?: string[];
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
}

/** CustomerFavoriteShopRespDTO */
export interface CustomerFavoriteShopRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  customerFavoriteShopId?: number;
  /** @format int32 */
  favoriteFlag?: number;
  platformType?: string;
  shopCode?: string;
  shopMainImg?: string;
  shopMajorCateCode?: string;
  shopMajorCateName?: string;
  shopName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerFocusProduct */
export interface CustomerFocusProduct {
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /**
   * 是否删除
   * @format int32
   */
  isDelete?: number;
  /**
   * 价格变动是否提醒
   * @format int32
   */
  isNotify?: number;
  /**
   * 是否上下架,0下架,1上架
   * @format int32
   */
  isOnline?: number;
  /** 最新商品价格 */
  latestProductSellPrice?: number;
  /** 平台类型 */
  platformType?: string;
  /** 商品编码 */
  productCode?: string;
  /** 商品url */
  productDetailUrl?: string;
  /** 商品主图 */
  productMainImg?: string;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品标题 */
  productTitle?: string;
  /**
   * 客户ID
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** CustomerFocusProductPrice */
export interface CustomerFocusProductPrice {
  /** @format int64 */
  createTime?: number;
  /** @format int32 */
  isDelete?: number;
  /** @format int32 */
  isOnline?: number;
  productCode?: string;
  productSellPrice?: number;
  time?: string;
  /** @format int64 */
  updateTime?: number;
}

/** CustomerFocusProductRespDTO */
export interface CustomerFocusProductRespDTO {
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /**
   * 是否删除
   * @format int32
   */
  isDelete?: number;
  /**
   * 是否较关注时价格降低
   * @format int32
   */
  isLow?: number;
  /**
   * 价格变动是否提醒
   * @format int32
   */
  isNotify?: number;
  /**
   * 是否上下架,0下架,1上架
   * @format int32
   */
  isOnline?: number;
  /** 最新商品价格 */
  latestProductSellPrice?: number;
  /** 平台类型 */
  platformType?: string;
  /** 商品编码 */
  productCode?: string;
  /** 商品url */
  productDetailUrl?: string;
  /** 商品主图 */
  productMainImg?: string;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品标题 */
  productTitle?: string;
  /**
   * 客户ID
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** CustomerFootprintProductPluginSaveReqDTO */
export interface CustomerFootprintProductPluginSaveReqDTO {
  /** @format int64 */
  customerId?: number;
  platformType?: string;
  productDetailUrl?: string;
}

/** CustomerFootprintProductReqDTO */
export interface CustomerFootprintProductReqDTO {
  /** 国家：例如CN（中国）KR（韩国） */
  country?: string;
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  filterCombinationProduct?: boolean;
  filterOemProduct?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerFootprintProductRespDTO */
export interface CustomerFootprintProductRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * ckb严选
   * @format int32
   */
  carefullySelected?: number;
  /** @format int32 */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /** @format int32 */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productSellQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  shopName?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerFootprintShopReqDTO */
export interface CustomerFootprintShopReqDTO {
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerFootprintShopRespDTO */
export interface CustomerFootprintShopRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  country?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  favoriteFlag?: number;
  platformType?: string;
  shopCode?: string;
  shopMainImg?: string;
  shopMajorCateCode?: string;
  shopMajorCateName?: string;
  shopName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerHomeFastCategoryRespDTO */
export interface CustomerHomeFastCategoryRespDTO {
  /** @format int32 */
  channel?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** @format int32 */
  sort?: number;
}

/** CustomerInfo */
export interface CustomerInfo {
  /**
   * 用户主键
   * @format int64
   */
  customerId?: number;
  /** 用户名称 */
  customerName?: string;
}

/** CustomerSearchKeywordHotRespDTO */
export interface CustomerSearchKeywordHotRespDTO {
  cateIcon?: string;
  cateNameEn?: string;
  cateNameJp?: string;
  cateNameKr?: string;
  cateNameZh?: string;
  keywordList?: string[];
  /** @format int64 */
  productCategoryFrontendId?: number;
}

/** CustomerStrategyProductReqDTO */
export interface CustomerStrategyProductReqDTO {
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** CustomerStrategyProductRespDTO */
export interface CustomerStrategyProductRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /** @format int32 */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /** @format int32 */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productSellQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  shopName?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** @format date-time */
  updateTime?: string;
}

/** CustomerStrategyShopRespDTO */
export interface CustomerStrategyShopRespDTO {
  shopInfoList?: ShopInfo[];
  shopType?: string;
}

/** DirectImageSearchReqDTO */
export interface DirectImageSearchReqDTO {
  descendOrder?: boolean;
  imageId?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sellPriceEnd?: number;
  sellPriceStart?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
}

/** DiscountInfoUpdateDTO */
export interface DiscountInfoUpdateDTO {
  /**
   * 让利折扣比例:%
   * @format double
   */
  discount?: number;
  /** sku */
  productSku?: string;
  /** 优惠方式:1-改价,2-返金 */
  promotionMethod?: string;
  /** 优惠方式:1-立减,2-折扣 */
  promotionType?: string;
  /** 立减金额 */
  reductionAmount?: string;
}

/** DiscountInfoUpdateVO */
export interface DiscountInfoUpdateVO {
  /**
   * 让利折扣比例:%
   * @format double
   */
  discount?: number;
  /** sku列表 */
  productSkuList?: string[];
  /** 优惠方式:1-改价,2-返金 */
  promotionMethod?: string;
  /** 优惠方式:1-立减,2-折扣 */
  promotionType?: string;
  /** 立减金额 */
  reductionAmount?: string;
}

/**
 * EditMarketAreaReqDTO
 * 修改运营专区请求
 */
export interface EditMarketAreaReqDTO {
  /** 专区描述 */
  areaDesc?: string;
  /** 专区图片 */
  areaImage?: string;
  /** 专区名称 */
  areaName?: string;
  /** 线索信息 */
  detailReqDTOS?: AddMarketAreaDetailReqDTO[];
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  /** 站点 */
  stationCode?: string;
  /**
   * 状态 0:关闭 1:开启
   * @format int32
   */
  status?: number;
  /** 线索运营标签集合 */
  tagCodes?: string[];
}

/** EditProductAtlasVO */
export interface EditProductAtlasVO {
  /** 图册编码 */
  atlasCode?: string;
  /** 商品类目编码 */
  cateCode?: string;
  /** 编辑人姓名 */
  editorName?: string;
  /** 跟进人id */
  followUserId?: string;
  /** 跟进人姓名 */
  followUserName?: string;
  /** 产品头图 */
  headerImage?: string;
  /**
   * 主键id
   * @format int64
   */
  id?: number;
  /** 标签列表 */
  labelIds?: number[];
  /**
   * 最小起订量（几手/几件）
   * @format int32
   */
  minOrderQuantity?: number;
  /**
   * 最小起订量类型 1-童装单sku，2-童装单spu，3-男女装单sku，4-男女装单spu，5-单件可拿
   * @format int32
   */
  minOrderType?: number;
  /**
   * 是否可混批 0-否 1-是
   * @format int32
   */
  mixBatchFlag?: number;
  /**
   * 来源 1-PC 2-H5
   * @format int32
   */
  platformType?: number;
  /** 平台商品SPU */
  productCode?: string;
  /** 产品描述 */
  productDesc?: string;
  /**
   * 产品描述类型 1-1688/TB，2-档口市场、线下渠道，3-品牌
   * @format int32
   */
  productDescType?: number;
  /** 产品图片（上限50张） */
  productImgs?: string[];
  /** 产品链接 */
  productLink?: string;
  /** 商品款号 */
  productNumber?: string;
  /** 商品价格区间 */
  productPrice?: AtlasProductPriceVO[];
  /**
   * 商品价格类型 1-单件，2-多件
   * @format int32
   */
  productPriceType?: number;
  /** 商品规格 */
  productSpece?: string;
  /** 供应商编码 */
  supplierCode?: string;
  /** 供应商名称 */
  supplierName?: string;
  /** 三方平台类型 YS：一手；XZ：四季星座；SE：生意网 */
  thirdPlatformType?: string;
}

/**
 * EditProductExtendReqDTO
 * 修改请求
 */
export interface EditProductExtendReqDTO {
  /**
   * 高
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长
   * @format double
   */
  maintainLength?: number;
  /**
   * 重量
   * @format int64
   */
  maintainWeight?: number;
  /**
   *  宽
   * @format double
   */
  maintainWidth?: number;
  /** 商品属性 */
  productAttribute?: string;
  /** 商品属性 */
  productAttributeList?: ProductPropDto[];
  /** 商品编码 */
  productCode?: string;
  /** 详情图 */
  productDescImgs?: string;
  /** 详情图列表 */
  productDescImgsList?: string[];
  /** 轮播图 */
  productImageUrl?: string;
  /** 轮播图列表 */
  productImageUrlList?: string[];
  /** 商品名称 */
  productName?: string;
  /** 规格信息 */
  productSku?: string;
  /** 商品sku属性中文 */
  propsList?: ProductPropGroupDTO[];
  /** 商品sku属性日文 */
  propsSkuList?: ProductPropGroupDTO[];
  /** sourceCode */
  sourceCode?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
}

/**
 * EditSourceCategoryReqDTO
 * 修改请求
 */
export interface EditSourceCategoryReqDTO {
  /** 类目图片 */
  categoryImage?: string;
  /** 类目中文名称 */
  categoryName?: string;
  /** 类目英文名称 */
  categoryNameEn?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /**
   * 状态
   * @format int32
   */
  status?: number;
}

/**
 * EditSourceReqDTO
 * 修改请求
 */
export interface EditSourceReqDTO {
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * 上架时间
   * @format date-time
   */
  onLineTime?: string;
  /** 价格（美金） */
  price?: number;
  /** 商品图片 */
  productImg?: string;
  /** 商品名称 */
  productName?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 商品分类 */
  sourceCategory?: string;
  /** 线索链接 */
  sourceUrl?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 线索标签id */
  tagCodes?: string[];
}

/** EngineResult */
export interface EngineResult {
  /** @format int32 */
  code?: number;
  data?: object;
  message?: string;
}

/** File */
export interface File {
  absolute?: boolean;
  absoluteFile?: File;
  absolutePath?: string;
  canonicalFile?: File;
  canonicalPath?: string;
  directory?: boolean;
  executable?: boolean;
  file?: boolean;
  /** @format int64 */
  freeSpace?: number;
  hidden?: boolean;
  /** @format int64 */
  lastModified?: number;
  name?: string;
  parent?: string;
  parentFile?: File;
  path?: string;
  readable?: boolean;
  /** @format int64 */
  totalSpace?: number;
  /** @format int64 */
  usableSpace?: number;
  writable?: boolean;
}

/** GoodsMaterialJoinDTO */
export interface GoodsMaterialJoinDTO {
  instr?: string;
  materialJoinStr?: string;
  oldDataFlag?: boolean;
}

/** HandlerServiceMeta */
export interface HandlerServiceMeta {
  aliasName?: string;
  className?: string;
  desc?: string;
  /** @format int64 */
  registerTime?: number;
  version?: string;
}

/** ISortFieldEnum */
export interface ISortFieldEnum {
  asc?: boolean;
  field?: string;
}

/** ImageAddNumReqDTO */
export interface ImageAddNumReqDTO {
  /** 商品编码 */
  productCode?: string;
}

/** ImageSearchReqDTO */
export interface ImageSearchReqDTO {
  /** 降序 */
  descendOrder?: boolean;
  /** 筛选项，多个choiceKey根据逗号分隔 */
  filters?: string;
  /** 图片地址 */
  imageAddress?: string;
  /** 图片id */
  imageId?: string;
  /** 图片地址 */
  imageUrl?: string;
  isOnePsale?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * 商品标签 1 精选货源
   * @format int32
   */
  productTag?: number;
  /** 结束销售价 */
  sellPriceEnd?: number;
  /** 起始销售价 */
  sellPriceStart?: number;
  /** 排序字段; (默认)更新时间: update_time; 销量: product_sell_quantity; 价格: product_sell_price; */
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  /** 站点code */
  stationCode?: string;
}

/** ImageTranslateRespDTO */
export interface ImageTranslateRespDTO {
  /** description */
  description?: string;
  /** descriptionEn */
  descriptionEn?: string;
  /** descriptionKo */
  descriptionKo?: string;
  /** descriptionZh */
  descriptionZh?: string;
  /** keywords */
  keywords?: string;
  /** keywordsEn */
  keywordsEn?: string;
  /** keywordsKo */
  keywordsKo?: string;
  /** keywordsZh */
  keywordsZh?: string;
  /** title */
  title?: string;
  /** titleEn */
  titleEn?: string;
  /** titleKo */
  titleKo?: string;
  /** titleZh */
  titleZh?: string;
}

/** ImageUploadReqDTO */
export interface ImageUploadReqDTO {
  /** 图片base64 */
  imageBase64?: string;
  /** 图片url 当拿不到图片时，传url */
  imageUrl?: string;
}

/** InputStream */
export type InputStream = object;

/**
 * InvalidateSourceReqDTO
 * 废弃
 */
export interface InvalidateSourceReqDTO {
  /** @format int64 */
  id?: number;
  /**
   * 废弃原因
   * @format int32
   */
  invalidateReason?: number;
}

/** KeyWordSearchReqDTO */
export interface KeyWordSearchReqDTO {
  /**
   * 页码
   * @format int32
   */
  beginPage?: number;
  /**
   * 类目ID
   * @format int64
   */
  categoryId?: number;
  /** 国别 */
  country?: string;
  /** 筛选字段，逗号分隔 */
  filter?: string;
  /** 关键词 */
  keyword?: string;
  /** 会员ID */
  outMemberId?: string;
  /**
   * 页大小
   * @format int32
   */
  pageSize?: number;
  /** 价格区间-结束 */
  priceEnd?: string;
  /** 价格区间-开始 */
  priceStart?: string;
  /** 排序 */
  sort?: string;
}

/** LiveSellPriceReq */
export interface LiveSellPriceReq {
  /** 直播销售价 */
  liveSellPrice?: number;
  /**
   * 直播销售价有效结束时间
   * @format date-time
   */
  liveSellPriceEndTime?: string;
  /**
   * 直播销售价有效开始时间
   * @format date-time
   */
  liveSellPriceStartTime?: string;
  /** 商品sku */
  productSku?: string;
}

/** LiveSellPriceTimeReq */
export interface LiveSellPriceTimeReq {
  /**
   * 直播销售价有效结束时间
   * @format date-time
   */
  liveSellPriceEndTime?: string;
  /**
   * 直播销售价有效开始时间
   * @format date-time
   */
  liveSellPriceStartTime?: string;
  /** 商品skuList */
  productSkuList?: string[];
}

/** MallAreaProductDTO */
export interface MallAreaProductDTO {
  /** 标签编码 */
  area_code?: string;
  /** 上次更新版本号 */
  last_version_number?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platform_type?: string;
  /** 商品编码 */
  product_code_list?: string[];
  /** 版本号 */
  version_number?: string;
}

/** MallCategoryFormReqDTO */
export interface MallCategoryFormReqDTO {
  /** @format int64 */
  mallCategoryId?: number;
  mallCategoryNameJp?: string;
  productCategoryFrontendIdList?: number[];
}

/** MallCategoryPageReqDTO */
export interface MallCategoryPageReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** MallCategoryProductDTO */
export interface MallCategoryProductDTO {
  /** 标签编码 */
  cate_code?: string;
  /** 上次更新版本号 */
  last_version_number?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platform_type?: string;
  /** 商品 */
  product_list?: MallCategoryProductItemDTO[];
  /** 版本号 */
  version_number?: string;
}

/** MallCategoryProductItemDTO */
export interface MallCategoryProductItemDTO {
  /** 商品编码 */
  product_code?: string;
  /** 商品主图 */
  product_main_img_url?: string;
  /** 商品价格 */
  product_sell_price?: number;
  /** 商品标题 */
  product_title?: string;
  /** 排名 */
  sort?: string;
}

/** MallCategoryReqDTO */
export interface MallCategoryReqDTO {
  /** @format int32 */
  deleteFlag?: number;
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** MallCategoryRespDTO */
export interface MallCategoryRespDTO {
  mallCategoryCode?: string;
  /** @format int64 */
  mallCategoryId?: number;
  mallCategoryNameEn?: string;
  mallCategoryNameJp?: string;
  mallCategoryNameKr?: string;
  mallCategoryNameZh?: string;
  manageBannerList?: ManageBannerRespDTO[];
  productCategoryFrontendList?: ProductCategoryFrontendRespDTO[];
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** MallDoorFormReqDTO */
export interface MallDoorFormReqDTO {
  marketCode?: string;
  shopCode?: string;
  shopDoor?: string;
  shopFloor?: string;
  shopMall?: string;
}

/** MallMarketAreaRespDTO */
export interface MallMarketAreaRespDTO {
  /** 板块标签编码 */
  areaCode?: string;
  /** 板块名称 */
  areaName?: string;
  /** 板块名称英文 */
  areaNameEn?: string;
  /** 板块名称日文 */
  areaNameJp?: string;
  /** 板块名称韩文 */
  areaNameKo?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platformType?: string;
}

/** MallMarketCategoryDTO */
export interface MallMarketCategoryDTO {
  /** 类目编码 */
  cate_code?: string;
  /** 类目名称 */
  cate_name?: string;
  /** 类目名称英文 */
  cate_name_en?: string;
  /** 类目名称日文 */
  cate_name_jp?: string;
  /** 类目名称韩文 */
  cate_name_ko?: string;
  /**
   * 类目等级:1或者2
   * @format int32
   */
  level?: number;
  /** 父级类目编码 */
  parent_cate_code?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platform_type?: string;
  /** 版本号(例如20240606) */
  version_number?: string;
}

/** MallMarketCategoryPageReqDTO */
export interface MallMarketCategoryPageReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 父级类目编码 */
  parentCateCode?: string;
  /** @format int32 */
  startIndex?: number;
  /** 版本号 */
  versionNumber?: string;
}

/** MallMarketCategoryProductRespDTO */
export interface MallMarketCategoryProductRespDTO {
  /** 营销类目编码 */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品编码 */
  productCode?: string;
  /** 商品主图 */
  productMainImgUrl?: string;
  /** 商品价格 */
  productPrice?: number;
  /** 商品标题 */
  productTitle?: string;
  /**
   * 排序值
   * @format int32
   */
  sort?: number;
}

/** MallMarketCategoryRespDTO */
export interface MallMarketCategoryRespDTO {
  /** 类目编码 */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  /** 类目名称英文 */
  cateNameEn?: string;
  /** 类目名称日文 */
  cateNameJp?: string;
  /** 类目名称韩文 */
  cateNameKo?: string;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** 父级类目编码 */
  parentCateCode?: string;
  /** 平台类型;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 二级类目独有的商品信息 */
  productRespDTOS?: MallMarketCategoryProductRespDTO[];
  /**
   * 自定义排序
   * @format int32
   */
  sort?: number;
  /** 子类目信息 */
  subCategoryList?: MallMarketCategoryRespDTO[];
}

/** ManageBannerRespDTO */
export interface ManageBannerRespDTO {
  /** @format int64 */
  bannerApplicableTemplateId?: number;
  bannerApplicableTemplateName?: string;
  /** @format int32 */
  bannerClickNum?: number;
  bannerDesignatedUserId?: string;
  /** @format int64 */
  bannerId?: number;
  bannerImgUrl?: string;
  bannerJumpLink?: string;
  bannerName?: string;
  /** @format int32 */
  bannerStatus?: number;
  /** @format int32 */
  bannerUserClickNum?: number;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  mallCategoryId?: number;
  /** @format date-time */
  startTime?: string;
  /** @format int32 */
  systemSource?: number;
}

/**
 * MarketAreaDetailQuery
 * 查询
 */
export interface MarketAreaDetailQuery {
  /**
   * 专区id
   * @format int64
   */
  marketAreaId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 结束销售价 */
  sellPriceEnd?: number;
  /** 起始销售价 */
  sellPriceStart?: number;
  /** 排序规则：正序-asc 倒序-desc；默认倒序 */
  sort?: string;
  /**
   * 排序类型 销量-1; 价格-2
   * @format int32
   */
  sortType?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
}

/** MarketAreaPO */
export interface MarketAreaPO {
  areaDesc?: string;
  areaImage?: string;
  areaName?: string;
  /** @format date-time */
  createTime?: string;
  /** @format int64 */
  creatorId?: number;
  /** @format int64 */
  editorId?: number;
  /** @format date-time */
  endTime?: string;
  /** @format int64 */
  id?: number;
  /** @format int32 */
  isDeleted?: number;
  /** @format int32 */
  sort?: number;
  sourceTags?: string;
  /** @format date-time */
  startTime?: string;
  stationCode?: string;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/**
 * MarketAreaQuery
 * 查询
 */
export interface MarketAreaQuery {
  /** 专区名称 */
  areaName?: string;
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  /**
   * 状态 0:关闭 1:开启
   * @format int32
   */
  status?: number;
}

/**
 * MarketAreaRespDTO
 * 响应结果
 */
export interface MarketAreaRespDTO {
  /** 专区描述 */
  areaDesc?: string;
  /** 专区图片 */
  areaImage?: string;
  /** 专区名称 */
  areaName?: string;
  /** 线索信息 */
  detailReqDTOS?: SourceRespDTO[];
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /** @format int64 */
  id?: number;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  sourceTagRespDTO?: SourceTagRespDTO[];
  /** 线索运营标签 */
  sourceTags?: string;
  /**
   * 线索数据时间
   * @format date-time
   */
  sourceTime?: string;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  /** 站点 */
  stationCode?: string;
  /**
   * 状态 0:关闭 1:开启
   * @format int32
   */
  status?: number;
}

/** MaterialDTO */
export interface MaterialDTO {
  content?: string;
  name?: string;
  /** @format int32 */
  percentFlag?: number;
}

/** MaterialInfoUpdateVO */
export interface MaterialInfoUpdateVO {
  /** 材质英文 */
  materialInfoEn?: string;
  /** 材质信息日文 */
  materialInfoJa?: string;
  /** 材质韩文 */
  materialInfoKr?: string;
  /** 材质信息中文 */
  materialInfoZh?: string;
  /** sku */
  productSku?: string;
  /** sku列表 */
  productSkuList?: string[];
  /** 站点code */
  stationCode?: string;
}

/** MaterialParseReqDTO */
export interface MaterialParseReqDTO {
  /** 中文材质 */
  materialZh?: string;
  /** 平台类型 */
  platformType?: string;
  /** 第三方平台类目代码（最底层） */
  thirdCateCode?: string;
}

/** MaterialQueryReqDTO */
export interface MaterialQueryReqDTO {
  /** 三级类目 */
  cateCode?: string;
  /** 完整标识（对应材质日，英，韩都存在） */
  completionFlag?: boolean;
  /** 韩文材质 */
  materialJp?: string;
  /** 韩文材质 */
  materialKr?: string;
  /** 中文材质 */
  materialZh?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * 限制百分比标识 1:百分比,0:非百分比
   * @format int32
   */
  percentFlag?: number;
  /** @format int32 */
  startIndex?: number;
}

/** MaterialReqDTO */
export interface MaterialReqDTO {
  /**
   * 唯一id
   * @format int32
   */
  id?: number;
  /** 日文材质 */
  materialJp?: string;
  /** 韩文材质 */
  materialKr?: string;
  /** 英文材质 */
  materialUk?: string;
  /** 中文材质 */
  materialZh?: string;
  /**
   * 百分比限制 0:否 1：是
   * @format int32
   */
  percentFlag?: number;
}

/** MaterialRespDTO */
export interface MaterialRespDTO {
  /**
   * 唯一id
   * @format int32
   */
  id?: number;
  /** 日文材质 */
  materialJp?: string;
  /** 韩文材质 */
  materialKr?: string;
  /** 英文材质 */
  materialUk?: string;
  /** 中文材质 */
  materialZh?: string;
  /**
   * 百分比限制 0:否 1：是
   * @format int32
   */
  percentFlag?: number;
}

/** NameValueDict */
export interface NameValueDict {
  name?: string;
  value?: string;
}

/** NameValueDictDTO */
export interface NameValueDictDTO {
  name?: string;
  value?: string;
}

/** OnlineManageAddVO */
export interface OnlineManageAddVO {
  appUrl?: string;
  /** banner */
  bannerList?: OnlineManageBannerUpsertVO[];
  canDelete?: boolean;
  canSettingBannerOrPromotion?: boolean;
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  /** @format int64 */
  onlineManageId?: number;
  /** 透明购类型 */
  onlineType?: string;
  /** 平台图标 */
  platformImageUrl?: string;
  /** 平台名称 */
  platformName?: string;
  platformStatus?: boolean;
  /** 平台链接 */
  platformUrl?: string;
  /** 平台活动 */
  promotionList?: OnlineManagePromotionUpsertVO[];
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManageBannerDTO */
export interface OnlineManageBannerDTO {
  bannerUrl?: string;
  /** @format date-time */
  createTime?: string;
  jumpUrl?: string;
  /** @format int64 */
  onlineManageBannerId?: number;
  /** @format int64 */
  onlineManageId?: number;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManageBannerUpsertVO */
export interface OnlineManageBannerUpsertVO {
  /** banner url */
  bannerUrl?: string;
  /** @format date-time */
  createTime?: string;
  /** 跳转链接 */
  jumpUrl?: string;
  /** @format int64 */
  onlineManageBannerId?: number;
  /**
   * 透明购管理主键
   * @format int64
   */
  onlineManageId?: number;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManageDetailVO */
export interface OnlineManageDetailVO {
  appUrl?: string;
  bannerList?: OnlineManageBannerDTO[];
  canDelete?: boolean;
  canSettingBannerOrPromotion?: boolean;
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  /** @format int64 */
  onlineManageId?: number;
  onlineType?: string;
  platformImageUrl?: string;
  platformName?: string;
  platformStatus?: boolean;
  platformUrl?: string;
  promotionList?: OnlineManagePromotionDTO[];
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManagePromotionDTO */
export interface OnlineManagePromotionDTO {
  /** @format date-time */
  createTime?: string;
  jumpUrl?: string;
  /** @format int64 */
  onlineManageId?: number;
  /** @format int64 */
  onlineManagePromotionId?: number;
  promotionButtonText?: string;
  promotionUrl?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManagePromotionUpsertVO */
export interface OnlineManagePromotionUpsertVO {
  /** @format date-time */
  createTime?: string;
  /** 跳转链接 */
  jumpUrl?: string;
  /**
   * 透明购管理主键
   * @format int64
   */
  onlineManageId?: number;
  /** @format int64 */
  onlineManagePromotionId?: number;
  /** 活动按钮文本	 */
  promotionButtonText?: string;
  /** 活动url	 */
  promotionUrl?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManageStatusUpdateVO */
export interface OnlineManageStatusUpdateVO {
  /**
   * 主键
   * @format int64
   */
  onlineManageId?: number;
  /** 平台状态；0：下架；1：上架 */
  platformStatus?: boolean;
}

/** OnlineManageTypeVO */
export interface OnlineManageTypeVO {
  /** 类型 */
  key?: string;
  /** 透明购 */
  onlineManageList?: OnlineManageVO[];
  /** 类型 */
  type?: string;
}

/** OnlineManageUpdateVO */
export interface OnlineManageUpdateVO {
  appUrl?: string;
  /** banner */
  bannerList?: OnlineManageBannerUpsertVO[];
  canDelete?: boolean;
  canSettingBannerOrPromotion?: boolean;
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  /**
   * 主键
   * @format int64
   */
  onlineManageId?: number;
  /** 透明购类型 */
  onlineType?: string;
  /** 平台图标 */
  platformImageUrl?: string;
  /** 平台名称 */
  platformName?: string;
  platformStatus?: boolean;
  /** 平台链接 */
  platformUrl?: string;
  /** 平台活动 */
  promotionList?: OnlineManagePromotionUpsertVO[];
  /** 站点code */
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OnlineManageVO */
export interface OnlineManageVO {
  appUrl?: string;
  bannerList?: OnlineManageBannerDTO[];
  canDelete?: boolean;
  canSettingBannerOrPromotion?: boolean;
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  /** @format int64 */
  onlineManageId?: number;
  /** 透明购类型 */
  onlineType?: string;
  platformImageUrl?: string;
  platformName?: string;
  platformStatus?: boolean;
  platformUrl?: string;
  promotionList?: OnlineManagePromotionDTO[];
  stationCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** OpenShareLinkRespVO */
export interface OpenShareLinkRespVO {
  /** 产品图册编码列表 */
  atlasCodes?: string[];
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /**
   * 分享人客户id
   * @format int64
   */
  customerId?: number;
  /** 分享人客户名称 */
  customerName?: string;
  /**
   * 分享人店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 分享人店铺名称 */
  customerShopName?: string;
  /**
   * 分享人主客户id
   * @format int64
   */
  mainCustomerId?: number;
  /** 图册列表 */
  page?: PageQueryProductAtlasRespVO;
  /** 备注 */
  remark?: string;
  /**
   * 发送状态 0-未发送，1-已发送
   * @format int32
   */
  sendStatus?: number;
  /** 分享码 */
  shareCode?: string;
  /**
   * 分享人超级客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 系统来源 1-D2C 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 分享标题 */
  title?: string;
  /** 分享人统一客户全名 */
  unificationCustomerFullName?: string;
}

/** OpenShareLinkVO */
export interface OpenShareLinkVO {
  /**
   * 是否加入心愿单 0-否 1-是
   * @format int32
   */
  addWishFlag?: number;
  /** 图册编码 */
  atlasCode?: string;
  /**
   * 是否可购买 0-否 1-是
   * @format int32
   */
  canBuyFlag?: number;
  /**
   * 客户是否已下单 0-否 1-是
   * @format int32
   */
  createOrderFlag?: number;
  /**
   * 分享人店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 标签列表 */
  labelIds?: number[];
  /**
   * 页码，不传默认1
   * @format int32
   */
  pageNo?: number;
  /**
   * 页大小，不传默认10
   * @format int32
   */
  pageSize?: number;
  /** 商品款号 */
  productNumber?: string;
  /** 分享码 */
  shareCode?: string;
  /** 供应商编码 */
  supplierCode?: string;
}

/** OrderItem */
export interface OrderItem {
  asc?: boolean;
  column?: string;
}

/** PageInfo */
export interface PageInfo {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
}

/** Product */
export interface Product {
  /** @format int32 */
  addChannel?: number;
  /** @format date-time */
  addedTime?: string;
  areaCodes?: string;
  /** @format int32 */
  batchNumber?: number;
  /** @format date-time */
  blackAddTime?: string;
  blackReason?: string;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  blackUserId?: string;
  blackUserName?: string;
  /** @format int32 */
  carefullySelected?: number;
  /** @format int32 */
  channel?: number;
  /** @format int32 */
  christmasClothingTag?: number;
  /** @format int32 */
  christmasGroceriesTag?: number;
  consignPrice?: number;
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  currency?: string;
  currencyProductSellPrice?: number;
  /** @format int32 */
  directSaleFlag?: number;
  directStoreProductDescImgs?: string;
  directStoreProductItemImgs?: string;
  directStoreProductItemImgsS?: string;
  directStoreProductMainImg?: string;
  /** @format double */
  height?: number;
  intactCateCode?: string;
  intactCateName?: string;
  /** @format int32 */
  isCkbDiscount?: number;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  /** @format int32 */
  isPick?: number;
  jxhyPrice?: number;
  keywords?: string;
  keywordsEn?: string;
  keywordsJp?: string;
  keywordsKr?: string;
  /** @format double */
  length?: number;
  /** @format double */
  maintainHeight?: number;
  /** @format double */
  maintainLength?: number;
  /** @format int64 */
  maintainWeight?: number;
  /** @format double */
  maintainWidth?: number;
  mallCode?: string;
  materialInfoEn?: string;
  materialInfoJa?: string;
  materialInfoKr?: string;
  materialInfoZh?: string;
  /** @format int32 */
  offlineDirectSaleFlag?: number;
  originalId?: string;
  originalPrice?: number;
  platformType?: string;
  productAppSellPrice?: number;
  productBrandId?: string;
  productBrandName?: string;
  /** @format int32 */
  productBuyMininum?: number;
  productCateCode?: string;
  productCode?: string;
  /** @format int32 */
  productCommentCount?: number;
  productDescImgs?: string;
  productDescOcrImgs?: string;
  /** @format int32 */
  productDescOcrImgsFlag?: number;
  productDescription?: string;
  productDescriptionEn?: string;
  productDescriptionJa?: string;
  productDescriptionKr?: string;
  productDetailSniffUrl?: string;
  productDetailUrl?: string;
  /** @format int64 */
  productId?: number;
  productItemCategoryZh?: string;
  productItemImgs?: string;
  productItemImgsS?: string;
  productKeywords?: string;
  productMainImg?: string;
  productOriginPriceRange?: string;
  productPriceLadder?: string;
  productPropImgs?: string;
  productProps?: string;
  /** @format int32 */
  productPropsAddMode?: number;
  productPropsEn?: string;
  productPropsEnList?: string;
  productPropsJa?: string;
  productPropsJaList?: string;
  productPropsKrList?: string;
  productPropsList?: string;
  productSellPrice?: number;
  productSellPriceRange?: string;
  /** @format int32 */
  productSellQuantity?: number;
  productStallNumber?: string;
  /** @format int32 */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  productTitleEn?: string;
  productTitleJa?: string;
  productTitleKr?: string;
  productVideo?: string;
  productVideoImg?: string;
  season?: string;
  sellerId?: string;
  sellerNick?: string;
  shopCode?: string;
  shopLocation?: string;
  shopName?: string;
  /** @format int32 */
  sortNum?: number;
  sourceCodes?: string;
  sourceProductTags?: string;
  sourceTags?: string;
  stationCode?: string;
  /** @format int32 */
  stationStatus?: number;
  supplierSpu?: string;
  thirdProductCateCode?: string;
  transportationAttrCode?: string;
  /** @format date-time */
  updateTime?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** ProductAddBlackDTO */
export interface ProductAddBlackDTO {
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记:1-黑名单,0-移除黑名单
   * @format int32
   */
  blackTag?: number;
  /** 商品code */
  productCode?: string;
  /** 商品codeList */
  productCodeList?: string[];
}

/** ProductAndSkuRespDTO */
export interface ProductAndSkuRespDTO {
  product?: Product;
  productPropGroupList?: ProductPropGroupRespDTO[];
  skuList?: Sku[];
}

/** ProductAndSkusDTO */
export interface ProductAndSkusDTO {
  productCode?: string;
  productSkuList?: string[];
}

/** ProductCategoryAddRequVO */
export interface ProductCategoryAddRequVO {
  /** 类目名称 */
  cateName?: string;
  /** 国际运费 */
  internationalFreight?: number;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** 维护人员ID; 前端不需要传 */
  maintainManagerId?: string;
  /** 维护人员名称; 前端不需要传 */
  maintainManagerName?: string;
  /** 映射类目编码 */
  mapList?: ProductCategoryMapSaveReqDTO[];
  pcode?: string;
  /**
   * 商品报关中文品名主键ID
   * @format int64
   */
  productCustomsId?: number;
  /** 运输属性code列表 */
  transportAttrCodeList?: string[];
  /** 运输属性名字列表 */
  transportAttrNameList?: string[];
  /**
   * 重量
   * @format int32
   */
  weight?: number;
}

/** ProductCategoryCustomsMapFormReqDTO */
export interface ProductCategoryCustomsMapFormReqDTO {
  maintainManagerId?: string;
  maintainManagerName?: string;
  productCategoryCateCode?: string;
  /** @format int64 */
  productCustomsId?: number;
}

/** ProductCategoryFixDTO */
export interface ProductCategoryFixDTO {
  /** 动作 */
  action?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 操作Id */
  id?: string;
  operator?: string;
}

/** ProductCategoryFrontendAllParentNodeDTO */
export interface ProductCategoryFrontendAllParentNodeDTO {
  cateIcon?: string;
  cateNameEn?: string;
  cateNameJp?: string;
  cateNameKr?: string;
  cateNameZh?: string;
  /** @format int32 */
  defaultFlag?: number;
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** ProductCategoryFrontendGroupChannelRespDTO */
export interface ProductCategoryFrontendGroupChannelRespDTO {
  /** @format int32 */
  channel?: number;
  productCategoryFrontendShortRespDTOList?: ProductCategoryFrontendShortRespDTO[];
}

/** ProductCategoryFrontendInsertReqDTO */
export interface ProductCategoryFrontendInsertReqDTO {
  cateCodeList?: string[];
  cateIcon?: string;
  /** 类目名称（英文） */
  cateNameEn?: string;
  /** 类目名称（日文） */
  cateNameJp?: string;
  /** 类目名称（韩文） */
  cateNameKr?: string;
  cateNameZh?: string;
  /** @format int32 */
  defaultFlag?: number;
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  /** 站点code */
  stationCode?: string;
}

/** ProductCategoryFrontendMapGroupRespDTO */
export interface ProductCategoryFrontendMapGroupRespDTO {
  cateCodeList?: ProductCategorySingleRespDTO[];
  /** @format int64 */
  productCategoryFrontendId?: number;
}

/** ProductCategoryFrontendMapReqDTO */
export interface ProductCategoryFrontendMapReqDTO {
  cateCode?: string;
  cateCodeList?: string[];
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** @format int32 */
  productCategoryFrontendLevel?: number;
  stationCode?: string;
}

/** ProductCategoryFrontendReqDTO */
export interface ProductCategoryFrontendReqDTO {
  cateName?: string;
  cateNameJp?: string;
  cateNameZh?: string;
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  productCategoryFrontendIdList?: number[];
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** ProductCategoryFrontendRespDTO */
export interface ProductCategoryFrontendRespDTO {
  cateIcon?: string;
  cateNameEn?: string;
  cateNameJp?: string;
  cateNameKr?: string;
  cateNameZh?: string;
  channels?: number[];
  children?: ProductCategoryFrontendRespDTO[];
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  defaultFlag?: number;
  /** @format int32 */
  fastCategoryFlag?: number;
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ProductCategoryFrontendRespV2DTO */
export interface ProductCategoryFrontendRespV2DTO {
  cateIcon?: string;
  cateName?: string;
  cateNameZh?: string;
  channels?: number[];
  children?: ProductCategoryFrontendRespV2DTO[];
  /** @format date-time */
  createTime?: string;
  /** @format int32 */
  defaultFlag?: number;
  /** @format int32 */
  fastCategoryFlag?: number;
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ProductCategoryFrontendShortRespDTO */
export interface ProductCategoryFrontendShortRespDTO {
  cateIcon?: string;
  cateNameEn?: string;
  cateNameJp?: string;
  cateNameKr?: string;
  cateNameZh?: string;
  children?: ProductCategoryFrontendShortRespDTO[];
  /** @format int32 */
  level?: number;
  /** @format int64 */
  parentId?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  stationCode?: string;
}

/** ProductCategoryFrontendUpdateReqDTO */
export interface ProductCategoryFrontendUpdateReqDTO {
  cateCodeList?: string[];
  cateIcon?: string;
  /** 类目名称（英文） */
  cateNameEn?: string;
  /** 类目名称（日文） */
  cateNameJp?: string;
  /** 类目名称（韩文） */
  cateNameKr?: string;
  cateNameZh?: string;
  /** @format int32 */
  defaultFlag?: number;
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** 站点code */
  stationCode?: string;
}

/** ProductCategoryMapGroupRespDTO */
export interface ProductCategoryMapGroupRespDTO {
  cateCodeList?: ProductCategoryThirdSingleRespDTO[];
  platformType?: string;
}

/** ProductCategoryMapReqDTO */
export interface ProductCategoryMapReqDTO {
  cateCode?: string;
  cateCodeList?: string[];
  platformType?: string;
  thirdCateCode?: string;
  /** @format int32 */
  thirdCateCodeLevel?: number;
}

/** ProductCategoryMapRespDTO */
export interface ProductCategoryMapRespDTO {
  cateCode?: string;
  mallCode?: string;
  platformType?: string;
  thirdCateCode?: string;
  /** @format int32 */
  thirdCateCodeLevel?: number;
}

/** ProductCategoryMapSaveReqDTO */
export interface ProductCategoryMapSaveReqDTO {
  cateCodeMapList?: ProductCategoryThirdSingleUpdateReqDTO[];
  platformType?: string;
}

/** ProductCategoryPageRequVO */
export interface ProductCategoryPageRequVO {
  /** 类目编码; */
  cateCode?: string;
  /** 类目编码列表 */
  cateCodeList?: string[];
  /** 类目名称 */
  cateName?: string;
  /**
   * 子类目是否存在报关关联信息;1-存在,0-不存在
   * @format int64
   */
  isExistProductCustoms?: number;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  pcode?: string;
  pcodeList?: string[];
  /** @format int32 */
  startIndex?: number;
  /**
   * 启用状态;1-开;0-关
   * @format int32
   */
  status?: number;
}

/** ProductCategoryReqDTO */
export interface ProductCategoryReqDTO {
  cateCode?: string;
  cateCodeList?: string[];
  cateName?: string;
  intactCateName?: string;
  /** @format int32 */
  level?: number;
  pcode?: string;
  pcodeList?: string[];
  /** @format int32 */
  status?: number;
}

/** ProductCategoryRequVO */
export interface ProductCategoryRequVO {
  /** 类目编码; */
  cateCode?: string;
  /** 类目编码列表 */
  cateCodeList?: string[];
  /** 类目名称 */
  cateName?: string;
  intactCateCode?: string;
  intactCateName?: string;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  pcode?: string;
  pcodeList?: string[];
  /**
   * 启用状态;1-开;0-关
   * @format int32
   */
  status?: number;
}

/** ProductCategoryRespDTO */
export interface ProductCategoryRespDTO {
  cateCode?: string;
  cateName?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 完整层级类目代码 */
  intactCateCode?: string;
  /** 完整层级类目名称 */
  intactCateName?: string;
  /** 国际运费 */
  internationalFreight?: number;
  /**
   * 子类目存在未关联中文品名
   * @format int64
   */
  isProductCustomsEmpty?: number;
  /**
   * 子类目存在运输属性为空
   * @format int64
   */
  isTransportationPropertiesEmpty?: number;
  /**
   * 子类目存在重量为空
   * @format int64
   */
  isWeightEmpty?: number;
  /** @format int32 */
  level?: number;
  maintainManagerId?: string;
  maintainManagerName?: string;
  pcode?: string;
  /** 操作日志 */
  productCategoryFixDTOS?: ProductCategoryFixDTO[];
  /** 已绑定三方类目 */
  productCategoryThirdOnlineList?: ProductCategoryThirdRespDTO[];
  /**
   * 商品报关主键ID
   * @format int64
   */
  productCustomsId?: number;
  /** 申报中文品名 */
  productItemCategoryZh?: string;
  /** @format int32 */
  status?: number;
  /** @format int32 */
  subCateCount?: number;
  /** 运输属性code列表 */
  transportAttrCodeList?: string[];
  /** 运输属性 */
  transportationProperties?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
  /**
   * 重量
   * @format int32
   */
  weight?: number;
}

/** ProductCategoryRespVO */
export interface ProductCategoryRespVO {
  /** 类目编码 */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  children?: ProductCategoryRespVO[];
  /** 完整层级类目代码 */
  intactCateCode?: string;
  /** 完整层级类目名称 */
  intactCateName?: string;
  /**
   * 子类目是否存在报关关联信息
   * @format int64
   */
  isExistProductCustoms?: number;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** 维护人员ID */
  maintainManagerId?: string;
  /** 维护人员名称 */
  maintainManagerName?: string;
  pcode?: string;
  /**
   * 商品报关主键ID
   * @format int64
   */
  productCustomsId?: number;
  /** 申报中文品名 */
  productItemCategoryZh?: string;
  /**
   * 启用状态;1-开;0-关;
   * @format int32
   */
  status?: number;
  /**
   * 子级数量
   * @format int32
   */
  subCateCount?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** ProductCategorySingleRespDTO */
export interface ProductCategorySingleRespDTO {
  cateCodeList?: string[];
  /** @format int32 */
  level?: number;
}

/** ProductCategoryThirdBlackSaveReqDTO */
export interface ProductCategoryThirdBlackSaveReqDTO {
  maintainManagerId?: string;
  maintainManagerName?: string;
  platformType?: string;
  /** @format int64 */
  productCategoryThirdId?: number;
  singleReqDTOList?: ProductCategoryThirdBlackSingleReqDTO[];
}

/** ProductCategoryThirdBlackSingleReqDTO */
export interface ProductCategoryThirdBlackSingleReqDTO {
  cateCodeList?: string[];
  /** @format int32 */
  level?: number;
}

/** ProductCategoryThirdChannelPlatformTypeRespDTO */
export interface ProductCategoryThirdChannelPlatformTypeRespDTO {
  /** @format int32 */
  channel?: number;
  platformTypeRespDTOList?: ProductCategoryThirdPlatformTypeRespDTO[];
}

/** ProductCategoryThirdGroupTreeShortRespDTO */
export interface ProductCategoryThirdGroupTreeShortRespDTO {
  list?: ProductCategoryThirdShortRespDTO[];
  platformType?: string;
}

/** ProductCategoryThirdPageReqDTO */
export interface ProductCategoryThirdPageReqDTO {
  /**
   * 黑名单;1-黑名单;0-非黑名单;2-半选;
   * @format int32
   */
  blackFlag?: number;
  /**
   * 黑名单列表传这个值; 1:表示获取黑名单或者半选
   * @format int32
   */
  blackFlagStatus?: number;
  /** 类目编码 */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  /** 降序 */
  descendOrder?: boolean;
  /** 是否叶子类目:true,false */
  isLeaf?: string;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /**
   * 是否映射;1-已映射;0-未映射
   * @format int32
   */
  mappingFlag?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 父级编码 */
  pcode?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫; */
  platformType?: string;
  /** 排序字段; (默认)更新时间: update_time,level; */
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
}

/** ProductCategoryThirdPlatformTypeRespDTO */
export interface ProductCategoryThirdPlatformTypeRespDTO {
  platformName?: string;
  platformType?: string;
}

/** ProductCategoryThirdReqDTO */
export interface ProductCategoryThirdReqDTO {
  /** @format int32 */
  blackFlag?: number;
  cateCode?: string;
  cateCodeList?: string[];
  excludeLevel?: number[];
  /** 是否为叶子类目;true/false */
  isLeaf?: string;
  /**
   * 是否需要补充中文材质:1需要,0不需要
   * @format int32
   */
  isNeedMaterial?: number;
  /** @format int32 */
  level?: number;
  /** @format int32 */
  mappingFlag?: number;
  pcode?: string;
  platformType?: string;
}

/** ProductCategoryThirdRespDTO */
export interface ProductCategoryThirdRespDTO {
  /**
   * 黑名单;1-黑名单;0-非黑名单;2-非全选黑名单;
   * @format int32
   */
  blackFlag?: number;
  /** 类目编码; */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /** 子级类目 */
  children?: ProductCategoryThirdRespDTO[];
  /** 完整层级类目编码 */
  intactCateCode?: string;
  /** 完整层级类目名称 */
  intactCateName?: string;
  /** 国际运费 */
  internationalFreight?: number;
  /** 是否叶子类目 */
  isLeaf?: string;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** 维护人员名称 */
  maintainManagerName?: string;
  /** 市场编码 */
  mallCode?: string;
  /** 市场名称 */
  mallName?: string;
  /**
   * 是否已mapping;1-已映射;0-未映射
   * @format int32
   */
  mappingFlag?: number;
  /** 父级编码 */
  pcode?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫; */
  platformType?: string;
  /**
   * 类目ID
   * @format int64
   */
  productCategoryThirdId?: number;
  /**
   * 子级数量
   * @format int32
   */
  subCount?: number;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** ProductCategoryThirdShortRespDTO */
export interface ProductCategoryThirdShortRespDTO {
  /** @format int32 */
  blackFlag?: number;
  cateCode?: string;
  cateName?: string;
  /** 类目名称 */
  cateNameEn?: string;
  /** 类目名称 */
  cateNameJa?: string;
  /** 类目名称 */
  cateNameKo?: string;
  children?: ProductCategoryThirdShortRespDTO[];
  /** 是否叶子类目 */
  isLeaf?: string;
  /** @format int32 */
  level?: number;
  /** @format int32 */
  mappingFlag?: number;
  pcode?: string;
}

/** ProductCategoryThirdSingleRespDTO */
export interface ProductCategoryThirdSingleRespDTO {
  /** @format int32 */
  thirdCateCodeLevel?: number;
  thirdCateCodeList?: string[];
}

/** ProductCategoryThirdSingleUpdateReqDTO */
export interface ProductCategoryThirdSingleUpdateReqDTO {
  cateCode?: string[];
  /** @format int32 */
  level?: number;
}

/** ProductCategoryUpdateRequVO */
export interface ProductCategoryUpdateRequVO {
  /** 类目编码 */
  cateCode?: string;
  /** 类目名称 */
  cateName?: string;
  /** 国际运费 */
  internationalFreight?: number;
  /**
   * 类目等级
   * @format int32
   */
  level?: number;
  /** 维护人员ID; 前端不需要传 */
  maintainManagerId?: string;
  /** 维护人员名称; 前端不需要传 */
  maintainManagerName?: string;
  /** 映射类目编码 */
  mapList?: ProductCategoryMapSaveReqDTO[];
  /**
   * 商品报关中文品名主键ID
   * @format int64
   */
  productCustomsId?: number;
  /**
   * 启用状态;1-开;0-关
   * @format int32
   */
  status?: number;
  /** 运输属性code列表 */
  transportAttrCodeList?: string[];
  /** 运输属性名字列表 */
  transportAttrNameList?: string[];
  /**
   * 重量
   * @format int32
   */
  weight?: number;
}

/** ProductChoiceCollection */
export interface ProductChoiceCollection {
  cateIcon?: string;
  cateName?: string;
  cateNameZh?: string;
  /** @format int64 */
  productCategoryFrontendId?: number;
}

/** ProductCodeSkuMapRespDTO */
export interface ProductCodeSkuMapRespDTO {
  productCode?: string;
  productSku?: string;
}

/** ProductCollectionRecommendResp */
export interface ProductCollectionRecommendResp {
  /** @format int32 */
  productCollectionId?: number;
  productCollectionName?: string;
  productCollectionNameZh?: string;
  productList?: SearchProductRespDTO[];
}

/** ProductCustomsFormReqDTO */
export interface ProductCustomsFormReqDTO {
  compilationMethod?: string;
  compilationMethodEn?: string;
  /** 报关编码(日文) */
  customsCode?: string;
  /** 报关编码（英文） */
  customsCodeEn?: string;
  /** 报关编码（韩文） */
  customsCodeKr?: string;
  /** @format int64 */
  productCustomsId?: number;
  productItemCategoryEn?: string;
  productItemCategoryZh?: string;
  simpleReportCode?: string;
  stationCode?: string;
}

/** ProductCustomsHsCodeCrawlReqDTO */
export interface ProductCustomsHsCodeCrawlReqDTO {
  /** HS CODE 列表详情 */
  productCustomsHsCodeReqDTOList?: ProductHsCodeKeywordReqDTO[];
  /** 报关中文品名(站点语种) */
  productItemCateLanguage?: string;
  /** 报关中文品名 */
  productItemCategoryZh?: string;
  /**
   * 来源
   * @format int32
   */
  source?: number;
  /** 站点code */
  stationCode?: string;
}

/** ProductCustomsListReqDTO */
export interface ProductCustomsListReqDTO {
  productItemCategoryZhs?: string[];
}

/** ProductCustomsPageReqDTO */
export interface ProductCustomsPageReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  productItemCategoryZh?: string;
  /** @format int32 */
  startIndex?: number;
}

/** ProductCustomsReqDTO */
export interface ProductCustomsReqDTO {
  productCustomsIdList?: number[];
  productItemCategoryZh?: string;
  stationCode?: string;
}

/** ProductCustomsRespDTO */
export interface ProductCustomsRespDTO {
  compilationMethod?: string;
  compilationMethodEn?: string;
  customsCode?: string;
  customsCodeEn?: string;
  customsCodeKr?: string;
  customsPriceJp?: number;
  /** @format int64 */
  productCustomsId?: number;
  productItemCategoryEn?: string;
  productItemCategoryZh?: string;
  simpleReportCode?: string;
  stationCode?: string;
}

/** ProductDetailByPluginPddRequest */
export interface ProductDetailByPluginPddRequest {
  html?: string;
}

/** ProductDetailDTO */
export interface ProductDetailDTO {
  add_time?: string;
  area_code?: string;
  asyncSupplier?: boolean;
  /** @format int32 */
  batch_number?: number;
  cate_code?: string;
  category_code?: string;
  channel_source?: string;
  /** @format int32 */
  christmas_clothing_tag?: number;
  /** @format int32 */
  christmas_groceries_tag?: number;
  consign_price?: number;
  /** @format int32 */
  country_product_tag?: number;
  data_source?: string;
  description?: string;
  description_imgs?: string[];
  detail_url?: string;
  /** @format int32 */
  direct_sale_flag?: number;
  direct_store_description_imgs?: string[];
  direct_store_item_imgs_b?: string[];
  direct_store_item_imgs_s?: string[];
  direct_store_main_img?: string;
  dk_hh?: string;
  /** @format double */
  height?: number;
  /** @format int32 */
  html_type?: number;
  is_one_psale?: boolean;
  /** @format int32 */
  is_online?: number;
  item_imgs_b?: string[];
  item_imgs_s?: string[];
  jxhy_price?: number;
  /** @format double */
  length?: number;
  main_img?: string;
  material?: string;
  materials?: MaterialDTO[];
  msg?: string;
  original_price?: number;
  platform_code?: string;
  price_range_list?: object[];
  price_range_str?: string;
  product_code?: string;
  /** @format int32 */
  product_comment?: number;
  product_id?: string;
  product_keywords?: string;
  /** @format int32 */
  product_tag?: number;
  props?: ProductPropDTO[];
  props_dict?: Record<string, string>;
  props_dict_en?: Record<string, string>;
  props_dict_ja?: Record<string, string>;
  props_dict_kr?: Record<string, string>;
  props_en?: ProductPropDTO[];
  props_img?: ProductPropImgDTO[];
  props_ja?: ProductPropDTO[];
  sell_price?: number;
  /** @format int32 */
  sell_quantity?: number;
  seller_info?: SellerInfoDTO;
  shop_code?: string;
  shop_customer_service_id?: string;
  shop_id?: string;
  shop_location?: string[];
  shop_url?: string;
  sku_list?: ProductSkuDTO[];
  /** @format int32 */
  sort_num?: number;
  source_code?: string;
  /** @format int32 */
  start_count?: number;
  /** @format int32 */
  stock_quantity?: number;
  tag_codes?: string[];
  title?: string;
  title_en?: string;
  title_ja?: string;
  video_img?: string;
  video_url?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** ProductDetailListReqDTO */
export interface ProductDetailListReqDTO {
  cateCode?: string;
  cateCodeList?: string[];
  /** @format int32 */
  channel?: number;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  /** @format int32 */
  offlineDirectSaleFlag?: number;
  productCodeList?: string[];
  productTitle?: string;
  productUrls?: string[];
  shopCode?: string;
  shopName?: string;
  sourceCodes?: string;
  stationCode?: string;
}

/** ProductDetailParamReqDTO */
export interface ProductDetailParamReqDTO {
  /** @format int32 */
  black_validate?: number;
  /** @format int32 */
  cate_map_validate?: number;
}

/** ProductDetailReqDTO */
export interface ProductDetailReqDTO {
  /** @format int64 */
  customerId?: number;
  /** 忽略上下架 */
  ignoreIsOnline?: boolean;
  /** @format int32 */
  isOnline?: number;
  productCode?: string;
  productCodeList?: string[];
  /** 站点 */
  stationCode?: string;
}

/** ProductDetailRequVO */
export interface ProductDetailRequVO {
  asyncSupplier?: boolean;
  country?: string;
  ignoreBlack?: boolean;
  platform?: string;
  productCode: string;
  stationCode?: string;
}

/** ProductDetailRespDTO */
export interface ProductDetailRespDTO {
  /**
   * 商品一手数量
   * @format int32
   */
  batchNumber?: number;
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  /** 是否一件代发(ture:是) */
  isOnePsale?: boolean;
  jxhyPrice?: number;
  /** 材质信息-日文（注意：订单使用） */
  materialInfoJa?: string;
  /** 材质信息-中文（注意：订单使用） */
  materialInfoZh?: string;
  /**
   * oem最小起订量
   * @format int32
   */
  minOrderQuantity?: number;
  /**
   * OEM商品分类表id：1-服装; 2-杂货; 3-辅料
   * @format int32
   */
  oemProductClassificationId?: number;
  /** 商品原始价格 */
  originalPrice?: number;
  paymentDetail?: string;
  /** @format int32 */
  paymentType?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品APP价格 */
  productAppSellPrice?: number;
  /** 品牌id */
  productBrandId?: string;
  /** 品牌名称 */
  productBrandName?: string;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码; */
  productCateCode?: string;
  /**
   * 前台类目二级ID
   * @format int64
   */
  productCategoryFrontendNdId?: number;
  /** 平台商品SPU */
  productCode?: string;
  /**
   * 商品评论数
   * @format int32
   */
  productCommentCount?: number;
  /** 描述图片 */
  productDescImgs?: string[];
  /** 商品描述 */
  productDescription?: string;
  /** 详情URL */
  productDetailUrl?: string;
  /** item缩略图（大） */
  productItemImgs?: ProductImageUrlDTO[];
  /** item缩略图（小） */
  productItemImgsS?: ProductImageUrlDTO[];
  /** 主图 */
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 商品阶梯价 */
  productPriceRangeLadderList?: ProductPriceLadderRespDTO[];
  /** 商品属性 */
  productPropGroupEnList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupJaList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupKrList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupList?: ProductPropGroupRespDTO[];
  /** 属性图片 */
  productPropImgs?: string[];
  /** 属性标识（注意：订单使用） */
  productProperties?: string;
  /** 属性名称（注意：订单使用） */
  productPropertiesName?: string;
  /** 属性名称parse（注意：sku使用） */
  productPropertiesNameParse?: string;
  /** 商品详情属性 */
  productProps?: string;
  productPropsEn?: string;
  productPropsEnList?: string;
  productPropsJa?: string;
  productPropsJaList?: string;
  /** 商品sku属性列表 */
  productPropsList?: string;
  /** 商品资源 */
  productResource?: ProductResourceRespDTO;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品销售价格-日元 */
  productSellPriceJpy?: number;
  /** 商品价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 平台商品SKU */
  productSku?: string;
  /** sku对应图片（注意：订单使用） */
  productSkuImg?: string;
  /** 档口货号 */
  productStallNumber?: string;
  /**
   * 库存
   * @format int32
   */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  /** 商品标题 */
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 商品视频介绍 */
  productVideo?: string;
  /** 问题-商品类型【问题一：商品类型】（注意：订单使用） */
  questionClassificationName?: string;
  /** 请求商品详情URL */
  requestProductDetailUrl?: string;
  /**
   * 寻源单复购申请表id
   * @format int64
   */
  searchSourcePriceId?: number;
  /** 二级类目编码 */
  secondaryProductCateCode?: string;
  /** 卖家id */
  sellerId?: string;
  /** 掌柜昵称 */
  sellerNick?: string;
  /** 店铺code */
  shopCode?: string;
  /** 发货地 */
  shopLocation?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 店铺名称-英文 */
  shopNameEn?: string;
  /** 店铺商品SKU(店铺商品库)（注意：订单使用） */
  shopProductSku?: string;
  /**
   * 1-单尺码; 2-多尺码（注意：订单使用）
   * @format int32
   */
  sizeFlag?: number;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** 第三方商品类目编码 */
  thirdProductCateCode?: string;
}

/** ProductDetailResponse */
export interface ProductDetailResponse {
  addTime?: string;
  areaCode?: string;
  /** @format int32 */
  batchNumber?: number;
  cateCode?: string;
  categoryCode?: string;
  channelSource?: string;
  /** @format int32 */
  code?: number;
  consignPrice?: number;
  /** @format int32 */
  countryProductTag?: number;
  dataSource?: string;
  description?: string;
  descriptionImgs?: string[];
  detailUrl?: string;
  dkHh?: string;
  /** @format double */
  height?: number;
  /** @format int32 */
  htmlType?: number;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  itemImgsB?: string[];
  itemImgsS?: string[];
  jxhyPrice?: number;
  /** @format double */
  length?: number;
  mainImg?: string;
  material?: string;
  materials?: MaterialDTO[];
  msg?: string;
  originalPrice?: number;
  platformCode?: string;
  priceRangeList?: object[];
  priceRangeStr?: string;
  productCode?: string;
  /** @format int32 */
  productComment?: number;
  productId?: string;
  /** @format int32 */
  productTag?: number;
  props?: ProductProp[];
  propsDict?: Record<string, string>;
  propsDictJa?: Record<string, string>;
  propsDictTrans?: Record<string, string>;
  propsImg?: ProductPropImg[];
  propsJa?: ProductProp[];
  propsTrans?: ProductProp[];
  sellPrice?: number;
  /** @format int32 */
  sellQuantity?: number;
  sellerInfo?: SellerInfo;
  shopCode?: string;
  shopId?: string;
  shopLocation?: string[];
  shopUrl?: string;
  skuList?: ProductSku[];
  /** @format int32 */
  startCount?: number;
  /** @format int32 */
  stockQuantity?: number;
  title?: string;
  titleJa?: string;
  titleTrans?: string;
  videoImg?: string;
  videoUrl?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** ProductDetailSaveReqDTO */
export interface ProductDetailSaveReqDTO {
  data?: ProductDetailDTO;
  param?: ProductDetailParamReqDTO;
}

/** ProductDetailUrlReqDTO */
export interface ProductDetailUrlReqDTO {
  asyncSupplier?: boolean;
  channelList?: number[];
  country?: string;
  /**
   * 是否需要1688实时数据 0 1
   * @format int32
   */
  currentData?: number;
  /** @format int64 */
  customerId?: number;
  detailUrl?: string;
  filterBlackTag?: boolean;
  filterNotIsOnline?: boolean;
  stationCode?: string;
}

/** ProductDetailVo */
export interface ProductDetailVo {
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * 来源类型;1-档口(市场购);2-线上平台(透明购);4-线下
   * @format int32
   */
  channel?: number;
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  consignPriceMax?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /** 完整层级类目代码 */
  intactCateCode?: string;
  /** 完整层级类目名称 */
  intactCateName?: string;
  /** @format int32 */
  isCkbDiscount?: number;
  isOnePsale?: boolean;
  /**
   * 是否有效：1:有效;0:无效;2:备用
   * @format int32
   */
  isOnline?: number;
  jxhyPrice?: number;
  /** 关键字 */
  keywords?: string;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /**
   * 高，单位cm(人工维护)
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长，单位cm(人工维护)
   * @format double
   */
  maintainLength?: number;
  /**
   * 重，单位g(人工维护)
   * @format int64
   */
  maintainWeight?: number;
  /**
   * 宽，单位cm(人工维护)
   * @format double
   */
  maintainWidth?: number;
  /** 英文材质 */
  materialInfoEn?: string;
  /** 日文材质 */
  materialInfoJa?: string;
  /** 韩文材质 */
  materialInfoKr?: string;
  /** 中文材质 */
  materialInfoZh?: string;
  /**
   * 直营商城标识
   * @format int32
   */
  offlineDirectSaleFlag?: number;
  originalPrice?: number;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码 */
  productCateCode?: string;
  /** 商品SPU */
  productCode?: string;
  /** 商品详情图 */
  productDescImgs?: string[];
  /** 商品描述 */
  productDescription?: string;
  /** 英文商品描述 */
  productDescriptionEn?: string;
  /** 日文商品描述 */
  productDescriptionJa?: string;
  /** 韩文商品描述 */
  productDescriptionKr?: string;
  /** 商品链接 */
  productDetailSniffUrl?: string;
  /**
   * spu主键
   * @format int64
   */
  productId?: number;
  /** 中文品名 */
  productItemCategoryZh?: string;
  /** 商品轮播图 */
  productItemImgs?: ProductImageUrlDTO[];
  /** 主图 */
  productMainImg?: string;
  /** 材质信息集合 */
  productMaterials?: SkuMaterialLanguageInfoDTO[];
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 商品阶梯价 */
  productPriceLadderVoList?: ProductPriceLadderVo[];
  /**
   * 规格属性创建模式，0-属性模式，1-自定义模式
   * @format int32
   */
  productPropsAddMode?: number;
  /** 规格属性映射列表，如：[{'0:0':'颜色:白色'}] */
  productPropsMap?: Record<string, string>;
  /** 商品销售价格 */
  productSellPrice?: number;
  /** 商品销售价格-日元 */
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** sku规格属性列表 */
  productSkuVoList?: ProductSkuVo[];
  /** @format int32 */
  productTag?: number;
  /** 商品名称 */
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 商品主视频 */
  productVideo?: string;
  /** 店铺编码 */
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
  /** 供应商id */
  supplierId?: string;
  /** 供应商名称 */
  supplierName?: string;
  /** 供应商spu */
  supplierSpu?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 重，单位g
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductDingWarnDTO */
export interface ProductDingWarnDTO {
  /** 操作内容 */
  content?: string;
  /**
   * 告警类型
   * @format int32
   */
  dingWarnType?: number;
}

/** ProductEditReqDTO */
export interface ProductEditReqDTO {
  productCode?: string;
  productStallNumber?: string;
}

/**
 * ProductExtendQuery
 * 查询
 */
export interface ProductExtendQuery {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
}

/**
 * ProductExtendRespDTO
 * 响应结果
 */
export interface ProductExtendRespDTO {
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 平台分类 */
  intactCateName?: string;
  /**
   * 高
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长
   * @format double
   */
  maintainLength?: number;
  /**
   * 重量
   * @format int64
   */
  maintainWeight?: number;
  /**
   *  宽
   * @format double
   */
  maintainWidth?: number;
  /** 最高价 */
  maxPrice?: number;
  /** 最低价 */
  minPrice?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 站点商品属性 */
  productAttribute?: string;
  /** 商品属性 */
  productAttributeList?: ProductPropDto[];
  /** 商品编码 */
  productCode?: string;
  /** 详情图 */
  productDescImgs?: string;
  /** 描述图片（商品详情） */
  productDescImgsList?: string[];
  /** 商品链接 */
  productDetailUrl?: string;
  /** 轮播图 */
  productImageUrl?: string;
  /** 描述图片（商品详情） */
  productImageUrlList?: string[];
  /** 商品中文sku属性信息 */
  productPropsList?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 站点规格信息 */
  productSku?: string;
  /** 商品名称(哪个站点 哪个国家的语言) */
  productStationName?: string;
  /** 商品名称 中文 */
  productTitle?: string;
  /** 商品sku属性中文 */
  propsList?: ProductPropGroupDTO[];
  /** 商品sku属性日文 */
  propsSkuList?: ProductPropGroupDTO[];
  /** 店铺名称 */
  shopName?: string;
  sourceProductTags?: string;
  sourceTags?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /**
   * 状态 0 待上架 1 已上架 -1 已废弃
   * @format int32
   */
  status?: number;
  /** 标签code */
  tagCodes?: string[];
  /** 标签名称 */
  tags?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** ProductFreightDTO */
export interface ProductFreightDTO {
  freight?: number;
  offerId?: string;
  /** @format int64 */
  totalNum?: number;
}

/** ProductFreightQueryDTO */
export interface ProductFreightQueryDTO {
  platformType?: string;
  productFreightDTOList?: ProductFreightDTO[];
  toCityCode?: string;
  toCountryCode?: string;
  toProvinceCode?: string;
}

/** ProductFreightRespDTO */
export interface ProductFreightRespDTO {
  productFreightDTOList?: ProductFreightDTO[];
  totalFreight?: number;
}

/** ProductHsCodeKeywordDeleteReqDTO */
export interface ProductHsCodeKeywordDeleteReqDTO {
  /**
   * 报关名称与hsCode映射关系
   * @format int64
   */
  id?: number;
  /** 站点code */
  stationCode?: string;
}

/** ProductHsCodeKeywordMappingPageReqDTO */
export interface ProductHsCodeKeywordMappingPageReqDTO {
  /** hsCode */
  hsCode?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 报关中文品名 */
  productHsCodeKeywordZh?: string;
  productHsCodeKeywordZhs?: string[];
  /** 搜索词 */
  searchKeywords?: string;
  /** 搜索词 */
  searchKeywordsLanguage?: string;
  /** @format int32 */
  startIndex?: number;
  /** 站点code */
  stationCode?: string;
  /** 税率 */
  taxRate?: number;
}

/** ProductHsCodeKeywordMappingRespDTO */
export interface ProductHsCodeKeywordMappingRespDTO {
  /** 描述 */
  description?: string;
  /** 描述(站点多语言) */
  descriptionLanguage?: string;
  /** hsCode */
  hsCode?: string;
  /**
   * 品名与hsCode映射id
   * @format int64
   */
  id?: number;
  /**
   * 商品HSCODE关键字id
   * @format int64
   */
  productHsCodeKeywordId?: number;
  /** 申报中文品名 */
  productHsCodeKeywordZh?: string;
  /** 站点code */
  stationCode?: string;
  /** 税率 */
  taxRate?: number;
}

/** ProductHsCodeKeywordPageReqDTO */
export interface ProductHsCodeKeywordPageReqDTO {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * hsCode关键字Id
   * @format int64
   */
  productHsCodeKeywordId?: number;
  /** 报关中文品名 */
  productHsCodeKeywordZh?: string;
  /** @format int32 */
  startIndex?: number;
}

/** ProductHsCodeKeywordReqDTO */
export interface ProductHsCodeKeywordReqDTO {
  /** 描述 */
  description?: string;
  /** 描述（站点语种） */
  descriptionLanguage?: string;
  /** hsCode */
  hsCode?: string;
  /**
   * 报关名称与hsCode映射关系
   * @format int64
   */
  id?: number;
  /**
   * hsCode关键字Id
   * @format int64
   */
  productHsCodeKeywordId?: number;
  /** 报关中文品名 */
  productHsCodeKeywordZh?: string;
  /**
   * 来源
   * @format int32
   */
  source?: number;
  /** 站点code */
  stationCode?: string;
  /** 税率 */
  taxRate?: number;
}

/** ProductHsCodeKeywordRespDTO */
export interface ProductHsCodeKeywordRespDTO {
  /**
   * 中文品名id
   * @format int64
   */
  id?: number;
  /** hsCode关键字（日文） */
  productHsCodeKeywordJp?: string;
  /** hsCode关键字（韩文） */
  productHsCodeKeywordKr?: string;
  /** hsCode关键字（英文） */
  productHsCodeKeywordUk?: string;
  /** hsCode关键字(中文) */
  productHsCodeKeywordZh?: string;
}

/**
 * ProductImageConfigRespDTO
 * 无水印图配置
 */
export interface ProductImageConfigRespDTO {
  /**
   * 次数/月
   * @format int32
   */
  num?: number;
  /**
   * 排序
   * @format int32
   */
  sort?: number;
  stationCode?: string;
  /** 会员身份名称 */
  templateName?: string;
}

/** ProductImageUrlDTO */
export interface ProductImageUrlDTO {
  url?: string;
}

/** ProductInfo */
export interface ProductInfo {
  platformType?: string;
  productAppSellPrice?: number;
  productCode?: string;
  productDescription?: string;
  productDescriptionEn?: string;
  productDescriptionJa?: string;
  productDescriptionKr?: string;
  productDetailUrl?: string;
  /** @format int64 */
  productId?: number;
  productMainImg?: string;
  productPropsEn?: string;
  productPropsEnList?: string;
  productPropsJa?: string;
  productPropsJaList?: string;
  productPropsList?: string;
  productSellPrice?: number;
  productTitle?: string;
  productTitleEn?: string;
  productTitleJa?: string;
  supplierSpu?: string;
}

/** ProductItemCategoryZhUpdateVO */
export interface ProductItemCategoryZhUpdateVO {
  /**
   * 商品报关ID
   * @format int64
   */
  productCustomsId?: number;
  /** 中文品名 */
  productItemCategoryZh?: string;
  /** sku */
  productSku?: string;
  /** sku列表 */
  productSkuList?: string[];
}

/** ProductKpiDTO */
export interface ProductKpiDTO {
  /** @format int32 */
  avgDeliveryTime?: number;
  /** @format date-time */
  createTime?: string;
  defectivePer?: number;
  /** @format int32 */
  defectiveQty?: number;
  errorPer?: number;
  /** @format int32 */
  errorQty?: number;
  minPurchaseUnitPrice?: number;
  moreLessPer?: number;
  /** @format int32 */
  moreLessQty?: number;
  productCode?: string;
  /**
   * 商品不良率显示:1-不良率≥40%,2-不良率≥50%
   * @format int32
   */
  showDefectiveStatus?: number;
  /**
   * 回货时长过长显示:3-回货时长≥15天
   * @format int32
   */
  showDeliveryTimeStatus?: number;
  /**
   * 优先显示状态:1-不良率≥40%,2-不良率≥50%,3-回货时长≥15天
   * @format int32
   */
  showStatus?: number;
  /** @format int32 */
  totalPurchaseQty?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ProductLabelRespVO */
export interface ProductLabelRespVO {
  /**
   * 标签id
   * @format int64
   */
  id?: number;
  /** 标签英文名称 */
  labelNameEn?: string;
  /** 标签日文名称 */
  labelNameJp?: string;
  /** 标签韩文名称 */
  labelNameKr?: string;
  /** 标签中文名称 */
  labelNameZh?: string;
  /**
   * 标签层级
   * @format int32
   */
  level?: number;
  /**
   * 开启状态 1-启用 2-停用
   * @format int32
   */
  openStatus?: number;
  /**
   * 上层标签id
   * @format int64
   */
  parentId?: number;
}

/** ProductMallFrontendRespDTO */
export interface ProductMallFrontendRespDTO {
  mallNameEn?: string;
  mallNameJp?: string;
  mallNameKr?: string;
  mallNameZh?: string;
  /** @format int64 */
  productMallFrontendId?: number;
}

/** ProductOcrUpdateVo */
export interface ProductOcrUpdateVo {
  /** OCR处理后的描述图片 */
  ocrImageList?: string[];
  /** 商品编码 */
  productCode?: string;
}

/** ProductOperatorLogVo */
export interface ProductOperatorLogVo {
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** 操作编码 */
  operateCode?: string;
  /** 操作内容 */
  operateContent?: string;
  /**
   * 操作对象:1-供应商,2-spu,3-sku
   * @format int32
   */
  operateObject?: number;
  /** 操作人id */
  operateUserId?: string;
  /** 操作人姓名 */
  operateUserName?: string;
  /** 更新后的值 */
  payload?: string;
  /** 商品SKU */
  productSku?: string;
}

/** ProductPluginSearchLogReqVo */
export interface ProductPluginSearchLogReqVo {
  /**
   * 客户ID
   * @format int64
   */
  customerId?: number;
  /** 关键字 */
  keyword?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /**
   * 商品类目ID
   * @format int64
   */
  productCategoryFrontendId?: number;
}

/** ProductPopularMallReqDTO */
export interface ProductPopularMallReqDTO {
  blackCategoryCodeList?: string[];
  categorySourceList?: string[];
  /** @format int64 */
  customerId?: number;
  disableProductCategoryCodeList?: string[];
  dislikeProductCodeList?: string[];
  /** @format date-time */
  fetchDate?: string;
  /** @format int64 */
  mallCategoryId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** ProductPopularMallRespDTO */
export interface ProductPopularMallRespDTO {
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * 渠道
   * @format int32
   */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  productCode?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 店铺编码 */
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
}

/** ProductPriceLadderReq */
export interface ProductPriceLadderReq {
  /** @format int32 */
  count?: number;
  /**
   * 结束数量
   * @format int32
   */
  endQty?: number;
  /** 销售单价 */
  price?: number;
  /** 采购单价 */
  purchasePrice?: number;
  /**
   * 起始数量
   * @format int32
   */
  startQty?: number;
}

/** ProductPriceLadderRespDTO */
export interface ProductPriceLadderRespDTO {
  appPrice?: number;
  /** @format int32 */
  count?: number;
  discount?: number;
  originPrice?: number;
  price?: number;
  purchasePrice?: number;
}

/** ProductPriceLadderVo */
export interface ProductPriceLadderVo {
  /** @format int32 */
  count?: number;
  /**
   * 结束数量
   * @format int32
   */
  endQty?: number;
  /** 销售单价 */
  price?: number;
  /** 采购单价 */
  purchasePrice?: number;
  /**
   * 起始数量
   * @format int32
   */
  startQty?: number;
}

/** ProductPriceRequVO */
export interface ProductPriceRequVO {
  /**
   * 天
   * @format int32
   */
  day?: number;
  /** 商品编码 */
  productCode?: string;
  time?: string;
}

/** ProductProp */
export interface ProductProp {
  name?: string;
  value?: string;
  values?: string[];
}

/** ProductPropDTO */
export interface ProductPropDTO {
  name?: string;
  value?: string;
}

/**
 * ProductPropDto
 * 商品属性
 */
export interface ProductPropDto {
  /** 中文名称 */
  name?: string;
  /** 站点名称 */
  stationName?: string;
  /** 站点结果 */
  stationValue?: string;
  /** 中文结果 */
  value?: string;
}

/** ProductPropGroupDTO */
export interface ProductPropGroupDTO {
  /** 属性id */
  id?: string;
  /** 属性信息 */
  props?: ProductPropWithImgDTO[];
  /** 属性类型 */
  type?: string;
}

/** ProductPropGroupRespDTO */
export interface ProductPropGroupRespDTO {
  id?: string;
  props?: ProductPropRespDTO[];
  type?: string;
}

/** ProductPropImg */
export interface ProductPropImg {
  properties?: string;
  url?: string;
  url_s?: string;
}

/** ProductPropImgDTO */
export interface ProductPropImgDTO {
  properties?: string;
  url?: string;
  url_s?: string;
}

/** ProductPropRespDTO */
export interface ProductPropRespDTO {
  id?: string;
  propKey?: string;
  propValue?: string;
  props?: ProductPropRespDTO[];
  /** @format int64 */
  sort?: number;
  type?: string;
  url?: string;
}

/** ProductPropWithImgDTO */
export interface ProductPropWithImgDTO {
  /** 属性id */
  id?: string;
  /** 属性编码 */
  propKey?: string;
  /** 属性值 */
  propValue?: string;
  /** 属性信息 */
  props?: ProductPropWithImgDTO[];
  /** @format int64 */
  sort?: number;
  /** 属性类型 */
  type?: string;
  /** 图片url */
  url?: string;
}

/** ProductQueryDTO */
export interface ProductQueryDTO {
  /**
   * 黑名单标记:1-黑名单
   * @format int32
   */
  blackTag?: number;
  /** 是否一件代发 true:是 */
  isOnePsale?: boolean;
  /** @format int32 */
  pageNum?: number;
  /**
   * 导出第几页结束
   * @format int32
   */
  pageNumEnd?: number;
  /**
   * 导出第几页开始
   * @format int32
   */
  pageNumStart?: number;
  /** @format int32 */
  pageSize?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品编码 */
  productCode?: string;
  /** 商品codeList */
  productCodeList?: string[];
  /** @format int32 */
  startIndex?: number;
  /** 采购链接 */
  url?: string;
}

/** ProductRecommendReqDTO */
export interface ProductRecommendReqDTO {
  /**
   * 前台类目id
   * @format int64
   */
  productCategoryFrontendId?: number;
}

/** ProductReferenceEditReqDTO */
export interface ProductReferenceEditReqDTO {
  /** 后台类目 */
  cateCode?: string;
  /** 高，单位cm */
  height?: number;
  /**
   * 参考库id
   * @format int64
   */
  id?: number;
  /** 长，单位cm */
  length?: number;
  /** 参考分类名称（英语） */
  referenceCategoryEn?: string;
  /** 参考分类名称（日语） */
  referenceCategoryJp?: string;
  /** 参考分类名称（韩文） */
  referenceCategoryKr?: string;
  /** 参考分类名称（中文） */
  referenceCategoryZh?: string;
  /** 商品图片 */
  referenceProductImg?: string;
  /** 参考商品简称（英语） */
  referenceProductNameEn?: string;
  /** 参考商品简称（日语） */
  referenceProductNameJp?: string;
  /** 参考商品简称（韩文） */
  referenceProductNameKr?: string;
  /** 参考商品简称（中文） */
  referenceProductNameZh?: string;
  /**
   * 体总（单位：g）
   * @format int64
   */
  weight?: number;
  /** 宽，单位cm */
  width?: number;
}

/** ProductReferenceGroupRespDTO */
export interface ProductReferenceGroupRespDTO {
  /** 分组下的参考库数据 */
  productReferences?: ProductReferenceRespDTO[];
  /** 参考分类名称（英语） */
  referenceCategoryEn?: string;
  /** 参考分类名称（日语） */
  referenceCategoryJp?: string;
  /** 参考分类名称（韩文） */
  referenceCategoryKr?: string;
  /** 参考分类名称（中文） */
  referenceCategoryZh?: string;
}

/** ProductReferencePageReqDTO */
export interface ProductReferencePageReqDTO {
  /** 后台类目 */
  cateCode?: string;
  /** 完整标识（日韩应都存在为完整，前端搜索使用） */
  completionFlag?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 类目分类 */
  referenceCategoryZh?: string;
  /** @format int32 */
  startIndex?: number;
}

/** ProductReferenceRespDTO */
export interface ProductReferenceRespDTO {
  /** 分类编码 */
  cateCode?: string;
  /** 分类名称 */
  cateName?: string;
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /**
   * 品名与HSCODE映射id
   * @format int64
   */
  id?: number;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /** 参考分类名称（英语） */
  referenceCategoryEn?: string;
  /** 参考分类名称（日语） */
  referenceCategoryJp?: string;
  /** 参考分类名称（韩文） */
  referenceCategoryKr?: string;
  /** 参考分类名称（中文） */
  referenceCategoryZh?: string;
  /** 商品图片 */
  referenceProductImg?: string;
  /** 参考商品简称（英语） */
  referenceProductNameEn?: string;
  /** 参考商品简称（日语） */
  referenceProductNameJp?: string;
  /** 参考商品简称（韩文） */
  referenceProductNameKr?: string;
  /** 参考商品简称（中文） */
  referenceProductNameZh?: string;
  /**
   * 体总（单位：g）
   * @format int32
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductReferenceSaveReqDTO */
export interface ProductReferenceSaveReqDTO {
  /** 后台类目 */
  cateCode?: string;
  /** 高，单位cm */
  height?: number;
  /** 长，单位cm */
  length?: number;
  /** 参考分类名称（英语） */
  referenceCategoryEn?: string;
  /** 参考分类名称（日语） */
  referenceCategoryJp?: string;
  /** 参考分类名称（韩文） */
  referenceCategoryKr?: string;
  /** 参考分类名称（中文） */
  referenceCategoryZh?: string;
  /** 商品图片 */
  referenceProductImg?: string;
  /** 参考商品简称（英语） */
  referenceProductNameEn?: string;
  /** 参考商品简称（日语） */
  referenceProductNameJp?: string;
  /** 参考商品简称（韩文） */
  referenceProductNameKr?: string;
  /** 参考商品简称（中文） */
  referenceProductNameZh?: string;
  /**
   * 体总（单位：g）
   * @format int64
   */
  weight?: number;
  /** 宽，单位cm */
  width?: number;
}

/** ProductReq */
export interface ProductReq {
  /** 产品图册编码 */
  atlasCode?: string;
  /**
   * 来源类型;1-档口(市场购);2-线上平台(透明购);4-线下
   * @format int32
   */
  channel?: number;
  /** 国家 */
  country?: string;
  /** 币种 */
  currency?: string;
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  intactCateCode?: string;
  intactCateName?: string;
  /**
   * 是否有效：1:启用;0:禁用;2:备用
   * @format int32
   */
  isOnline?: number;
  /** 关键字 */
  keywords?: string;
  /** 关键字 */
  keywordsEn?: string;
  /** 关键字日文 */
  keywordsJp?: string;
  /** 关键字 */
  keywordsKr?: string;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /**
   * 高，单位cm(人工维护)
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长，单位cm(人工维护)
   * @format double
   */
  maintainLength?: number;
  /**
   * 重，单位g(人工维护)
   * @format int64
   */
  maintainWeight?: number;
  /**
   * 宽，单位cm(人工维护)
   * @format double
   */
  maintainWidth?: number;
  /** 英文材质 */
  materialInfoEn?: string;
  /** 日文材质 */
  materialInfoJa?: string;
  /** 韩文材质 */
  materialInfoKr?: string;
  /** 中文材质:废弃 */
  materialInfoZh?: string;
  /**
   * 直营商城标识
   * @format int32
   */
  offlineDirectSaleFlag?: number;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码; */
  productCateCode?: string;
  /** 商品SPU */
  productCode?: string;
  /** 商品详情图 */
  productDescImgs?: string[];
  /** 中文商品描述 */
  productDescription?: string;
  /** 英文商品描述 */
  productDescriptionEn?: string;
  /** 日文商品描述 */
  productDescriptionJa?: string;
  /** 韩文商品描述 */
  productDescriptionKr?: string;
  /** 商品链接不能为空 */
  productDetailSniffUrl?: string;
  /**
   * spu主键
   * @format int64
   */
  productId?: number;
  /** 中文品名 */
  productItemCategoryZh?: string;
  /** 商品轮播图 */
  productItemImgs?: ProductImageUrlDTO[];
  /** 主图 */
  productMainImg?: string;
  /** 材质信息集合 */
  productMaterials?: SkuMaterialLanguageInfoDTO[];
  /** 商品阶梯价 */
  productPriceLadderReqList?: ProductPriceLadderReq[];
  /**
   * 规格属性创建模式，0-属性模式，1-自定义模式
   * @format int32
   */
  productPropsAddMode?: number;
  /** 规格属性映射列表，如：[{'0:0':'颜色:白色'}] */
  productPropsMap?: Record<string, string>;
  /** sku规格属性列表 */
  productSkuReqList?: ProductSkuReq[];
  /** 商品名称 */
  productTitle?: string;
  /** 商品主视频 */
  productVideo?: string;
  /** 商品季节：spring，summer，autumn，winter */
  season?: string;
  /** 供应商id */
  supplierId?: string;
  /** 供应商名称 */
  supplierName?: string;
  /** 供应商spu */
  supplierSpu?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 重，单位g
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductResourceRespDTO */
export interface ProductResourceRespDTO {
  descImgs?: string[];
  itemImgs?: string[];
  mainImg?: string;
  propImgs?: string;
  video?: string;
}

/** ProductRespDTO */
export interface ProductRespDTO {
  /**
   * 商品一手数量
   * @format int32
   */
  batchNumber?: number;
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /**
   * 黑名单;1-黑名单;0-白名单
   * @format int32
   */
  blackFlag?: number;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 商品加入黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * 是否严选
   * @format int32
   */
  carefullySelected?: number;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  consignPrice?: number;
  consignPriceJpy?: number;
  consignPriceMax?: number;
  consignPriceMaxJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  currencyProductSellPrice?: number;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  jxhyPrice?: number;
  /** 关键字 */
  keywords?: string;
  /** 关键字 */
  keywordsEn?: string;
  /** 关键字 */
  keywordsJp?: string;
  /** 关键字 */
  keywordsKr?: string;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /**
   * 高，单位cm（人工维护）
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长，单位cm（人工维护）
   * @format double
   */
  maintainLength?: number;
  /**
   * 重，单位g（人工维护）
   * @format int64
   */
  maintainWeight?: number;
  /**
   * 宽，单位cm（人工维护）
   * @format double
   */
  maintainWidth?: number;
  /** 材质信息-日文（注意：订单使用） */
  materialInfoJa?: string;
  /** 材质信息-中文（注意：订单使用） */
  materialInfoZh?: string;
  /**
   * oem最小起订量
   * @format int32
   */
  minOrderQuantity?: number;
  /**
   * OEM商品分类表id：1-服装; 2-杂货; 3-辅料
   * @format int32
   */
  oemProductClassificationId?: number;
  /** 商品原始价格 */
  originalPrice?: number;
  paymentDetail?: string;
  /** @format int32 */
  paymentType?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品APP价格 */
  productAppSellPrice?: number;
  /** 品牌id */
  productBrandId?: string;
  /** 品牌名称 */
  productBrandName?: string;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码; */
  productCateCode?: string;
  /** 前台一级类目名 */
  productCategoryFrontendFirstName?: string;
  /** 前台一级类目名jp */
  productCategoryFrontendFirstNameJp?: string;
  /**
   * 前台类目二级ID
   * @format int64
   */
  productCategoryFrontendNdId?: number;
  /** 前台二级类目名 */
  productCategoryFrontendSecondName?: string;
  /** 前台二级类目名jp */
  productCategoryFrontendSecondNameJp?: string;
  /**
   * 平台类目状态;1-启用;0-停用
   * @format int32
   */
  productCategoryStatusFlag?: number;
  /** 平台商品SPU */
  productCode?: string;
  /**
   * 商品评论数
   * @format int32
   */
  productCommentCount?: number;
  /** 描述图片 */
  productDescImgs?: string[];
  /** 商品描述 */
  productDescription?: string;
  productDescriptionEn?: string;
  productDescriptionJa?: string;
  productDescriptionKr?: string;
  /** 详情URL */
  productDetailUrl?: string;
  /** item缩略图（大） */
  productItemImgs?: ProductImageUrlDTO[];
  /** item缩略图（小） */
  productItemImgsS?: ProductImageUrlDTO[];
  /** 主图 */
  productMainImg?: string;
  /**
   * 前台市场ID
   * @format int64
   */
  productMallFrontendId?: number;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 商品阶梯价 */
  productPriceRangeLadderList?: ProductPriceLadderRespDTO[];
  /** 商品属性 */
  productPropGroupEnList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupJaList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupKrList?: ProductPropGroupRespDTO[];
  /** 商品属性 */
  productPropGroupList?: ProductPropGroupRespDTO[];
  /** 属性图片 */
  productPropImgs?: string[];
  /** 属性标识（注意：订单使用） */
  productProperties?: string;
  /** 属性名称（注意：订单使用） */
  productPropertiesName?: string;
  /** 属性名称parse（注意：sku使用） */
  productPropertiesNameParse?: string;
  /** 商品详情属性 */
  productProps?: string;
  productPropsEn?: string;
  productPropsEnList?: string;
  productPropsJa?: string;
  productPropsJaList?: string;
  /** 商品sku属性列表 */
  productPropsList?: string;
  /** 商品资源 */
  productResource?: ProductResourceRespDTO;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品销售价格-日元 */
  productSellPriceJpy?: number;
  /** 商品价格范围 */
  productSellPriceRange?: string;
  /** 商品价格范围-日币 */
  productSellPriceRangeJpy?: string;
  /**
   * 销售价类型， 0-原价,1-精选货源价,2-销售折扣价
   * @format int32
   */
  productSellPriceType?: number;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 平台商品SKU */
  productSku?: string;
  /** sku对应图片（注意：订单使用） */
  productSkuImg?: string;
  /** 档口货号 */
  productStallNumber?: string;
  /**
   * 库存
   * @format int32
   */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  /** 商品名称 */
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 商品视频介绍 */
  productVideo?: string;
  /** 问题-商品类型【问题一：商品类型】（注意：订单使用） */
  questionClassificationName?: string;
  /** 请求商品详情URL */
  requestProductDetailUrl?: string;
  /**
   * 寻源单复购申请表id
   * @format int64
   */
  searchSourcePriceId?: number;
  /** 二级类目编码 */
  secondaryProductCateCode?: string;
  /** 卖家id */
  sellerId?: string;
  /** 掌柜昵称 */
  sellerNick?: string;
  /** 店铺code */
  shopCode?: string;
  /**
   * 店铺是否为黑名单
   * @format int32
   */
  shopIsBlack?: number;
  /** 发货地 */
  shopLocation?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 店铺名称-英文 */
  shopNameEn?: string;
  /** 店铺商品SKU(店铺商品库)（注意：订单使用） */
  shopProductSku?: string;
  /** 店铺链接 */
  shopUrl?: string;
  /**
   * 1-单尺码; 2-多尺码（注意：订单使用）
   * @format int32
   */
  sizeFlag?: number;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  /** 线索code */
  sourceCodes?: string;
  stationCode?: string;
  /** @format int32 */
  stationStatus?: number;
  /** 第三方商品类目编码 */
  thirdProductCateCode?: string;
  /** 运输属性列表 */
  transportationAttrCodeList?: string[];
  /** 运输属性(多个逗号隔开) */
  transportationAttrNameStr?: string;
  /**
   * 重，单位kg
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductSameStylePutInRespVO */
export interface ProductSameStylePutInRespVO {
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /** 同款商品SPU */
  productCode?: string;
  /**
   * 同款商品id
   * @format int64
   */
  productSameStyleId?: number;
}

/** ProductSameStyleRespVO */
export interface ProductSameStyleRespVO {
  /** @format int32 */
  channel?: number;
  /**
   * 商品价格
   * @format int32
   */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  originalId?: string;
  platformType?: string;
  productCode?: string;
  productDetailUrl?: string;
  productMainImg?: string;
  /** @format int64 */
  productSameStyleId?: number;
  productSellPrice?: number;
  /** 商品价格 */
  productSellPriceJpa?: number;
  /** @format int32 */
  productStockQuantity?: number;
  productTitle?: string;
  putIn?: boolean;
  shopLocation?: string;
  sourceProductCode?: string;
  /** @format date-time */
  updateTime?: string;
}

/** ProductSimilar */
export interface ProductSimilar {
  /** @format int32 */
  channel?: number;
  /** @format date-time */
  createTime?: string;
  mallCode?: string;
  platformType?: string;
  productCode?: string;
  productSellPrice?: number;
  /** @format int32 */
  productSellQuantity?: number;
  productSimilarId?: string;
  similarProductCode?: string;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  /** @format date-time */
  updateTime?: string;
}

/** ProductSimilarSearchReqDTO */
export interface ProductSimilarSearchReqDTO {
  /** @format int32 */
  channel?: number;
  channelList?: number[];
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  dislikeProductCodeList?: string[];
  mallCodeList?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  platformType?: string;
  productCode?: string;
  /** @format int64 */
  productMallFrontendId?: number;
  sellPriceEnd?: number;
  sellPriceStart?: number;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** ProductSimpleRespDTO */
export interface ProductSimpleRespDTO {
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /** 完整层级类目代码; */
  intactCateCode?: string;
  /** 完整层级类目名称; */
  intactCateName?: string;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /** 材质信息中文 */
  materialInfoZh?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 类目编码; */
  productCateCode?: string;
  /** 平台商品SPU */
  productCode?: string;
  /** 描述图片 */
  productDescImgs?: string[];
  /** 商品描述 */
  productDescription?: string;
  /** 详情URL */
  productDetailUrl?: string;
  /** 中文品名 */
  productItemCategoryZh?: string;
  /** item缩略图（大） */
  productItemImgs?: ProductImageUrlDTO[];
  /** 主图 */
  productMainImg?: string;
  /** 商品名称 */
  productTitle?: string;
  /** 商品名称 */
  productTitleJa?: string;
  /** 运输属性 */
  productTransportationAttrDTOS?: ProductTransportationAttrDTO[];
  /** 店铺code（platform_type-shop_id 例：TB-shop001） */
  shopCode?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 第三方商品类目编码 */
  thirdProductCateCode?: string;
  /**
   * 重，单位g
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductSku */
export interface ProductSku {
  consignPrice?: number;
  /** @format int32 */
  countryProductTag?: number;
  discountprice?: number;
  /** @format double */
  height?: number;
  isOnePsale?: boolean;
  jxhyPrice?: number;
  /** @format double */
  length?: number;
  price?: number;
  productOriginSellPrice?: number;
  properties?: string;
  propertiesName?: string;
  propertiesNameJa?: string;
  propertiesNameTrans?: string;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  sellQuantity?: number;
  /** @format int32 */
  skuComment?: number;
  skuId?: string;
  specId?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** ProductSkuDTO */
export interface ProductSkuDTO {
  consign_price?: number;
  /** @format int32 */
  country_product_tag?: number;
  discountprice?: number;
  /** @format double */
  height?: number;
  is_one_psale?: boolean;
  jxhy_price?: number;
  /** @format double */
  length?: number;
  price?: number;
  productOriginSellPrice?: number;
  properties?: string;
  properties_name?: string;
  properties_name_en?: string;
  properties_name_ja?: string;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  sell_quantity?: number;
  /** @format int32 */
  sku_comment?: number;
  sku_id?: string;
  spec_id?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** ProductSkuReq */
export interface ProductSkuReq {
  /**
   * 是否有效：1:启用;0:禁用;2:备用
   * @format int32
   */
  isOnline?: number;
  /**
   * 操作类型: 0-none,1-add,2-modify,3-delete
   * @format int32
   */
  operationType?: number;
  /** 商品编码 */
  productCode?: string;
  /** 规格属性 */
  productProperties?: string;
  /** 属性名称 */
  productPropertiesName?: string;
  /** 属性名称parse */
  productPropertiesNameParse?: string;
  /** 销售单价 */
  productSellPrice?: number;
  /**
   * 销售量
   * @format int32
   */
  productSellQuantity?: number;
  /** 平台商品SKU */
  productSku?: string;
  /**
   * sku主键
   * @format int64
   */
  productSkuId?: number;
  /** sku规格图片 */
  productSkuImg?: string;
  /**
   * 库存(上架总库存)
   * @format int32
   */
  productStockQuantity?: number;
  /** 采购单价 */
  purchasePrice?: number;
  /** 供应商sku */
  supplierSku?: string;
}

/** ProductSkuVo */
export interface ProductSkuVo {
  /** @format int32 */
  channel?: number;
  consignPrice?: number;
  country?: string;
  currency?: string;
  /** @format int64 */
  customerId?: number;
  discountPriceSetting?: string;
  isOnePsale?: boolean;
  /**
   * 是否有效：1:有效;0:无效;2:备用
   * @format int32
   */
  isOnline?: number;
  jxhyPrice?: number;
  /**
   * 操作类型: 0-none,1-add,2-modify,3-delete
   * @format int32
   */
  operationType?: number;
  /** 商品编码 */
  productCode?: string;
  productOriginSellPrice?: number;
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 规格属性 */
  productProperties?: string;
  /** 属性名称 */
  productPropertiesName?: string;
  /** 属性名称parse */
  productPropertiesNameParse?: string;
  /** 销售单价 */
  productSellPrice?: number;
  /** @format int32 */
  productSellPriceType?: number;
  /**
   * 销售量
   * @format int32
   */
  productSellQuantity?: number;
  /** 平台商品SKU */
  productSku?: string;
  /**
   * sku主键
   * @format int64
   */
  productSkuId?: number;
  /** sku规格图片 */
  productSkuImg?: string;
  /**
   * 库存(上架总库存)
   * @format int32
   */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  productTitleEn?: string;
  productTitleJp?: string;
  productTitleKr?: string;
  /** 采购单价 */
  purchasePrice?: number;
  shopCode?: string;
  stationCode?: string;
  /** 供应商sku */
  supplierSku?: string;
}

/** ProductStallEditReqDTO */
export interface ProductStallEditReqDTO {
  productCode?: string;
  productSku?: string;
  productStallNumber?: string;
  stallProductSellPrice?: number;
}

/** ProductStallNumberUpdateVO */
export interface ProductStallNumberUpdateVO {
  /** productCode */
  productCode?: string;
  /** 档口货号 */
  productStallNumber?: string;
}

/** ProductTransAndStoragePropertyDTO */
export interface ProductTransAndStoragePropertyDTO {
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /**
   * 高，单位cm（人工维护）
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长，单位cm（人工维护）
   * @format double
   */
  maintainLength?: number;
  /**
   * 重，单位g（人工维护）
   * @format int64
   */
  maintainWeight?: number;
  /**
   * 宽，单位cm（人工维护）
   * @format double
   */
  maintainWidth?: number;
  /** 商品编码 */
  productCode?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 重，单位kg
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** ProductTransportationAttrDTO */
export interface ProductTransportationAttrDTO {
  code?: string;
  name?: string;
  nameEn?: string;
  nameJp?: string;
  nameKr?: string;
}

/** ProductWishCanOrderRespDto */
export interface ProductWishCanOrderRespDto {
  /** 类目编码; */
  productCateCode?: string;
  /** 平台商品SPU */
  productCode?: string;
  /** 主图 */
  productMainImg?: string;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品名称 */
  productTitle?: string;
  /** 二级类目编码 */
  secondaryProductCateCode?: string;
}

/** PurchaseMallReqDTO */
export interface PurchaseMallReqDTO {
  /** @format int32 */
  level?: number;
  /** @format int32 */
  parentId?: number;
  /** @format int32 */
  status?: number;
}

/** PurchaseMallRespDTO */
export interface PurchaseMallRespDTO {
  /** @format date-time */
  createTime?: string;
  intactTitle?: string;
  /** @format int32 */
  level?: number;
  marketCode?: string;
  /** @format int64 */
  parentId?: number;
  /** @format int64 */
  purchaseMallId?: number;
  /** @format int32 */
  sort?: number;
  /** @format int32 */
  status?: number;
  title?: string;
  /** @format date-time */
  updateTime?: string;
}

/** QueryAtlasSupplierVO */
export interface QueryAtlasSupplierVO {
  /**
   * 页码，不传默认1
   * @format int32
   */
  pageNo?: number;
  /**
   * 页大小，不传默认10
   * @format int32
   */
  pageSize?: number;
  /** 供应商名称 */
  supplierName?: string;
}

/** QueryCustomerShareLinkListVO */
export interface QueryCustomerShareLinkListVO {
  /**
   * 页码，不传默认1
   * @format int32
   */
  pageNo?: number;
  /**
   * 页大小，不传默认10
   * @format int32
   */
  pageSize?: number;
}

/** QueryProductAtlasRespVO */
export interface QueryProductAtlasRespVO {
  /**
   * 是否加入心愿单 0-否 1-是
   * @format int32
   */
  addWishFlag?: number;
  /** 图册编码 */
  atlasCode?: string;
  /**
   * 审核状态 1-待审核 2-审核通过 3-审核失败
   * @format int32
   */
  auditStatus?: number;
  /** 商品类目编码 */
  cateCode?: string;
  /**
   * 客户是否已下单 0-否 1-是
   * @format int32
   */
  createOrderFlag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /**
   * 删除状态 0-有效 1-无效
   * @format int32
   */
  deleteStatus?: number;
  /** 跟进人id */
  followUserId?: string;
  /** 跟进人姓名 */
  followUserName?: string;
  /** 产品头图 */
  headerImage?: string;
  /**
   * 主键id
   * @format int64
   */
  id?: number;
  /** 关联的标签列表 */
  labels?: ProductLabelRespVO[];
  /**
   * 最小起订量（几手/几件）
   * @format int32
   */
  minOrderQuantity?: number;
  /**
   * 最小起订量类型 1-童装单sku，2-童装单spu，3-男女装单sku，4-男女装单spu，5-单件可拿
   * @format int32
   */
  minOrderType?: number;
  /**
   * 是否可混批 0-否 1-是
   * @format int32
   */
  mixBatchFlag?: number;
  /**
   * 来源 1-PC 2-H5
   * @format int32
   */
  platformType?: number;
  /** 平台商品SPU */
  productCode?: string;
  /** 产品描述 */
  productDesc?: string;
  /**
   * 产品描述类型 1-1688/TB，2-档口市场、线下渠道，3-品牌
   * @format int32
   */
  productDescType?: number;
  /** 产品图片（上限50张） */
  productImgs?: string[];
  /** 产品链接 */
  productLink?: string;
  /** 商品款号 */
  productNumber?: string;
  /** 商品价格区间 */
  productPrice?: AtlasProductPriceVO[];
  /**
   * 商品价格类型 1-单件，2-多件
   * @format int32
   */
  productPriceType?: number;
  /** 商品规格 */
  productSpece?: string;
  /** 审核拒绝原因 */
  rejectReason?: string;
  /** 供应商编码 */
  supplierCode?: string;
  /** 供应商名称 */
  supplierName?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** QueryProductAtlasVO */
export interface QueryProductAtlasVO {
  /**
   * 是否加入心愿单 0-否 1-是
   * @format int32
   */
  addWishFlag?: number;
  /** 图册编码 */
  atlasCode?: string;
  /** 图册编码列表 */
  atlasCodes?: string[];
  /**
   * 审核状态 1-待审核 2-审核通过 3-审核失败
   * @format int32
   */
  auditStatus?: number;
  /**
   * 是否可购买 0-否 1-是
   * @format int32
   */
  canBuyFlag?: number;
  /** 商品类目编码 */
  cateCodes?: string[];
  /**
   * 创建时间-结束
   * @format date-time
   */
  createTimeEnd?: string;
  /**
   * 创建时间-开始
   * @format date-time
   */
  createTimeStart?: string;
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /**
   * 分享人店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 跟进人id */
  followUserId?: string;
  /** 标签列表 */
  labelIds?: number[];
  /** 最大价格（内部字段） */
  maxPrice?: number;
  /** 最小价格（内部字段） */
  minPrice?: number;
  /**
   * 标签为空 0-否 1-是
   * @format int32
   */
  noLabelFlag?: number;
  /**
   * 页码，不传默认1
   * @format int32
   */
  pageNo?: number;
  /**
   * 页大小，不传默认10
   * @format int32
   */
  pageSize?: number;
  /**
   * 来源 11-PC产品图册列表 12-PC采购审核列表
   * @format int32
   */
  platformDetailType?: number;
  /**
   * 来源 1-PC 2-H5
   * @format int32
   */
  platformType?: number;
  /**
   * 价格区间类型 取值范围：1-9
   * @format int32
   */
  priceRangeType?: number;
  /** 产品链接 */
  productLink?: string;
  /** 商品款号 */
  productNumber?: string;
  /** 供应商编码 */
  supplierCode?: string;
  /** 供应商名称列表 */
  supplierName?: string[];
}

/** QueryProductLabelRespVO */
export interface QueryProductLabelRespVO {
  /** 标签子集 */
  children?: QueryProductLabelRespVO[];
  /**
   * 标签id
   * @format int64
   */
  labelId?: number;
  /** 标签英文名称 */
  labelNameEn?: string;
  /** 标签日文名称 */
  labelNameJp?: string;
  /** 标签韩文名称 */
  labelNameKr?: string;
  /** 标签中文名称 */
  labelNameZh?: string;
  /**
   * 标签层级
   * @format int32
   */
  level?: number;
  /**
   * 开启状态 1-启用 2-停用
   * @format int32
   */
  openStatus?: number;
  /**
   * 上层标签id
   * @format int64
   */
  parentId?: number;
}

/** QueryProductLabelVO */
export interface QueryProductLabelVO {
  /** 标签id列表 */
  labelIds?: number[];
  /** 标签名称-中文 */
  labelNameZh?: string;
  /**
   * 开启状态 1-启用 2-停用
   * @format int32
   */
  openStatus?: number;
}

/** QueryShareLinkListRespVO */
export interface QueryShareLinkListRespVO {
  /** 产品图册编码列表 */
  atlasCodes?: string[];
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 创建人id */
  creatorId?: string;
  /** 创建人姓名 */
  creatorName?: string;
  /**
   * 分享人客户id
   * @format int64
   */
  customerId?: number;
  /** 分享人客户名称 */
  customerName?: string;
  /**
   * 分享人店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 分享人店铺名称 */
  customerShopName?: string;
  /** 产品头图 */
  headerImages?: string[];
  /**
   * 分享人主客户id
   * @format int64
   */
  mainCustomerId?: number;
  /** 备注 */
  remark?: string;
  /**
   * 发送状态 0-未发送，1-已发送
   * @format int32
   */
  sendStatus?: number;
  /** 分享码 */
  shareCode?: string;
  /**
   * 分享人超级客户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 系统来源 1-D2C 2-B2B
   * @format int32
   */
  systemSource?: number;
  /** 分享标题 */
  title?: string;
  /** 分享人统一客户全名 */
  unificationCustomerFullName?: string;
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/** QueryShareLinkListVO */
export interface QueryShareLinkListVO {
  /**
   * 创建时间-结束
   * @format date-time
   */
  createTimeEnd?: string;
  /**
   * 创建时间-开始
   * @format date-time
   */
  createTimeStart?: string;
  /** 创建人 */
  creatorName?: string;
  /**
   * 店铺id
   * @format int64
   */
  customerShopId?: number;
  /**
   * 页码，不传默认1
   * @format int32
   */
  pageNo?: number;
  /**
   * 页大小，不传默认10
   * @format int32
   */
  pageSize?: number;
  /**
   * 发送状态 0-未发送，1-已发送
   * @format int32
   */
  sendStatus?: number;
  /** 分享码 */
  shareCode?: string;
}

/** ReceiveTaskParam */
export interface ReceiveTaskParam {
  businessId?: string;
  flowCode?: string;
  /** @format int32 */
  identity?: number;
  retry?: boolean;
  /** @format int64 */
  taskId?: number;
  taskMeta?: TaskMeta;
  /** @format int64 */
  threadId?: number;
}

/** RecommendProductSearchReqDTO */
export interface RecommendProductSearchReqDTO {
  /** @format int32 */
  channel?: number;
  /** @format int64 */
  customerId?: number;
  dislikeProductCodeList?: string[];
  keyword?: string;
  keywordList?: string[];
  /** @format int32 */
  langType?: number;
  /** @format int64 */
  mallCategoryId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  platform?: string;
  platformType?: string;
  productCateCodeList?: string[];
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** RecommendProductSearchRespDTO */
export interface RecommendProductSearchRespDTO {
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /** @format int32 */
  channel?: number;
  /** 一件代发价 */
  consignPrice?: number;
  /** 一件代发价,当地汇率价格 */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  jxhyPrice?: number;
  originalPrice?: number;
  platformType?: string;
  productCode?: string;
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productSellPrice?: number;
  productSellPriceJpy?: number;
  /** 商品销售价格范围 */
  productSellPriceRange?: string;
  /** 商品销售价格范围-日元 */
  productSellPriceRangeJpy?: string;
  /** @format int32 */
  productSellQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  /** 商品标题翻译; 日文 */
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 店铺编码 */
  shopCode?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
}

/** RecommendProductSkuUpdateVO */
export interface RecommendProductSkuUpdateVO {
  /** sku */
  productSku?: string;
  /** 推荐商品SKU */
  recommendProductSku?: string;
}

/** RecommendSupplierSearchReqDTO */
export interface RecommendSupplierSearchReqDTO {
  /** @format int32 */
  channel?: number;
  /** @format int64 */
  customerId?: number;
  dislikeShopCodeList?: string[];
  /** @format int64 */
  mallCategoryId?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  platformType?: string;
  productCateCodeList?: string[];
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** RecommendSupplierSearchRespDTO */
export interface RecommendSupplierSearchRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  channel?: number;
  /** @format int32 */
  favoriteFlag?: number;
  platformType?: string;
  recommendProductList?: RecommendProductSearchRespDTO[];
  shopCode?: string;
  shopMainImg?: string;
  shopMajorCateCode?: string;
  shopMajorCateName?: string;
  shopName?: string;
}

/** Resource */
export interface Resource {
  description?: string;
  file?: File;
  filename?: string;
  inputStream?: InputStream;
  open?: boolean;
  readable?: boolean;
  uri?: URI;
  url?: URL;
}

/** SearchAndSaveProductVo */
export interface SearchAndSaveProductVo {
  /** 商品信息 */
  data?: Record<string, object>;
  /** platformType:taobao,1688,tmall, */
  platformType?: string;
}

/** SearchProductBySourceRequVO */
export interface SearchProductBySourceRequVO {
  /** 平台商品类目编码 */
  cateCodeList?: string[];
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /**
   * 客户ID; 前端不传
   * @format int64
   */
  customerId?: number;
  /** 降序 */
  descendOrder?: boolean;
  /** 是否一件代发(ture:是) */
  isOnePsale?: boolean;
  /** 关键词 */
  keyword?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /**
   * 前台客户端类目ID
   * @format int64
   */
  productCategoryFrontendId?: number;
  /** 结束销售价 */
  sellPriceEnd?: number;
  /** 起始销售价 */
  sellPriceStart?: number;
  /** 排序字段; (默认)更新时间: update_time; 销量: product_sell_quantity; 价格: product_sell_price; */
  sortType?: string;
  /** 线索编码 */
  sourceCode?: string;
  /**
   * 线索关联类型:1-找相似,2-找同款
   * @format int32
   */
  sourceRelationType?: number;
  /** @format int32 */
  startIndex?: number;
  /** 站点code */
  stationCode?: string;
  /** 标签编码 */
  tagCode?: string;
}

/** SearchProductReqDTO */
export interface SearchProductReqDTO {
  areaCodes?: string;
  blackCategoryCodeList?: string[];
  /** 黑名单供应商 */
  blackShopCodeList?: string[];
  /**
   * 黑名单标记:1-黑名单
   * @format int32
   */
  blackTag?: number;
  carefullySelected?: boolean;
  cateCode?: string;
  cateCodeList?: string[];
  /** @format int64 */
  categoryId?: number;
  /** @format int32 */
  channel?: number;
  channelList?: number[];
  /**
   * 圣诞活动标签:1-杂货,2服装
   * @format int32
   */
  christmasTag?: number;
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  createTimeGe?: string;
  createTimeLe?: string;
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  /** @format int32 */
  directSaleFlag?: number;
  disableProductCategoryCodeList?: string[];
  dislikeProductCodeList?: string[];
  filters?: string;
  /** @format int32 */
  isCkbDiscount?: number;
  /** 是否忽略直采标记 */
  isIgnoreDirect?: boolean;
  isOnePsale?: boolean;
  keyword?: string;
  keywordList?: string[];
  /** @format int32 */
  langType?: number;
  mallCodeList?: string[];
  /** 是否只查看上线商品 */
  onlyOnline?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  platformType?: string;
  productAtlasLabelIds?: string[];
  /** @format int64 */
  productCategoryFrontendId?: number;
  /** 商品编码 */
  productCode?: string;
  /** 商品codeList */
  productCodeList?: string[];
  /** @format int32 */
  productCollectionId?: number;
  /** @format int64 */
  productMallFrontendId?: number;
  /** @format int32 */
  productSellQuantityMin?: number;
  /** @format int32 */
  productTag?: number;
  productTitleEn?: string;
  sellPriceEnd?: number;
  sellPriceStart?: number;
  shopCode?: string;
  shopCodeList?: string[];
  shopMajorCateName?: string;
  sortType?: string;
  /** @format int32 */
  source?: number;
  sourceCodes?: string;
  sourceProductTags?: string;
  /** @format int32 */
  startIndex?: number;
  /** 站点code */
  stationCode?: string;
  /** @format int32 */
  stationStatus?: number;
  thirdCateCodeList?: string[];
  updateTimeGe?: string;
  updateTimeLe?: string;
  /** 采购链接 */
  url?: string;
}

/** SearchProductRequVO */
export interface SearchProductRequVO {
  /** 是否灰度用户 */
  abUser?: boolean;
  /** 板块编码 */
  areaCodes?: string;
  /** 黑名单类目编码列表；后台设置 */
  blackCategoryCodeList?: string[];
  /**
   * 品牌id
   * @format int64
   */
  brandId?: number;
  /** ckb严选 */
  carefullySelected?: boolean;
  /** 平台商品类目编码；后台设置：前台传productCategoryFrontendId值 */
  cateCodeList?: string[];
  /**
   * 1688平台类目id
   * @format int64
   */
  categoryId?: number;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /** 来源类型;1-档口(市场购);2-线上平台（透明购） */
  channelList?: number[];
  /**
   * 圣诞活动标签:1-杂货,2服装
   * @format int32
   */
  christmasTag?: number;
  /** 国家 */
  country?: string;
  /**
   * 是否需要1688实时数据 0 1
   * @format int32
   */
  currentData?: number;
  /**
   * 客户ID; 前端不传
   * @format int64
   */
  customerId?: number;
  /** 降序 */
  descendOrder?: boolean;
  /** 平台商品停用类目编码列表; 后台设置 */
  disableProductCategoryCodeList?: string[];
  /** 筛选项，多个choiceKey根据逗号分隔 */
  filters?: string;
  /**
   * 价格优势 0 1
   * @format int32
   */
  isCkbDiscount?: number;
  isOnePsale?: boolean;
  /** 关键词 */
  keyword?: string;
  /** 关键词列表; 前端不传；使用空格分隔关键词 */
  keywordList?: string[];
  /**
   * 关键字语言类型(1:日文(默认) 2:中文)
   * @format int32
   */
  langType?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  platform?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品标签id */
  productAtlasLabelIds?: string[];
  /**
   * 商品类目ID
   * @format int64
   */
  productCategoryFrontendId?: number;
  /** 商品编码 */
  productCode?: string;
  /**
   * 1688货盘id
   * @format int32
   */
  productCollectionId?: number;
  /**
   * 市场ID
   * @format int64
   */
  productMallFrontendId?: number;
  /** 结束销售价 */
  sellPriceEnd?: number;
  /** 起始销售价 */
  sellPriceStart?: number;
  /**
   * 7日上新, 0否1是
   * @format int32
   */
  sevenDaysNew?: number;
  /** 店铺编码 */
  shopCode?: string;
  /** 主营类目 */
  shopMajorCateName?: string;
  /** 相似商品编码; 查询相似商品数据 */
  similarProductCode?: string;
  /** 排序字段; (默认)更新时间: update_time; 销量: product_sell_quantity; 价格: product_sell_price; */
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  /** 站点code */
  stationCode?: string;
  /** 三方类目code */
  thirdProductCateCode?: string;
}

/** SearchProductRespDTO */
export interface SearchProductRespDTO {
  /** 板块编码（多个逗号隔开） */
  areaCodes?: string;
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  /**
   * 黑名单类型:1-商品,2-供应商,类型为2的无法解除黑名单限制
   * @format int32
   */
  blackType?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员 */
  blackUserName?: string;
  /**
   * ckb严选
   * @format int32
   */
  carefullySelected?: number;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  /** 一件代发价格 */
  consignPrice?: number;
  /** 一件代发价格Jpy */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /**
   * 国家货源标签 1 1688国家货盘
   * @format int32
   */
  countryProductTag?: number;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  /** @format int32 */
  isCkbDiscount?: number;
  /** 是否一件代发(ture:是) */
  isOnePsale?: boolean;
  jxhyPrice?: number;
  /**
   * 近30天销量
   * @format int32
   */
  monthSold?: number;
  /** 商品原始价格 */
  originalPrice?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码; */
  productCateCode?: string;
  /** 平台商品SPU */
  productCode?: string;
  /** 商品描述 */
  productDescription?: string;
  productDescriptionEn?: string;
  productDescriptionJa?: string;
  productDescriptionKr?: string;
  /** 主图 */
  productMainImg?: string;
  /** 商品原销售价格 */
  productOriginPriceRange?: string;
  /** 商品原销售价格-日元 */
  productOriginPriceRangeJpy?: string;
  /** 商品阶梯价 */
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品价格-日币 */
  productSellPriceJpy?: number;
  /** 商品价格范围 */
  productSellPriceRange?: string;
  /** 商品价格范围-日币 */
  productSellPriceRangeJpy?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 档口货号 */
  productStallNumber?: string;
  /**
   * 库存
   * @format int32
   */
  productStockQuantity?: number;
  /**
   * 商品标签 1 精选货源
   * @format int32
   */
  productTag?: number;
  /** 商品名称 */
  productTitle?: string;
  productTitleEn?: string;
  /** 商品标题翻译; 日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 商品链接 */
  productUrl?: string;
  /** 商品视频介绍 */
  productVideo?: string;
  /** 近30天复购率 */
  repurchaseRate?: string;
  /** 店铺code */
  shopCode?: string;
  /** 发货地 */
  shopLocation?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 商品sku信息 */
  skuList?: SkuRespDTO[];
  /** @format int32 */
  sort?: number;
  /** 线索code （多个逗号隔开） */
  sourceCodes?: string;
  /** 线索商品标签code （多个逗号隔开） */
  sourceProductTags?: string;
  stationCode?: string;
  /**
   * 商品在美国站点的状态 0-待上架 1-上架中 2-已下架
   * @format int32
   */
  stationStatus?: number;
}

/** SearchProductRespVO */
export interface SearchProductRespVO {
  /** 板块编码 */
  areaCodes?: string;
  /**
   * 客户行为;1-喜欢;2-不喜欢
   * @format int32
   */
  behaviorFlag?: number;
  /**
   * ckb严选
   * @format int32
   */
  carefullySelected?: number;
  /**
   * 来源类型;1-档口(市场购);2-线上平台（透明购）
   * @format int32
   */
  channel?: number;
  consignPrice?: number;
  /** 一件代发价格Jpy */
  consignPriceJpy?: number;
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** 币种 */
  currency?: string;
  /**
   * 是否收藏;1-已收藏;0-未收藏
   * @format int32
   */
  favoriteFlag?: number;
  isOnePsale?: boolean;
  jxhyPrice?: number;
  /**
   * 近30天销量
   * @format int32
   */
  monthSold?: number;
  /** 商品原始价格 */
  originalPrice?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /**
   * 最小购买数/起拍数
   * @format int32
   */
  productBuyMininum?: number;
  /** 类目编码; */
  productCateCode?: string;
  /** 平台商品SPU */
  productCode?: string;
  /** 商品描述 */
  productDescription?: string;
  productDescriptionEn?: string;
  productDescriptionJa?: string;
  productDescriptionKr?: string;
  /** 主图 */
  productMainImg?: string;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品价格-日币 */
  productSellPriceJpy?: number;
  /** 商品价格范围 */
  productSellPriceRange?: string;
  /** 商品价格范围-日币 */
  productSellPriceRangeJpy?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /** 档口货号 */
  productStallNumber?: string;
  /**
   * 库存
   * @format int32
   */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  /** 商品名称 */
  productTitle?: string;
  /** 商品名称英文 */
  productTitleEn?: string;
  /** 商品名称日文 */
  productTitleJp?: string;
  /** 商品标题翻译; 日文 */
  productTitleKr?: string;
  /** 商品视频介绍 */
  productVideo?: string;
  /** 近30天复购率 */
  repurchaseRate?: string;
  /** 店铺code */
  shopCode?: string;
  /** 发货地 */
  shopLocation?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 线索code （多个逗号隔开） */
  sourceCodes?: string;
  /** 线索商品标签code （多个逗号隔开） */
  sourceProductTags?: string;
}

/** SearchSupplierReqDTO */
export interface SearchSupplierReqDTO {
  /** @format int64 */
  customerId?: number;
  descendOrder?: boolean;
  footprint?: boolean;
  /** @format int64 */
  mallCategoryId?: number;
  /** 是否需要翻译商品标题  true:需要 */
  needTranslateTitle?: boolean;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sellPriceEnd?: number;
  sellPriceStart?: number;
  shopCode?: string;
  shopMajorCateName?: string;
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** SearchSupplierRespDTO */
export interface SearchSupplierRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  favoriteFlag?: number;
  shopCode?: string;
  shopMainImg?: string;
  shopName?: string;
}

/** SellerInfo */
export interface SellerInfo {
  categoryCode?: string;
  companyId?: string;
  conpamyAdd?: string;
  /** @format double */
  customerStar?: number;
  dkFloor?: string;
  dkMarket?: string;
  dkNumber?: string;
  mainSell?: string[];
  qrCode?: string;
  saleTag?: string;
  sellerContact?: NameValueDict[];
  sellerId?: string;
  sellerNick?: string;
  sellerService?: NameValueDict[];
  serviceList?: object[];
  shopAddress?: string;
  shopId?: string;
  shopMajorCateNameLanguage?: ShopMajorCateNameLanguage;
  shopName?: string;
  shopUrl?: string;
}

/** SellerInfoDTO */
export interface SellerInfoDTO {
  category_code?: string;
  company_add?: string;
  conpamy_add?: string;
  dk_floor?: string;
  dk_market?: string;
  dk_number?: string;
  main_sell?: string[];
  platform_code?: string;
  seller_contact?: NameValueDictDTO[];
  seller_id?: string;
  seller_nick?: string;
  seller_service?: NameValueDictDTO[];
  shop_address?: string;
  shop_code?: string;
  shop_id?: string;
  shop_location?: string[];
  shop_major_cate_name_language?: SellerMajorCateNameLanguageDTO;
  shop_name?: string;
  shop_url?: string;
  sz_city?: string;
}

/** SellerMajorCateNameLanguageDTO */
export interface SellerMajorCateNameLanguageDTO {
  main_sell?: string[];
  main_sell_en?: string[];
  main_sell_jp?: string[];
  main_sell_kr?: string[];
}

/** ShopInfo */
export interface ShopInfo {
  /** 店铺编码 */
  shopCode?: string;
  /** 店铺位置 */
  shopLocation?: string;
  /** 店铺名称 */
  shopName?: string;
  /** 店铺URL */
  shopUrl?: string;
}

/** ShopMajorCateNameLanguage */
export interface ShopMajorCateNameLanguage {
  mainSell?: string[];
  mainSellEn?: string[];
  mainSellJp?: string[];
  mainSellKr?: string[];
}

/** ShopProductRequVO */
export interface ShopProductRequVO {
  shopUrl: string;
}

/** ShopProductRespVO */
export interface ShopProductRespVO {
  /** 接口来源 */
  dataSource?: string;
  /** 商品信息 */
  productInfoList?: ProductInfo[];
  /** 资源来源 */
  productItemCategoryZh?: string;
  /** 店铺信息 */
  sellerInfoDTO?: SellerInfoDTO;
  /** 店铺id */
  shopId?: string;
}

/** ShopTypeInfo */
export interface ShopTypeInfo {
  /** 店铺信息 */
  shopInfoList?: ShopInfo[];
  /** 店铺类目 */
  shopType?: string;
}

/** SizenfoUpdateVO */
export interface SizenfoUpdateVO {
  /** 尺码信息 */
  productSizePropertiesName?: string;
  /** sku */
  productSku?: string;
}

/** Sku */
export interface Sku {
  /** @format int32 */
  blackTag?: number;
  bought?: boolean;
  /** @format int32 */
  channel?: number;
  /** @format int32 */
  clearRecommendReason?: number;
  consignPrice?: number;
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  currency?: string;
  currencyProductSellPrice?: number;
  /** @format double */
  discount?: number;
  /** @format date-time */
  firstApiTime?: string;
  /** @format date-time */
  firstCartTime?: string;
  /** @format date-time */
  firstOrderTime?: string;
  /** @format double */
  height?: number;
  /** @format int32 */
  hotFlag?: number;
  /** @format int32 */
  isNeedManageMaterial?: number;
  /** @format int32 */
  isNeedMaterial?: number;
  isNeedMaterialVersion?: string;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  /** @format int32 */
  isPurchase?: number;
  jxhyPrice?: number;
  /** @format double */
  length?: number;
  liveSellPrice?: number;
  /** @format date-time */
  liveSellPriceEndTime?: string;
  /** @format date-time */
  liveSellPriceStartTime?: string;
  /** @format int32 */
  maintainFlag?: number;
  /** @format double */
  maintainHeight?: number;
  /** @format double */
  maintainLength?: number;
  maintainManagerId?: string;
  /** @format int64 */
  maintainWeight?: number;
  /** @format double */
  maintainWidth?: number;
  /** @format date-time */
  mantainTime?: string;
  materialInfoEn?: string;
  materialInfoEnJson?: string;
  materialInfoJa?: string;
  materialInfoJaJson?: string;
  materialInfoKr?: string;
  materialInfoKrJson?: string;
  materialInfoZh?: string;
  materialInfoZhJson?: string;
  /** @format date-time */
  newOrderTime?: string;
  /** @format date-time */
  newPurchaseOrderTime?: string;
  /** @format int32 */
  offlineDirectSaleFlag?: number;
  platformType?: string;
  productAppSellPrice?: number;
  productCode?: string;
  /** @format int32 */
  productCommentCount?: number;
  /** @format int64 */
  productCustomsId?: number;
  productItemCategoryZh?: string;
  productOriginSellPrice?: number;
  productProperties?: string;
  productPropertiesName?: string;
  productPropertiesNameEn?: string;
  productPropertiesNameJa?: string;
  productSellPrice?: number;
  /** @format int32 */
  productSellQuantity?: number;
  productSizePropertiesName?: string;
  productSku?: string;
  /** @format int64 */
  productSkuId?: number;
  productSkuImg?: string;
  /** @format int32 */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  promotionMethod?: string;
  promotionType?: string;
  purchasePrice?: number;
  recommendProductSku?: string;
  reductionAmount?: string;
  skuId?: string;
  specId?: string;
  stallProductSellPrice?: number;
  supplierSku?: string;
  transportationAttrCode?: string;
  /** @format date-time */
  updateTime?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** SkuEditReqDTO */
export interface SkuEditReqDTO {
  productItemCategoryZh?: string;
  productSku?: string;
}

/** SkuKpiInfo */
export interface SkuKpiInfo {
  /**
   * 平均交货时长
   * @format int32
   */
  avgDeliveryTime?: number;
  /**
   * 总次品数
   * @format int32
   */
  defectiveQty?: number;
  /** 次品率 */
  defectiveRate?: number;
  /** 最低采购单价RMB */
  minPurchaseUnitPrice?: number;
  /** 商品code */
  productCode?: string;
  /** sku编码 */
  productSku?: string;
  /**
   * 总采购数量
   * @format int32
   */
  totalPurchaseQty?: number;
}

/**
 * SkuMaterialImportReqDTO
 * 批量导入材质信息
 */
export interface SkuMaterialImportReqDTO {
  /** 导入文件url */
  url?: string;
}

/** SkuMaterialLanguageInfoDTO */
export interface SkuMaterialLanguageInfoDTO {
  /** 说明 */
  instr?: string;
  /** 材质信息(英) */
  materialEns?: MaterialDTO[];
  /** 材质信息（日） */
  materialJas?: MaterialDTO[];
  /** 材质信息（韩） */
  materialKrs?: MaterialDTO[];
  /** 材质信息（中） */
  materialZhs?: MaterialDTO[];
}

/** SkuMaterialUpdateVO */
export interface SkuMaterialUpdateVO {
  /** 三级类目 */
  cateCode?: string;
  /** 材质信息集合 */
  productMaterials?: SkuMaterialLanguageInfoDTO[];
  /** SkuCode */
  productSku?: string;
  /** 站点信息 */
  stationCode?: string;
}

/** SkuOperatorLogVO */
export interface SkuOperatorLogVO {
  /** 操作类型编码:MODIFY_DISCOUNT_SKU -> 修改Sku折扣价 */
  operateCode?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 商品spu */
  productCode?: string;
  /** 商品sku */
  productSku?: string;
  /** 供应商编码 */
  shopCode?: string;
  /** @format int32 */
  startIndex?: number;
}

/** SkuProductSimpleRespDTO */
export interface SkuProductSimpleRespDTO {
  productSimpleRespDTO?: ProductSimpleRespDTO;
  skuRespDTO?: SkuRespDTO;
}

/** SkuReqDTO */
export interface SkuReqDTO {
  assignMemberShipProductRate?: number;
  columns?: string[];
  /** @format int64 */
  customerId?: number;
  /** @format int32 */
  isOnline?: number;
  needCalculateSellDiscount?: boolean;
  needCalculateVolume?: boolean;
  needSellDiscountPriceSetting?: boolean;
  productCode?: string;
  productCodeList?: string[];
  productSku?: string;
  productSkuList?: string[];
  recommendProductSku?: string;
  stationCode?: string;
}

/** SkuReqVO */
export interface SkuReqVO {
  /**
   * 客户ID；价格配置需要
   * @format int64
   */
  customerId?: number;
  /**
   * 上下架;1-上架;0-下架
   * @format int32
   */
  isOnline?: number;
  needSellDiscountPriceSetting?: boolean;
  /** 商品编码 */
  productCode?: string;
  /** 商品编码列表 */
  productCodeList?: string[];
  /** 商品SKU */
  productSku?: string;
  /** 商品SKU编码列表 */
  productSkuList?: string[];
  /** 站点 */
  stationCode?: string;
}

/** SkuRespDTO */
export interface SkuRespDTO {
  /** @format int32 */
  availableQty?: number;
  /** @format int32 */
  batchNumber?: number;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  bought?: boolean;
  /** @format int32 */
  channel?: number;
  consignPrice?: number;
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  currency?: string;
  /** @format int64 */
  customerId?: number;
  /** @format double */
  discount?: number;
  discountPriceSetting?: string;
  /** @format double */
  height?: number;
  /** @format int32 */
  hotFlag?: number;
  isInBlank?: boolean;
  isInProductCategoryClose?: boolean;
  isOnePsale?: boolean;
  isOnline?: boolean;
  isOnlineProduct?: boolean;
  /** @format int32 */
  isOnlineSku?: number;
  jxhyPrice?: number;
  /** @format double */
  length?: number;
  liveSellPrice?: number;
  /** @format date-time */
  liveSellPriceEndTime?: string;
  /** @format date-time */
  liveSellPriceStartTime?: string;
  /** @format double */
  maintainHeight?: number;
  /** @format double */
  maintainLength?: number;
  /** @format int64 */
  maintainWeight?: number;
  /** @format double */
  maintainWidth?: number;
  materialInfoEn?: string;
  materialInfoJa?: string;
  materialInfoKr?: string;
  materialInfoZh?: string;
  materialJoinEns?: GoodsMaterialJoinDTO[];
  materialJoinJas?: GoodsMaterialJoinDTO[];
  materialJoinKrs?: GoodsMaterialJoinDTO[];
  materialJoinZhs?: GoodsMaterialJoinDTO[];
  newProductPropertiesName?: string;
  /** @format int32 */
  notInStorage?: number;
  /** @format int32 */
  productBuyMininum?: number;
  productCateCode?: string;
  productCategoryFrontendNdId?: string;
  productCode?: string;
  productCustoms?: ProductCustomsRespDTO;
  /** @format int64 */
  productCustomsId?: number;
  productDetailUrl?: string;
  productItemCategoryZh?: string;
  productOriginSellPrice?: number;
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  productProperties?: string;
  productPropertiesName?: string;
  productPropertiesNameEn?: string;
  productPropertiesNameJa?: string;
  productPropertiesNameParse?: string;
  productPropertiesNameParseEn?: string;
  /** @format int64 */
  productPropertiesSort?: number;
  productSellPrice?: number;
  /** @format int32 */
  productSellPriceType?: number;
  /** @format int32 */
  productSellQuantity?: number;
  productSku?: string;
  productSkuImg?: string;
  /** @format int32 */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  productTitleEn?: string;
  productTitleJp?: string;
  productTitleKr?: string;
  /** 运输属性 */
  productTransportationAttrDTOS?: ProductTransportationAttrDTO[];
  promotionMethod?: string;
  promotionType?: string;
  purchasePrice?: number;
  recommendProductSku?: string;
  reductionAmount?: string;
  season?: string;
  shopCode?: string;
  /** @format int32 */
  shopIsBlack?: number;
  skuId?: string;
  specId?: string;
  stallProductSellPrice?: number;
  stationCode?: string;
  /** @format int32 */
  stationStatus?: number;
  supplierSku?: string;
  taxInfo?: TaxInfoDTO;
  transportationAttrCode?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** SkuRespVO */
export interface SkuRespVO {
  /** @format int32 */
  availableQty?: number;
  /**
   * 商品一手数量
   * @format int32
   */
  batchNumber?: number;
  /** @format int32 */
  blackReasonCode?: number;
  /** @format int32 */
  blackTag?: number;
  /** @format int32 */
  channel?: number;
  consignPrice?: number;
  country?: string;
  currency?: string;
  /** @format int64 */
  customerId?: number;
  /** @format double */
  discount?: number;
  discountPriceSetting?: string;
  /** @format int32 */
  hotFlag?: number;
  isOnePsale?: boolean;
  jxhyPrice?: number;
  liveSellPrice?: number;
  /** @format date-time */
  liveSellPriceEndTime?: string;
  /** @format date-time */
  liveSellPriceStartTime?: string;
  materialInfoJa?: string;
  materialInfoZh?: string;
  /** 商品编码 */
  productCode?: string;
  /** 中文品名 */
  productItemCategoryZh?: string;
  productOriginSellPrice?: number;
  productPriceLadderList?: ProductPriceLadderRespDTO[];
  /** 属性标识 */
  productProperties?: string;
  /** 属性名称 */
  productPropertiesName?: string;
  /** 属性名称(英文) */
  productPropertiesNameEn?: string;
  /** 属性名称parse */
  productPropertiesNameParse?: string;
  productPropertiesNameParseEn?: string;
  /** pc销售单价 */
  productSellPrice?: number;
  /** @format int32 */
  productSellPriceType?: number;
  /**
   * 销售量
   * @format int32
   */
  productSellQuantity?: number;
  /** 平台商品SKU */
  productSku?: string;
  /** sku对应图片 */
  productSkuImg?: string;
  /**
   * 库存
   * @format int32
   */
  productStockQuantity?: number;
  /** @format int32 */
  productTag?: number;
  productTitle?: string;
  productTitleEn?: string;
  productTitleJp?: string;
  productTitleKr?: string;
  promotionMethod?: string;
  promotionType?: string;
  purchasePrice?: number;
  /** 推荐商品SKU */
  recommendProductSku?: string;
  reductionAmount?: string;
  shopCode?: string;
  /** @format int32 */
  shopIsBlack?: number;
  /** 档口价格 */
  stallProductSellPrice?: number;
  stationCode?: string;
  /** @format int32 */
  stationStatus?: number;
  supplierSku?: string;
}

/** SkuTransAndStoragePropertyDTO */
export interface SkuTransAndStoragePropertyDTO {
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /** 商品编码 */
  productSku?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 重，单位kg
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** SkuTransPropertyBatchEditDTO */
export interface SkuTransPropertyBatchEditDTO {
  /** sku编码列表 */
  productSkuList?: string[];
  /** 运输属性code列表 */
  transportationAttrCodeList?: string[];
}

/**
 * SourceCategoryQuery
 * 查询
 */
export interface SourceCategoryQuery {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /**
   * 站点代码:状态0未启用 1启用
   * @format int32
   */
  status?: number;
}

/**
 * SourceCategoryRespDTO
 * 响应结果
 */
export interface SourceCategoryRespDTO {
  /** 线索编码 */
  categoryImage?: string;
  /** 类目中文名称 */
  categoryName?: string;
  /** 类目英文名称 */
  categoryNameEn?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /**
   * 状态 0 未启用 1 启用
   * @format int32
   */
  status?: number;
}

/**
 * SourceFirstReqDTO
 * 获取前几个
 */
export interface SourceFirstReqDTO {
  /**
   * 是否会员 0不是 1是
   * @format int32
   */
  isMember?: number;
  /** @format int32 */
  limit?: number;
  notInIds?: number[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /** 标签 */
  tagCode?: string;
}

/**
 * SourceProductQuery
 * 查询
 */
export interface SourceProductQuery {
  /**
   * 创建结束时间
   * @format date-time
   */
  createEndTime?: string;
  /**
   * 创建开始时间
   * @format date-time
   */
  createStartTime?: string;
  /**
   * 编辑状态 0 未编辑 1 已编辑
   * @format int32
   */
  editStatus?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园 */
  platformType?: string;
  /** 商品编码 */
  productCode?: string;
  /** 商品链接 */
  productUrl?: string;
  sorts?: ISortFieldEnum[];
  /** 线索编码 */
  sourceCode?: string;
  /** @format int32 */
  startIndex?: number;
  /**
   * 状态 0 待上架 1 上架中 2 已上架
   * @format int32
   */
  status?: number;
  /** 标签code */
  tagCode?: string;
  /**
   * 更新结束时间
   * @format date-time
   */
  updateEndTime?: string;
  /**
   * 更新开始时间
   * @format date-time
   */
  updateStartTime?: string;
}

/** SourceProductReqDTO */
export interface SourceProductReqDTO {
  /** 商品编码 */
  productCodes?: string[];
  /** 线索id */
  sourceCode?: string;
}

/**
 * SourceProductTagReqDTO
 * 打标
 */
export interface SourceProductTagReqDTO {
  /** 商品编码 */
  productCode?: string;
  /** 线索code */
  sourceCode?: string;
  /** 标签 */
  tagCodes?: string[];
}

/**
 * SourceProductUniqueReqDTO
 * 线索货源唯一标识
 */
export interface SourceProductUniqueReqDTO {
  /** 商品编码 */
  productCode?: string;
  /** 线索code */
  sourceCode?: string;
}

/**
 * SourceQuery
 * 查询
 */
export interface SourceQuery {
  /**
   * 结束时间
   * @format date-time
   */
  createEndTime?: string;
  /**
   * 开始时间
   * @format date-time
   */
  createStartTime?: string;
  /**
   * 废弃结束时间
   * @format date-time
   */
  invalidateEndTime?: string;
  /**
   * 废弃原因
   * @format int32
   */
  invalidateReason?: number;
  /**
   * 废弃开始时间
   * @format date-time
   */
  invalidateStartTime?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 商品名称 */
  productName?: string;
  /** 结束销售价 */
  sellPriceEnd?: number;
  /** 起始销售价 */
  sellPriceStart?: number;
  /** 排序规则：正序-asc 倒序-desc；默认倒序 */
  sort?: string;
  /**
   * 排序类型 销量-1; 价格-2
   * @format int32
   */
  sortType?: number;
  sorts?: ISortFieldEnum[];
  /**
   * 商品分类
   * @format int64
   */
  sourceCategoryId?: number;
  /** 线索id */
  sourceCode?: string;
  /** 线索标签id */
  sourceTag?: string;
  /** 线索标签id集合 */
  sourceTagList?: string[];
  /** @format int32 */
  startIndex?: number;
  /**
   * 状态 0 待上架 1 已上架 2 已废弃
   * @format int32
   */
  status?: number;
  /**
   * 更新结束时间
   * @format date-time
   */
  updateEndTime?: string;
  /**
   * 更新开始时间
   * @format date-time
   */
  updateStartTime?: string;
}

/**
 * SourceRespDTO
 * 响应结果
 */
export interface SourceRespDTO {
  /**
   * 上架时间
   * @format date-time
   */
  createTime?: string;
  /**
   * id
   * @format int64
   */
  id?: number;
  /**
   * 废弃原因
   * @format int32
   */
  invalidateReason?: number;
  /** 废弃原因描述 */
  invalidateReasonDesc?: string;
  /**
   * 废弃时间
   * @format date-time
   */
  invalidateTime?: string;
  /**
   * 上架时间
   * @format date-time
   */
  onLineTime?: string;
  /** 价格（美金） */
  price?: number;
  /** 商品图片 */
  productImg?: string;
  /** 商品名称 */
  productName?: string;
  /**
   * 销量
   * @format int32
   */
  productSellQuantity?: number;
  /**
   * 同款下架数量
   * @format int32
   */
  sameOffCount?: number;
  /**
   * 相似下架数量
   * @format int32
   */
  similarOffCount?: number;
  /**
   * 商品分类id
   * @format int64
   */
  sourceCategoryId?: number;
  /** 商品分类名称 */
  sourceCategoryName?: string;
  /** 线索id */
  sourceCode?: string;
  /** 线索标签 */
  sourceTagList?: string;
  /** 线索标签名称 */
  sourceTagNames?: string;
  /** 线索标签 */
  sourceTags?: string;
  /** 线索链接 */
  sourceUrl?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /**
   * 状态 0 待上架 1 已上架 2 已废弃
   * @format int32
   */
  status?: number;
  /**
   * 货源更新时间
   * @format date-time
   */
  syncTime?: string;
  /** 线索标签code */
  tagCodes?: string[];
  /**
   * 更新时间
   * @format date-time
   */
  updateTime?: string;
}

/**
 * SourceTagQuery
 * 查询
 */
export interface SourceTagQuery {
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 标签集合 */
  tagCodes?: string[];
  /**
   * 标签类型：1 线索标签 2 货源标签
   * @format int32
   */
  tagType?: number;
}

/**
 * SourceTagReqDTO
 * 打标
 */
export interface SourceTagReqDTO {
  /** @format int64 */
  id?: number;
  /** 标签id */
  sourceCategoryIds?: string[];
}

/**
 * SourceTagRespDTO
 * 响应结果
 */
export interface SourceTagRespDTO {
  /** 操作人 */
  editorName?: string;
  /** @format int64 */
  id?: number;
  /** 标签说明 */
  remark?: string;
  /** 站点代码:JapanStation,KoreaStation,UkStation,US */
  stationCode?: string;
  /** 标签编码 */
  tagCode?: string;
  /** 标签名称 */
  tagName?: string;
  /**
   * 标签类型：1 线索标签 2 货源标签
   * @format int32
   */
  tagType?: number;
  /**
   * 操作时间
   * @format date-time
   */
  updateTime?: string;
}

/** SpuTransAndStoragePropertyDTO */
export interface SpuTransAndStoragePropertyDTO {
  /**
   * 高，单位cm
   * @format double
   */
  height?: number;
  /**
   * 长，单位cm
   * @format double
   */
  length?: number;
  /** 商品编码 */
  productCode?: string;
  /** 运输属性 */
  transportationAttrCodeList?: string[];
  /**
   * 重，单位kg
   * @format int64
   */
  weight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  width?: number;
}

/** StallProductSellPriceUpdateVO */
export interface StallProductSellPriceUpdateVO {
  /** sku */
  productSku?: string;
  /** 档口价格 */
  stallProductSellPrice?: number;
}

/** StrategyConfigProductAddVO */
export interface StrategyConfigProductAddVO {
  /** 用户信息 */
  customerInfoList?: CustomerInfo[];
  /** 是否用户全局 */
  productGlobal?: boolean;
  /** 商品信息 */
  productInfoList?: ProductInfo[];
  /** 站点code */
  stationCode?: string;
  /**
   * 策略结束时间
   * @format date-time
   */
  strategyEndTime?: string;
  /** 策略名称 */
  strategyName?: string;
}

/** StrategyConfigProductEnableStatusVO */
export interface StrategyConfigProductEnableStatusVO {
  /** 启用状态；1：启用；0：不启用 */
  enableStatus?: boolean;
  /**
   * 主键
   * @format int64
   */
  strategyConfigProductId?: number;
}

/** StrategyConfigProductGlobalStatusVO */
export interface StrategyConfigProductGlobalStatusVO {
  /** 是否用户全局；1：全局，0：不全局 */
  productGlobal?: boolean;
  /**
   * 主键
   * @format int64
   */
  strategyConfigProductId?: number;
}

/** StrategyConfigProductItemVO */
export interface StrategyConfigProductItemVO {
  /** 用户信息 */
  customerInfoList?: CustomerInfo[];
  /** 是否用户全局 */
  productGlobal?: boolean;
  /** 商品信息 */
  productInfoList?: ProductInfo[];
  /** 站点code */
  stationCode?: string;
  /**
   * 商品策略主键
   * @format int64
   */
  strategyConfigProductId?: number;
  /**
   * 策略结束时间
   * @format date-time
   */
  strategyEndTime?: string;
  /** 策略名称 */
  strategyName?: string;
}

/** StrategyConfigProductUrlImportVo */
export interface StrategyConfigProductUrlImportVo {
  /**
   * 序号
   * @format int64
   */
  nu?: number;
  /** 商品url */
  productUrl?: string;
}

/** StrategyConfigProductUrlResultVo */
export interface StrategyConfigProductUrlResultVo {
  /** 是否导入成功 */
  importSuccess?: boolean;
  /**
   * 序号
   * @format int64
   */
  nu?: number;
  /** 商品详情 */
  product?: ProductInfo;
  /** 商品url */
  productUrl?: string;
}

/** StrategyConfigProductVO */
export interface StrategyConfigProductVO {
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  enableStatus?: boolean;
  manageUserId?: string;
  manageUserName?: string;
  productGlobal?: boolean;
  stationCode?: string;
  /** @format int64 */
  strategyConfigProductId?: number;
  /** @format date-time */
  strategyEndTime?: string;
  strategyName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** StrategyConfigShopAddVO */
export interface StrategyConfigShopAddVO {
  /** 用户信息 */
  customerInfoList?: CustomerInfo[];
  /** 是否用户全局 */
  shopGlobal?: boolean;
  /** 店铺类目 */
  shopTypeInfoList?: ShopTypeInfo[];
  /** 站点code */
  stationCode?: string;
  /**
   * 策略结束时间
   * @format date-time
   */
  strategyEndTime?: string;
  /** 策略名称 */
  strategyName?: string;
}

/** StrategyConfigShopEnableStatusVO */
export interface StrategyConfigShopEnableStatusVO {
  /** 启用状态；1：启用；0：不启用 */
  enableStatus?: boolean;
  /**
   * 主键
   * @format int64
   */
  strategyConfigShopId?: number;
}

/** StrategyConfigShopGlobalStatusVO */
export interface StrategyConfigShopGlobalStatusVO {
  /** 是否用户全局；1：全局，0：不全局 */
  shopGlobal?: boolean;
  /**
   * 主键
   * @format int64
   */
  strategyConfigShopId?: number;
}

/** StrategyConfigShopItemVO */
export interface StrategyConfigShopItemVO {
  /** 用户信息 */
  customerInfoList?: CustomerInfo[];
  /** 是否用户全局 */
  shopGlobal?: boolean;
  /** 店铺类目信息 */
  shopTypeInfoList?: ShopTypeInfo[];
  /** 站点code */
  stationCode?: string;
  /**
   * 商品策略主键
   * @format int64
   */
  strategyConfigShopId?: number;
  /**
   * 策略结束时间
   * @format date-time
   */
  strategyEndTime?: string;
  /** 策略名称 */
  strategyName?: string;
}

/** StrategyConfigShopUrlImportVo */
export interface StrategyConfigShopUrlImportVo {
  /**
   * 序号
   * @format int64
   */
  nu?: number;
  /** 商品url */
  shopUrl?: string;
}

/** StrategyConfigShopUrlResultVo */
export interface StrategyConfigShopUrlResultVo {
  /** 是否导入成功 */
  importSuccess?: boolean;
  /**
   * 序号
   * @format int64
   */
  nu?: number;
  /** 店铺详情 */
  shopInfo?: ShopInfo;
  /** shopUrl */
  shopUrl?: string;
}

/** StrategyConfigShopVo */
export interface StrategyConfigShopVo {
  /** @format date-time */
  createTime?: string;
  deleteFlag?: boolean;
  enableStatus?: boolean;
  manageUserId?: string;
  manageUserName?: string;
  shopGlobal?: boolean;
  stationCode?: string;
  /** @format int64 */
  strategyConfigShopId?: number;
  /** @format date-time */
  strategyEndTime?: string;
  strategyName?: string;
  /** @format date-time */
  updateTime?: string;
}

/** SupplierDetailSaveReqDTO */
export interface SupplierDetailSaveReqDTO {
  /** 工厂数据 */
  factory_info?: SupplierFactoryInfoDTO;
  /** 店铺参数 */
  seller_info?: SupplierShopInfoDTO;
}

/** SupplierFactoryInfoDTO */
export interface SupplierFactoryInfoDTO {
  /** 履约率 */
  compliance_rate?: string;
  /** 定制起订量 */
  customized_minimum_order_quantity?: string;
  /** 次品率 */
  defective_rate?: string;
  /** 厂房面积 */
  factory_area?: string;
  /** 工厂牌评级 */
  factory_brand_rating?: string;
  /** 市 */
  factory_city?: string;
  /** 工厂联系方式 */
  factory_concat_num?: string;
  /** 工厂联系人 */
  factory_concat_person?: string;
  /** 工厂详细地址 */
  factory_detail_address?: string;
  /** 区 */
  factory_district?: string;
  /** 工厂主营类目 */
  factory_main_sell?: string[];
  /** 工厂memberId */
  factory_member_code?: string;
  /** 工厂名称 */
  factory_name?: string;
  /** 工厂人数 */
  factory_number_employees?: string;
  /** 省 */
  factory_province?: string;
  /** 工厂链接 */
  factory_url?: string;
  /**
   * 是否金牌制造:0-不是,1-是
   * @format int32
   */
  is_gold_medal?: number;
  /**
   * 是否实力商家:0-不是,1-是
   * @format int32
   */
  is_power_seller?: number;
  /**
   * 是否超级工厂:0-不是,1-是
   * @format int32
   */
  is_super_factory?: number;
  /** 管理体系认证 */
  management_system_certification?: string;
  /** 平台编码 */
  platform_code?: string;
  /** 生产质量认证 */
  production_quality_certification?: string;
  /** 复购率 */
  repurchase_rate?: string;
  /** 服务响应率 */
  service_response_rate?: string;
}

/** SupplierFactoryRespDTO */
export interface SupplierFactoryRespDTO {
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** 市 */
  factoryCity?: string;
  /** 市代码 */
  factoryCityCode?: string;
  /** 工厂联系方式 */
  factoryConcatNum?: string;
  /** 工厂联系人 */
  factoryConcatPerson?: string;
  /** 区 */
  factoryDistrict?: string;
  /** 区代码 */
  factoryDistrictCode?: string;
  /** 工厂详细地址 */
  factoryLocation?: string;
  /** 工厂主营类目名称;格式","分隔 */
  factoryMajorCateName?: string;
  /** 工厂memberCode */
  factoryMemberCode?: string;
  /** 卖家店铺名 */
  factoryName?: string;
  /** 国家 */
  factoryNation?: string;
  /** 国家代码 */
  factoryNationCode?: string;
  /** 省 */
  factoryProvince?: string;
  /** 省代码 */
  factoryProvinceCode?: string;
  /** 工厂标签 */
  factoryTag?: string;
  /** 标签列表 */
  factoryTagList?: string[];
  /** 工厂URL */
  factoryUrl?: string;
  /** @format int64 */
  id?: number;
  /**
   * 是否金牌制造:0-不是,1-是
   * @format int32
   */
  isGoldMedal?: number;
  /**
   * 是否实力商家:0-不是,1-是
   * @format int32
   */
  isPowerSeller?: number;
  /**
   * 是否超级工厂:0-不是,1-是
   * @format int32
   */
  isSuperFactory?: number;
  /** Oem供应商准入考核数据json:工厂规模,价格,次品率,履约率,服务响应率,复购率 */
  oemSupplierOriginalInfoJson?: string;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** SupplierInfo */
export interface SupplierInfo {
  /** 国家 */
  country?: string;
  /** 币种 */
  currency?: string;
  /** 平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款;WS:网商园; */
  platformType?: string;
  /** 卖家联系综合信息;包括qq,wx,电话号码等 */
  sellerContactInfo?: object;
  /** 店铺编码 */
  shopCode?: string;
  /** 档口号 */
  shopDoor?: string;
  /** 档口楼层 */
  shopFloor?: string;
  /** 店铺所在地;省市区 */
  shopLocation?: string;
  /** 店铺主营类目编码-一级；格式","分隔 */
  shopMajorCateCode?: string;
  /** 店铺主营类目名称;格式","分隔 */
  shopMajorCateName?: string;
  /** 档口市场 */
  shopMall?: string;
  /** 卖家店铺名 */
  shopName?: string;
  /** 店铺服务信息；综合服务,物流等;格式json对象 */
  shopServiceInfo?: object;
  /** 店铺URL */
  shopUrl?: string;
}

/** SupplierListReqDTO */
export interface SupplierListReqDTO {
  /** @format int32 */
  blackTag?: number;
  platformType?: string;
  /** 店铺编码列表 */
  shopCodeList?: string[];
  /** 店铺名称列表 */
  shopNameList?: string[];
  /** 店铺url */
  shopUrls?: string[];
  stationCode?: string;
  /** @format int32 */
  status?: number;
}

/** SupplierManageListQueryVO */
export interface SupplierManageListQueryVO {
  /**
   * 黑名单标记
   * @format int32
   */
  blackTag?: number;
  bought?: boolean;
  /** @format int32 */
  channel?: number;
  /** 清空推荐Sku原因是否为空 */
  clearRecommendReasonIsNull?: boolean;
  /** 国家 */
  country?: string;
  /** excludeProductSku */
  excludeProductSku?: string;
  /**
   * 首次加购或关联结束时间
   * @format date-time
   */
  firstCartOrApiTimeEnd?: string;
  /**
   * 首次加购或关联开始时间
   * @format date-time
   */
  firstCartOrApiTimeStart?: string;
  /**
   * 首次下单结束时间
   * @format date-time
   */
  firstOrderTimeEnd?: string;
  /**
   * 首次下单开始时间
   * @format date-time
   */
  firstOrderTimeStart?: string;
  /**
   * 是否需要补充中文材质:1需要,0不需要
   * @format int32
   */
  isNeedMaterial?: number;
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  /**
   * 是否下过采购订单: 0 未下 1已下
   * @format int32
   */
  isPurchase?: number;
  /** 待补充英文材质 */
  materialInfoEnIsEmptyString?: boolean;
  materialInfoJaIsEmptyString?: boolean;
  /** 待补充韩文材质 */
  materialInfoKrIsEmptyString?: boolean;
  materialInfoZhIsEmptyString?: boolean;
  /**
   * 最近下单结束时间
   * @format date-time
   */
  newOrderTimeEnd?: string;
  /**
   * 最近下单开始时间
   * @format date-time
   */
  newOrderTimeStart?: string;
  /**
   * 最新采购订单结束时间
   * @format date-time
   */
  newPurchaseOrderTimeEnd?: string;
  /**
   * 最新采购订单开始时间
   * @format date-time
   */
  newPurchaseOrderTimeStart?: string;
  /**
   * 线下商品直营标识 0-普通 1-直营
   * @format int32
   */
  offlineDirectSaleFlag?: number;
  /** @format int32 */
  pageNum?: number;
  /**
   * 第几页结束
   * @format int32
   */
  pageNumEnd?: number;
  /**
   * 第几页开始
   * @format int32
   */
  pageNumStart?: number;
  /** @format int32 */
  pageSize?: number;
  platformType?: string;
  productCode?: string;
  productCodeList?: string[];
  productItemCategoryZhIsNull?: boolean;
  productSku?: string;
  /** 商品SKU批量搜索 */
  productSkuList?: string[];
  /**
   * 商品标签 1 精选货源
   * @format int32
   */
  productTag?: number;
  /** 商品名称 */
  productTitle?: string;
  /** 商品采购链接 */
  productUrl?: string;
  /**
   * 查询来源 1 推荐Sku
   * @format int32
   */
  queryFrom?: number;
  /** 推荐商品sku */
  recommendProductSku?: string;
  /** 待补充推荐商品sku */
  recommendProductSkuIsEmptyString?: boolean;
  /** 推荐商品sku批量搜索 */
  recommendProductSkuList?: string[];
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
  /** 供应商id */
  supplierId?: string;
  /** 供应商名称 */
  supplierName?: string;
  version?: string;
}

/** SupplierManageListVO */
export interface SupplierManageListVO {
  /**
   * 可用库存
   * @format int32
   */
  availableQuantity?: number;
  /** @format int32 */
  blackTag?: number;
  bought?: boolean;
  /** @format int32 */
  channel?: number;
  /** @format int32 */
  clearRecommendReason?: number;
  /** 一件代发价格 */
  consignPrice?: number;
  country?: string;
  /**
   * 国家货盘标签 1 国家货盘
   * @format int32
   */
  countryProductTag?: number;
  /** @format date-time */
  createTime?: string;
  currency?: string;
  currencyProductSellPrice?: number;
  /** @format double */
  discount?: number;
  /**
   * 首次关联时间
   * @format date-time
   */
  firstApiTime?: string;
  /**
   * 首次加购时间
   * @format date-time
   */
  firstCartTime?: string;
  /**
   * 首次下单时间
   * @format date-time
   */
  firstOrderTime?: string;
  /** @format double */
  height?: number;
  /** @format int32 */
  hotFlag?: number;
  /** @format int32 */
  isNeedManageMaterial?: number;
  /** @format int32 */
  isNeedMaterial?: number;
  isNeedMaterialVersion?: string;
  /** 是否一件代发(ture:是) */
  isOnePsale?: boolean;
  /** @format int32 */
  isOnline?: number;
  /** @format int32 */
  isPurchase?: number;
  jxhyPrice?: number;
  /** @format double */
  length?: number;
  liveSellPrice?: number;
  /** @format date-time */
  liveSellPriceEndTime?: string;
  /** @format date-time */
  liveSellPriceStartTime?: string;
  /** @format int32 */
  maintainFlag?: number;
  /** @format double */
  maintainHeight?: number;
  /** @format double */
  maintainLength?: number;
  maintainManagerId?: string;
  /** @format int64 */
  maintainWeight?: number;
  /** @format double */
  maintainWidth?: number;
  /** @format date-time */
  mantainTime?: string;
  /** 材质信息英文 */
  materialInfoEn?: string;
  materialInfoEnJson?: string;
  /** 材质信息日文 */
  materialInfoJa?: string;
  materialInfoJaJson?: string;
  /** 材质信息韩文 */
  materialInfoKr?: string;
  materialInfoKrJson?: string;
  /** 材质信息中文 */
  materialInfoZh?: string;
  materialInfoZhJson?: string;
  /**
   * 最近下单时间
   * @format date-time
   */
  newOrderTime?: string;
  /** @format date-time */
  newPurchaseOrderTime?: string;
  /** @format int32 */
  offlineDirectSaleFlag?: number;
  platformType?: string;
  /** 商品信息 */
  product?: SupplierManageListVOProductInfo;
  productAppSellPrice?: number;
  /** 商品编码 */
  productCode?: string;
  /**
   * 商品评论数
   * @format int32
   */
  productCommentCount?: number;
  /** @format int64 */
  productCustomsId?: number;
  /** 中文品名 */
  productItemCategoryZh?: string;
  /** 材质信息集合 */
  productMaterials?: SkuMaterialLanguageInfoDTO[];
  productOriginSellPrice?: number;
  productProperties?: string;
  /** 属性名称 */
  productPropertiesName?: string;
  productPropertiesNameEn?: string;
  productPropertiesNameJa?: string;
  /** 销售单价 */
  productSellPrice?: number;
  /** @format int32 */
  productSellQuantity?: number;
  /** 尺码属性名称 */
  productSizePropertiesName?: string;
  /** sniff生成超级ID基础码 */
  productSku?: string;
  /** @format int64 */
  productSkuId?: number;
  /** 商品sku图 */
  productSkuImg?: string;
  /** @format int32 */
  productStockQuantity?: number;
  /**
   * 商品标签 1 精选货源
   * @format int32
   */
  productTag?: number;
  promotionMethod?: string;
  promotionType?: string;
  purchasePrice?: number;
  /** 推荐商品SKU */
  recommendProductSku?: string;
  /** 推荐SKU信息 */
  recommendProductSkuInfo?: Sku;
  reductionAmount?: string;
  skuId?: string;
  /** 商品沉淀数据 */
  skuKpi?: SkuKpiInfo;
  specId?: string;
  stallProductSellPrice?: number;
  /** 供应商信息 */
  supplier?: SupplierInfo;
  supplierSku?: string;
  transportationAttrCode?: string;
  /** 运输属性code列表 */
  transportationAttrCodeList?: string[];
  /** 运输属性名称 */
  transportationAttrName?: string;
  /** @format date-time */
  updateTime?: string;
  /** @format int64 */
  weight?: number;
  /** @format double */
  width?: number;
}

/** SupplierManageListVOProductInfo */
export interface SupplierManageListVOProductInfo {
  /** 国家 */
  country?: string;
  /** @format int32 */
  countryProductTag?: number;
  /** 币种 */
  currency?: string;
  /** 完整层级类目名称 */
  intactCateName?: string;
  /**
   * 是否有效：1:有效;0:无效;2:备用
   * @format int32
   */
  isOnline?: number;
  /**
   * 高，单位cm
   * @format double
   */
  maintainHeight?: number;
  /**
   * 长，单位cm
   * @format double
   */
  maintainLength?: number;
  /**
   * 重，单位g
   * @format int64
   */
  maintainWeight?: number;
  /**
   * 宽，单位cm
   * @format double
   */
  maintainWidth?: number;
  /**
   * 直营商城标识
   * @format int32
   */
  offlineDirectSaleFlag?: number;
  /** 类目编码 */
  productCateCode?: string;
  /** 商品编码 */
  productCode?: string;
  /** sniff商品详情URL */
  productDetailSniffUrl?: string;
  /** 商品url */
  productDetailUrl?: string;
  /** 商品轮播图 */
  productItemImgs?: ProductImageUrlDTO[];
  /** 商品主图 */
  productMainImg?: string;
  /** 商品价格 */
  productSellPrice?: number;
  /** 商品货号 */
  productStallNumber?: string;
  /**
   * 商品标签 1 精选货源
   * @format int32
   */
  productTag?: number;
  /** 商品标题 */
  productTitle?: string;
  /** 供应商id */
  supplierId?: string;
  /** 供应商名称 */
  supplierName?: string;
  /** 供应商款式编码 */
  supplierSpu?: string;
  /** 第三方商品类目编码 */
  thirdProductCateCode?: string;
  /** 三方叶子类目 */
  thirdProductCateName?: string;
  /** 三方叶子类目对应中文品名 */
  thirdProductCategoryZh?: string;
  /** 运输属性 */
  transportationAttrCode?: string;
}

/** SupplierManageSkuCountInfoVo */
export interface SupplierManageSkuCountInfoVo {
  /**
   * 待补充材质日文数量
   * @format int64
   */
  materialInfoJaEmptyCount?: number;
  /**
   * 待补充材质中文数量
   * @format int64
   */
  materialInfoZhEmptyCount?: number;
  /**
   * 未关联中文品名数量
   * @format int64
   */
  notAssociatedProductItemCategoryZhNumber?: number;
  /**
   * 待维护阴阳id
   * @format int64
   */
  waitRecommendProductCount?: number;
}

/** SupplierOperateBlackFlagDTO */
export interface SupplierOperateBlackFlagDTO {
  /**
   * 加黑原因
   * @format int32
   */
  blackReasonCode?: number;
  /** 审核拒绝原因 */
  rejectReason?: string;
  /** 供应商编码列表 */
  shopCodeList?: string[];
  /** 操作人id */
  userId?: string;
  /** 操作人姓名 */
  userName?: string;
}

/** SupplierPaymentAccountRespDTO */
export interface SupplierPaymentAccountRespDTO {
  /** 账号 */
  account?: string;
  /** 户名 */
  accountName?: string;
  /** 开户行 */
  accountOpeningBank?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** 创建者 */
  creatorId?: string;
  /** @format int64 */
  id?: number;
  /**
   * 是否默认账号
   * @format int32
   */
  isDefault?: number;
  /** 收款账户名 */
  paymentAccountName?: string;
  /**
   * 店铺code
   * @format int32
   */
  supplierShopCode?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  /** 更新者 */
  updaterId?: string;
}

/** SupplierPerformanceSyncRespDTO */
export interface SupplierPerformanceSyncRespDTO {
  /** 平均单价 */
  averageUnitPrice?: number;
  /** 议价率 */
  bargainingRate?: number;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** 累计金额 */
  cumulativeAmount?: number;
  /** 次品率 */
  defectiveRate?: number;
  /** @format int64 */
  id?: number;
  /**
   * 最近下单时间
   * @format date-time
   */
  lastOrderTime?: string;
  /** OEM次品率 */
  oemDefectiveRate?: number;
  /** OEM交付超期率 */
  oemDeliveryOverdueRate?: number;
  /**
   * 采购商品数
   * @format int32
   */
  purchaseItemNum?: number;
  /**
   * 采购次数
   * @format int32
   */
  purchaseTimes?: number;
  /** 退款率 */
  refundRate?: number;
  /**
   * 回货时长
   * @format int32
   */
  returnTime?: number;
  /** 店铺编码 */
  supplierShopCode?: string;
  /**
   * 店铺id
   * @format int32
   */
  supplierShopId?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** SupplierProductRespDTO */
export interface SupplierProductRespDTO {
  productPage?: PageSearchProductRespDTO;
  supplierRespDTO?: SupplierRespDTO;
}

/** SupplierReqDTO */
export interface SupplierReqDTO {
  /** @format int32 */
  pageSize?: number;
  shopCode?: string;
  shopName?: string;
  shopUrl: string;
}

/** SupplierRespDTO */
export interface SupplierRespDTO {
  /** @format int32 */
  behaviorFlag?: number;
  /** @format int32 */
  channel?: number;
  city?: string;
  discountRate?: string;
  /** @format int32 */
  favoriteFlag?: number;
  marketCode?: string;
  platformType?: string;
  provice?: string;
  sellerContactInfo?: object;
  shopCode?: string;
  shopDescription?: string;
  shopDistrict?: string;
  shopDoor?: string;
  shopFloor?: string;
  shopLocation?: string;
  shopMainImg?: string;
  shopMajorCateCode?: string;
  shopMajorCateName?: string;
  shopMajorCateNameEn?: string;
  shopMajorCateNameJp?: string;
  shopMajorCateNameKr?: string;
  shopMall?: string;
  shopName?: string;
  shopPosition?: string;
  shopServiceInfo?: object;
  shopUrl?: string;
  /** @format int32 */
  status?: number;
  /**
   * 实力档口 1：实力 0:非实力
   * @format int32
   */
  strongSupplier?: number;
}

/** SupplierSaveReqDTO */
export interface SupplierSaveReqDTO {
  /**
   * 供应商状态;0:禁用;1:启用;
   * @format int32
   */
  status?: number;
  /** 店铺编码 */
  supplierShopCode?: string;
}

/** SupplierSettlementRespDTO */
export interface SupplierSettlementRespDTO {
  /**
   * 账期结算方式:1-按月,2-按周
   * @format int32
   */
  accountSettlementMethod?: number;
  /**
   * 账期结算日期:周一到周日1234567
   * @format int32
   */
  accountSettlementTime?: number;
  /** 实际折扣 */
  actualDiscount?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** @format int64 */
  id?: number;
  /** 分期付款额度百分比，共三期 */
  installmentPercentage?: number[];
  /** 支付方式 */
  payMethod?: string;
  /** 优惠方式:1-改价,2-返金 */
  promotionMethod?: string;
  /** 优惠备注 */
  promotionRemark?: string;
  /**
   * 结算方式:1-按采购单,2-按账期,3-分期付款
   * @format int32
   */
  settlementMethod?: number;
  /** 统一社会信用代码 */
  socialCreditCode?: string;
  /**
   * 店铺code
   * @format int32
   */
  supplierShopCode?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
}

/** SupplierShopAndProductsRespDTO */
export interface SupplierShopAndProductsRespDTO {
  /**
   * 渠道;1-档口(市场购);2-线上平台(透明购):3-线下合作
   * @format int32
   */
  channel?: number;
  /** 国家 */
  country?: string;
  /** 币种 */
  currency?: string;
  /** @format int64 */
  id?: number;
  /** 原始卖家店铺id */
  originalShopId?: string;
  /** 原始卖家店铺名 */
  originalShopName?: string;
  /** 来源平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  platformType?: string;
  /** 店铺商品信息列表 */
  productList?: ProductInfo[];
  /** 采购渠道:TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  purchaseChannel?: string;
  /** 旺旺id */
  shopCustomerServiceId?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 店铺URL */
  shopUrl?: string;
  /** 店铺编码 */
  supplierShopCode?: string;
  /** 店铺编码 */
  supplierShopName?: string;
  /**
   * 供应商类型:1-成品,2-OEM,3-成品和OEM
   * @format int32
   */
  supplierType?: number;
}

/** SupplierShopCustomerServiceRespDTO */
export interface SupplierShopCustomerServiceRespDTO {
  /** 店铺编码 */
  shopCode?: string;
  /** 旺旺id */
  shopCustomerServiceId?: string;
}

/** SupplierShopInfoDTO */
export interface SupplierShopInfoDTO {
  /** 档口市场编码 */
  category_code?: string;
  /** 履约率 */
  compliance_rate?: string;
  /** 综合服务评分 */
  comprehensive_service_rating?: string;
  /** 档口楼层 */
  dk_floor?: string;
  /** 档口市场 */
  dk_market?: string;
  /** 档口号 */
  dk_number?: string;
  /** 工厂memberId */
  factory_member_code?: string;
  /**
   * 是否有工厂:0-没有,1-有
   * @format int32
   */
  is_having_factory?: number;
  /** 店铺主营类目 */
  main_sell?: string[];
  /** 近30天支付订单数 */
  number_pay_orders_amonth?: string;
  /** 平台编码 */
  platform_code?: string;
  /** 揽收率 */
  recovery_rate?: string;
  /** 退款率 */
  refund_rate?: string;
  /** 响应率 */
  response_rate?: string;
  /** 市 */
  shop_city?: string;
  /** 店铺编码 */
  shop_code?: string;
  /** 旺旺id */
  shop_customer_service_id?: string;
  /** 店铺详细地址 */
  shop_detail_address?: string;
  /** 区 */
  shop_district?: string;
  /** 店铺ID */
  shop_id?: string;
  /** 店铺主图 */
  shop_main_img?: string;
  shop_major_cate_name_language?: SellerMajorCateNameLanguageDTO;
  /** 店铺名称 */
  shop_name?: string;
  /** 省 */
  shop_province?: string;
  /** 店铺链接 */
  shop_url?: string;
}

/** SupplierShopQueryVO */
export interface SupplierShopQueryVO {
  /**
   * 黑名单标记:0-不是,1-是
   * @format int32
   */
  blackTag?: number;
  /** 国家 */
  country?: string;
  /** 降序 */
  descendOrder?: boolean;
  /**
   * 结束时间
   * @format date-time
   */
  endTime?: string;
  /**
   * 排除黑名单标记:0-不是,1-是
   * @format int32
   */
  isExcludeblackTag?: number;
  /**
   * 排除黑名单待审核状态:0-不是,1-是
   * @format int32
   */
  isExcludewaitAuditFlag?: number;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 平台类型:TB:淘宝;AM:1688;TM:天猫;VC搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  platformType?: string;
  /** 采购渠道:TB:淘宝;AM:1688;TM:天猫;VC搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  purchaseChannel?: string;
  /** 采购员id */
  purchaserId?: string;
  /**
   * 查询类型: 1-供应商列表, 2-黑名单待审核列表, 3-黑名单列表
   * @format int32
   */
  queryType?: number;
  /** 店铺主营类目名称 */
  shopMajorCateName?: string;
  /** 排序字段; (默认): default; 销售额: platform_sales; */
  sortType?: string;
  /** @format int32 */
  startIndex?: number;
  /**
   * 开始时间
   * @format date-time
   */
  startTime?: string;
  stationCode?: string;
  /** 状态 0:禁用;1:启用 */
  status?: string;
  /**
   * 实力档口
   * @format int32
   */
  strongSupplier?: number;
  /** 供应商名称 */
  supplierShopName?: string;
  /**
   * 供应商类型:1-成品,2-OEM,3-成品和OEM
   * @format int32
   */
  supplierType?: number;
  /** 供应商类型列表:1-成品,2-OEM,3-成品和OEM */
  supplierTypeList?: number[];
  /**
   * 黑名单待审核状态:0-不是,1-是
   * @format int32
   */
  waitAuditFlag?: number;
}

/** SupplierShopRespDTO */
export interface SupplierShopRespDTO {
  /**
   * 添加方式:1-系统,2-手动
   * @format int32
   */
  addMethod?: number;
  /** 附件地址 */
  appendix?: string;
  /** 基本资质 */
  basicQualifications?: string;
  /**
   * 黑名单加入时间
   * @format date-time
   */
  blackAddTime?: string;
  /** 黑名单原因 */
  blackReason?: string;
  /**
   * 黑名单原因编码
   * @format int32
   */
  blackReasonCode?: number;
  /**
   * 黑名单标记:0-不是,1-是
   * @format int32
   */
  blackTag?: number;
  /** 黑名单操作员id */
  blackUserId?: string;
  /** 黑名单操作员id */
  blackUserName?: string;
  /** 品牌id */
  brandId?: string;
  /** 品牌名称 */
  brandName?: string;
  /**
   * 渠道;1-档口(市场购);2-线上平台(透明购):3-线下合作
   * @format int32
   */
  channel?: number;
  /** 国家 */
  country?: string;
  /**
   * 创建日期
   * @format date-time
   */
  createTime?: string;
  /** 币种 */
  currency?: string;
  /** 额外信息json:基本资质,是否有廉政协议,供应商优势,推荐原因 */
  extraInfoJson?: string;
  /** 工厂信息code */
  factoryMemberCode?: string;
  /**
   * 次品处理方式:1-直接退款,2-退货退款,3-退货返修
   * @format int32
   */
  handleDefectiveMethod?: number;
  /** @format int64 */
  id?: number;
  /**
   * 是否自有工厂
   * @format int32
   */
  isHavingFactory?: number;
  /**
   * 是否有廉政协议
   * @format int32
   */
  isHavingIntegrityAgreement?: number;
  /**
   * 是否支持定制:0-不支持,1-支持
   * @format int32
   */
  isSupportCustomization?: number;
  /** 市场编码 */
  marketCode?: string;
  /** 员工人数 */
  numberEmployees?: string;
  /** oem评级 */
  oemSorceLevel?: string;
  /**
   * 操作人id
   * @format int64
   */
  operatorId?: number;
  /** 操作人名称 */
  operatorName?: string;
  /** 原始卖家店铺id */
  originalShopId?: string;
  /** 原始卖家店铺名 */
  originalShopName?: string;
  /** 来源平台类型;TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  platformType?: string;
  /** 成品评级 */
  productSorceLevel?: string;
  /** 成品供应商准入考核数据json:揽收率,履约率,退款率,响应率,综合服务评分,近30天支付订单数 */
  productSupplierOriginalInfoJson?: string;
  /** 采购渠道:TB:淘宝;AM:1688;TM:天猫;VC:搜款网;WS:网商园;YW:义乌小商品市场;OL:线下 */
  purchaseChannel?: string;
  /** 采购员id */
  purchaserId?: string;
  /** 采购员名字 */
  purchaserName?: string;
  /** 推荐原因 */
  reasonsForRecommendation?: string;
  /** 拒绝原因 */
  rejectReason?: string;
  /** 备注 */
  remark?: string;
  /** 供应商联系电话 */
  sellerContactMobilePhone?: string;
  /** 供应商联系人 */
  sellerContactPerson?: string;
  /** 市 */
  shopCity?: string;
  /** 市代码 */
  shopCityCode?: string;
  /** 店铺编码 */
  shopCode?: string;
  /** 旺旺id */
  shopCustomerServiceId?: string;
  /** 区 */
  shopDistrict?: string;
  /** 区代码 */
  shopDistrictCode?: string;
  /** 档口号 */
  shopDoor?: string;
  /** 档口楼层 */
  shopFloor?: string;
  /** 详细地址 */
  shopLocation?: string;
  /** 店铺主图 */
  shopMainImg?: string;
  /** 店铺主营类目名称;格式","分隔 */
  shopMajorCateName?: string;
  shopMajorCateNameEn?: string;
  shopMajorCateNameJp?: string;
  shopMajorCateNameKr?: string;
  /** 档口市场 */
  shopMall?: string;
  /** 卖家店铺名 */
  shopName?: string;
  /** 国家 */
  shopNation?: string;
  /** 国家代码 */
  shopNationCode?: string;
  /** 省 */
  shopProvince?: string;
  /** 省代码 */
  shopProvinceCode?: string;
  /** 店铺URL */
  shopUrl?: string;
  /**
   * 供应商状态;0:禁用;1:启用;
   * @format int32
   */
  status?: number;
  /**
   * 实力档口 1：实力 0:非实力
   * @format int32
   */
  strongSupplier?: number;
  /** 供应商优势 */
  supplierAdvantages?: string;
  /** 供应商工厂信息 */
  supplierFactoryRespDTO?: SupplierFactoryRespDTO;
  /** 供应商收款信息 */
  supplierPaymentAccountRespDTOS?: SupplierPaymentAccountRespDTO[];
  /** 供应商履约信息 */
  supplierPerformanceSyncRespDTO?: SupplierPerformanceSyncRespDTO;
  /** 供应商结算信息 */
  supplierSettlementRespDTO?: SupplierSettlementRespDTO;
  /** 店铺编码 */
  supplierShopCode?: string;
  /** 店铺编码 */
  supplierShopName?: string;
  /**
   * 供应商类型:1-成品,2-OEM,3-成品和OEM
   * @format int32
   */
  supplierType?: number;
  /**
   * 更新日期
   * @format date-time
   */
  updateTime?: string;
  /**
   * 黑名单待审核状态:0-不是,1-是
   * @format int32
   */
  waitAuditFlag?: number;
}

/** SupplierSimilarSearchReqDTO */
export interface SupplierSimilarSearchReqDTO {
  /** @format int64 */
  customerId?: number;
  dislikeShopCodeList?: string[];
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  shopCode?: string;
  /** @format int32 */
  startIndex?: number;
  stationCode?: string;
}

/** SyncSupplierReq */
export interface SyncSupplierReq {
  productCode?: string;
  shopCode?: string;
  shopUrl?: string;
}

/** TaskMeta */
export interface TaskMeta {
  aliasName?: string;
  businessSerializeInfo?: string;
  nexts?: TaskMeta[];
  /** @format int32 */
  stepId?: number;
  /** @format int32 */
  timeout?: number;
}

/** TaxInfoDTO */
export interface TaxInfoDTO {
  hscode?: string;
  taxRate?: number;
}

/** TranslateCommonTextReqDTO */
export interface TranslateCommonTextReqDTO {
  from?: string;
  text?: string;
  to?: string;
}

/** TranslateReqVo */
export interface TranslateReqVo {
  /** 翻译后语言代码:zh-中文,ja-日语,ko-韩语,en-英语 */
  afterLanguageCode?: string;
  /** 原语言代码:zh-中文,ja-日语,ko-韩语,en-英语 */
  beforeLanguageCode?: string;
  /** 关键字 */
  keyword?: string;
}

/** TranslateTextReqDTO */
export interface TranslateTextReqDTO {
  text?: string;
}

/** URI */
export interface URI {
  absolute?: boolean;
  authority?: string;
  fragment?: string;
  host?: string;
  opaque?: boolean;
  path?: string;
  /** @format int32 */
  port?: number;
  query?: string;
  rawAuthority?: string;
  rawFragment?: string;
  rawPath?: string;
  rawQuery?: string;
  rawSchemeSpecificPart?: string;
  rawUserInfo?: string;
  scheme?: string;
  schemeSpecificPart?: string;
  userInfo?: string;
}

/** URL */
export interface URL {
  authority?: string;
  content?: object;
  /** @format int32 */
  defaultPort?: number;
  deserializedFields?: URLStreamHandler;
  file?: string;
  host?: string;
  path?: string;
  /** @format int32 */
  port?: number;
  protocol?: string;
  query?: string;
  ref?: string;
  /** @format int32 */
  serializedHashCode?: number;
  userInfo?: string;
}

/** URLStreamHandler */
export type URLStreamHandler = object;

/** UpdateFollowUserVO */
export interface UpdateFollowUserVO {
  /** 产品图册编码列表 */
  atlasCodes?: string[];
  /** 跟进人id */
  followUserId?: string;
  /** 跟进人姓名 */
  followUserName?: string;
}

/** UpdateProductLabelsVO */
export interface UpdateProductLabelsVO {
  /** 产品图册编码列表 */
  atlasCode?: string[];
  /** 标签列表 */
  labelIds?: number[];
}

/**
 * UpdateSourceImgReqDTO
 * 爬虫回调修改图片
 */
export interface UpdateSourceImgReqDTO {
  /** 图片链接 */
  productImg?: string;
  /** 线索code */
  sourceCode?: string;
}

/** UpdateStockDetailReqDTO */
export interface UpdateStockDetailReqDTO {
  /** @format int32 */
  changeQty?: number;
  orderNo?: string;
  productSku?: string;
}

/** UpdateStockReqDTO */
export interface UpdateStockReqDTO {
  detailReqDTOS?: UpdateStockDetailReqDTO[];
  operateUserId?: string;
  operateUserName?: string;
  operationType?: string;
  requestId?: string;
}

/** UserImageUsageAddReqDTO */
export interface UserImageUsageAddReqDTO {
  /** 商品编码 */
  productCode?: string;
  /**
   * 统一用户id
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 使用时间
   * @format date-time
   */
  userTime?: string;
}

/**
 * UserImageUsageRespDTO
 * 用户无水印使用详情
 */
export interface UserImageUsageRespDTO {
  /**
   * 最大使用次数 -1 无限制
   * @format int32
   */
  maxNum?: number;
  /**
   * 本月使用次数
   * @format int32
   */
  num?: number;
}

/** WishListDTO */
export interface WishListDTO {
  /** 图册code */
  atlasCode?: string;
  /**
   * 创建时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 客户ID
   * @format int64
   */
  customerId?: number;
  /** 客户名称 */
  customerName?: string;
  /**
   * 店铺id
   * @format int64
   */
  customerShopId?: number;
  /** 店铺名称 */
  customerShopName?: string;
  headerImage?: string;
  /**
   * 客户经理id
   * @format int64
   */
  managerId?: number;
  /** 客户经理名称 */
  managerName?: string;
  /** 是否通知用户 */
  notifyUser?: boolean;
  /** 商品编码 */
  productCode?: string;
  /**
   * 商品创建时间
   * @format date-time
   */
  productCreateTime?: string;
  productImgs?: string;
  /** 商品链接 */
  productLink?: string;
  /**
   * 超级客户ID
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 客户总监id
   * @format int64
   */
  supervisionManagerId?: number;
  /** 客户总监名称 */
  supervisionManagerName?: string;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
}

/** WishListNeedCreateDTO */
export interface WishListNeedCreateDTO {
  /** 图册code */
  atlasCode?: string;
  /**
   * 图册创建时间
   * @format date-time
   */
  atlasCreateTime?: string;
  /** 图册创建人id */
  atlasCreatorId?: string;
  /** 图册创建人姓名 */
  atlasCreatorName?: string;
  /**
   * 加入心愿单时间
   * @format date-time
   */
  createTime?: string;
  /**
   * 客户ID
   * @format int64
   */
  customerId?: number;
  /**
   * 超级客户ID
   * @format int64
   */
  superCustomerId?: number;
  /**
   * 客户标签类型，1:OEM重点客户-项目, 2:OEM重点客户-非项目, 4：重点新客，5：项目客户，6：重点客户
   * @format int32
   */
  tag?: number;
  /** 统一客户全名 */
  unificationCustomerFullName?: string;
}

/** WishListNeedCreateQueryReqDTO */
export interface WishListNeedCreateQueryReqDTO {
  /** 商品编码 */
  atlasCode?: string;
  /** 图册创建人姓名 */
  atlasCreatorName?: string;
  /**
   * 创建结束-后台
   * @format date-time
   */
  createTimeEnd?: string;
  /**
   * 创建开始时间-后台
   * @format date-time
   */
  createTimeStart?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  /**
   * 客户标签类型，1:OEM重点客户-项目, 2:OEM重点客户-非项目, 4：重点新客，5：项目客户，6：重点客户
   * @format int32
   */
  tags?: number;
  /** 统一客户全名-后台 */
  unificationCustomerFullName?: string;
}

/** WishListQueryReqDTO */
export interface WishListQueryReqDTO {
  /**
   * 是否可以下单
   * @format int32
   */
  canOrder?: number;
  /** 国家：例如CN（中国）KR（韩国） */
  country?: string;
  /**
   * 创建结束-后台
   * @format date-time
   */
  createTimeEnd?: string;
  /**
   * 创建开始时间-后台
   * @format date-time
   */
  createTimeStart?: string;
  /** @format int32 */
  pageNum?: number;
  /** @format int32 */
  pageSize?: number;
  /** 排序规则：正序-asc 倒序-desc；默认倒序 */
  sort?: string;
  /**
   * 排序类型 默认1 创建时间-1;
   * @format int32
   */
  sortType?: number;
  sorts?: ISortFieldEnum[];
  /** @format int32 */
  startIndex?: number;
  /** 统一客户全名-后台 */
  unificationCustomerFullName?: string;
}

/** WishListUpdateReqDTO */
export interface WishListUpdateReqDTO {
  /** 商品code列表 */
  productCodes?: string[];
}

/** BizResponse«BrandManageDetailRespDTO» */
export interface BizResponseBrandManageDetailRespDTO {
  code?: string;
  /** 后台管理-品牌详情 */
  data?: BrandManageDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«BrandSetInfoRespDTO» */
export interface BizResponseBrandSetInfoRespDTO {
  code?: string;
  /** 客户端-品牌集查询 */
  data?: BrandSetInfoRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerBrandAuthApplyAuditQueryRespDTO» */
export interface BizResponseCustomerBrandAuthApplyAuditQueryRespDTO {
  code?: string;
  data?: CustomerBrandAuthApplyAuditQueryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerBrandAuthApplyQueryRespDTO» */
export interface BizResponseCustomerBrandAuthApplyQueryRespDTO {
  code?: string;
  data?: CustomerBrandAuthApplyQueryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«CustomerBrandAuthApplyStatisticRespDTO» */
export interface BizResponseCustomerBrandAuthApplyStatisticRespDTO {
  code?: string;
  data?: CustomerBrandAuthApplyStatisticRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«HashMap«string,List«SkuRespDTO»»» */
export interface BizResponseHashMapStringListSkuRespDTO {
  code?: string;
  data?: Record<string, SkuRespDTO[]>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«IPage«OnlineManageVO»» */
export interface BizResponseIPageOnlineManageVO {
  code?: string;
  data?: IPageOnlineManageVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«IPage«StrategyConfigProductVO»» */
export interface BizResponseIPageStrategyConfigProductVO {
  code?: string;
  data?: IPageStrategyConfigProductVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«IPage«StrategyConfigShopVo»» */
export interface BizResponseIPageStrategyConfigShopVo {
  code?: string;
  data?: IPageStrategyConfigShopVo;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ImageTranslateRespDTO» */
export interface BizResponseImageTranslateRespDTO {
  code?: string;
  data?: ImageTranslateRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«BrandBannnerQueryRespDTO»» */
export interface BizResponseListBrandBannnerQueryRespDTO {
  code?: string;
  data?: BrandBannnerQueryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«BrandInfoRespDTO»» */
export interface BizResponseListBrandInfoRespDTO {
  code?: string;
  data?: BrandInfoRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«BrandItemDTO»» */
export interface BizResponseListBrandItemDTO {
  code?: string;
  data?: BrandItemDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«BrandShopRespDTO»» */
export interface BizResponseListBrandShopRespDTO {
  code?: string;
  data?: BrandShopRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«BrandStyleRespDTO»» */
export interface BizResponseListBrandStyleRespDTO {
  code?: string;
  data?: BrandStyleRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CountryRespDTO»» */
export interface BizResponseListCountryRespDTO {
  code?: string;
  data?: CountryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerBrandAuthApplyAuditQueryRespDTO»» */
export interface BizResponseListCustomerBrandAuthApplyAuditQueryRespDTO {
  code?: string;
  data?: CustomerBrandAuthApplyAuditQueryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerFocusProductPrice»» */
export interface BizResponseListCustomerFocusProductPrice {
  code?: string;
  data?: CustomerFocusProductPrice[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerFocusProductRespDTO»» */
export interface BizResponseListCustomerFocusProductRespDTO {
  code?: string;
  data?: CustomerFocusProductRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerHomeFastCategoryRespDTO»» */
export interface BizResponseListCustomerHomeFastCategoryRespDTO {
  code?: string;
  data?: CustomerHomeFastCategoryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerSearchKeywordHotRespDTO»» */
export interface BizResponseListCustomerSearchKeywordHotRespDTO {
  code?: string;
  data?: CustomerSearchKeywordHotRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«CustomerStrategyShopRespDTO»» */
export interface BizResponseListCustomerStrategyShopRespDTO {
  code?: string;
  data?: CustomerStrategyShopRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MallCategoryRespDTO»» */
export interface BizResponseListMallCategoryRespDTO {
  code?: string;
  data?: MallCategoryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MallMarketAreaRespDTO»» */
export interface BizResponseListMallMarketAreaRespDTO {
  code?: string;
  data?: MallMarketAreaRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MallMarketCategoryRespDTO»» */
export interface BizResponseListMallMarketCategoryRespDTO {
  code?: string;
  data?: MallMarketCategoryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«Map«string,object»»» */
export interface BizResponseListMapStringObject {
  code?: string;
  data?: MapStringObject[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MarketAreaRespDTO»» */
export interface BizResponseListMarketAreaRespDTO {
  code?: string;
  data?: MarketAreaRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«MaterialDTO»» */
export interface BizResponseListMaterialDTO {
  code?: string;
  data?: MaterialDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«OnlineManageTypeVO»» */
export interface BizResponseListOnlineManageTypeVO {
  code?: string;
  data?: OnlineManageTypeVO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryFrontendGroupChannelRespDTO»» */
export interface BizResponseListProductCategoryFrontendGroupChannelRespDTO {
  code?: string;
  data?: ProductCategoryFrontendGroupChannelRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryFrontendMapGroupRespDTO»» */
export interface BizResponseListProductCategoryFrontendMapGroupRespDTO {
  code?: string;
  data?: ProductCategoryFrontendMapGroupRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryFrontendRespDTO»» */
export interface BizResponseListProductCategoryFrontendRespDTO {
  code?: string;
  data?: ProductCategoryFrontendRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryFrontendRespV2DTO»» */
export interface BizResponseListProductCategoryFrontendRespV2DTO {
  code?: string;
  data?: ProductCategoryFrontendRespV2DTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryMapGroupRespDTO»» */
export interface BizResponseListProductCategoryMapGroupRespDTO {
  code?: string;
  data?: ProductCategoryMapGroupRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryMapRespDTO»» */
export interface BizResponseListProductCategoryMapRespDTO {
  code?: string;
  data?: ProductCategoryMapRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryRespDTO»» */
export interface BizResponseListProductCategoryRespDTO {
  code?: string;
  data?: ProductCategoryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryRespVO»» */
export interface BizResponseListProductCategoryRespVO {
  code?: string;
  data?: ProductCategoryRespVO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryThirdChannelPlatformTypeRespDTO»» */
export interface BizResponseListProductCategoryThirdChannelPlatformTypeRespDTO {
  code?: string;
  data?: ProductCategoryThirdChannelPlatformTypeRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryThirdRespDTO»» */
export interface BizResponseListProductCategoryThirdRespDTO {
  code?: string;
  data?: ProductCategoryThirdRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCategoryThirdShortRespDTO»» */
export interface BizResponseListProductCategoryThirdShortRespDTO {
  code?: string;
  data?: ProductCategoryThirdShortRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductChoiceCollection»» */
export interface BizResponseListProductChoiceCollection {
  code?: string;
  data?: ProductChoiceCollection[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCodeSkuMapRespDTO»» */
export interface BizResponseListProductCodeSkuMapRespDTO {
  code?: string;
  data?: ProductCodeSkuMapRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductCustomsRespDTO»» */
export interface BizResponseListProductCustomsRespDTO {
  code?: string;
  data?: ProductCustomsRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductDetailRespDTO»» */
export interface BizResponseListProductDetailRespDTO {
  code?: string;
  data?: ProductDetailRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductHsCodeKeywordMappingRespDTO»» */
export interface BizResponseListProductHsCodeKeywordMappingRespDTO {
  code?: string;
  data?: ProductHsCodeKeywordMappingRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductImageConfigRespDTO»» */
export interface BizResponseListProductImageConfigRespDTO {
  code?: string;
  data?: ProductImageConfigRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductKpiDTO»» */
export interface BizResponseListProductKpiDTO {
  code?: string;
  data?: ProductKpiDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductMallFrontendRespDTO»» */
export interface BizResponseListProductMallFrontendRespDTO {
  code?: string;
  data?: ProductMallFrontendRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductReferenceGroupRespDTO»» */
export interface BizResponseListProductReferenceGroupRespDTO {
  code?: string;
  data?: ProductReferenceGroupRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductRespDTO»» */
export interface BizResponseListProductRespDTO {
  code?: string;
  data?: ProductRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«ProductWishCanOrderRespDto»» */
export interface BizResponseListProductWishCanOrderRespDto {
  code?: string;
  data?: ProductWishCanOrderRespDto[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«PurchaseMallRespDTO»» */
export interface BizResponseListPurchaseMallRespDTO {
  code?: string;
  data?: PurchaseMallRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«QueryProductLabelRespVO»» */
export interface BizResponseListQueryProductLabelRespVO {
  code?: string;
  data?: QueryProductLabelRespVO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«RecommendSupplierSearchRespDTO»» */
export interface BizResponseListRecommendSupplierSearchRespDTO {
  code?: string;
  data?: RecommendSupplierSearchRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SearchProductRespDTO»» */
export interface BizResponseListSearchProductRespDTO {
  code?: string;
  data?: SearchProductRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SkuProductSimpleRespDTO»» */
export interface BizResponseListSkuProductSimpleRespDTO {
  code?: string;
  data?: SkuProductSimpleRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SkuRespDTO»» */
export interface BizResponseListSkuRespDTO {
  code?: string;
  data?: SkuRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SkuRespVO»» */
export interface BizResponseListSkuRespVO {
  code?: string;
  data?: SkuRespVO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SourceCategoryRespDTO»» */
export interface BizResponseListSourceCategoryRespDTO {
  code?: string;
  data?: SourceCategoryRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SourceRespDTO»» */
export interface BizResponseListSourceRespDTO {
  code?: string;
  data?: SourceRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SourceTagRespDTO»» */
export interface BizResponseListSourceTagRespDTO {
  code?: string;
  data?: SourceTagRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«StrategyConfigProductUrlResultVo»» */
export interface BizResponseListStrategyConfigProductUrlResultVo {
  code?: string;
  data?: StrategyConfigProductUrlResultVo[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«StrategyConfigShopUrlResultVo»» */
export interface BizResponseListStrategyConfigShopUrlResultVo {
  code?: string;
  data?: StrategyConfigShopUrlResultVo[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SupplierShopCustomerServiceRespDTO»» */
export interface BizResponseListSupplierShopCustomerServiceRespDTO {
  code?: string;
  data?: SupplierShopCustomerServiceRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«SupplierShopRespDTO»» */
export interface BizResponseListSupplierShopRespDTO {
  code?: string;
  data?: SupplierShopRespDTO[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«List«string»» */
export interface BizResponseListString {
  code?: string;
  data?: string[];
  msg?: string;
  success?: boolean;
}

/** BizResponse«Map«string,TaxInfoDTO»» */
export interface BizResponseMapStringTaxInfoDTO {
  code?: string;
  data?: Record<string, TaxInfoDTO>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Map«string,boolean»» */
export interface BizResponseMapStringBoolean {
  code?: string;
  data?: Record<string, boolean>;
  msg?: string;
  success?: boolean;
}

/** BizResponse«MarketAreaRespDTO» */
export interface BizResponseMarketAreaRespDTO {
  code?: string;
  /** 响应结果 */
  data?: MarketAreaRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«OnlineManageDetailVO» */
export interface BizResponseOnlineManageDetailVO {
  code?: string;
  data?: OnlineManageDetailVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«OpenShareLinkRespVO» */
export interface BizResponseOpenShareLinkRespVO {
  code?: string;
  data?: OpenShareLinkRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ProductCollectionRecommendResp»» */
export interface BizResponsePageResultProductCollectionRecommendResp {
  code?: string;
  data?: PageResultProductCollectionRecommendResp;
  msg?: string;
  success?: boolean;
}

/** BizResponse«PageResult«ProductHsCodeKeywordRespDTO»» */
export interface BizResponsePageResultProductHsCodeKeywordRespDTO {
  code?: string;
  data?: PageResultProductHsCodeKeywordRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«AtlasSupplierRespVO»» */
export interface BizResponsePageAtlasSupplierRespVO {
  code?: string;
  data?: PageAtlasSupplierRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«BrandItemDTO»» */
export interface BizResponsePageBrandItemDTO {
  code?: string;
  data?: PageBrandItemDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«BrandManageInfoRespDTO»» */
export interface BizResponsePageBrandManageInfoRespDTO {
  code?: string;
  data?: PageBrandManageInfoRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«BrandSetInfoRespDTO»» */
export interface BizResponsePageBrandSetInfoRespDTO {
  code?: string;
  data?: PageBrandSetInfoRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«BrandStyleRespDTO»» */
export interface BizResponsePageBrandStyleRespDTO {
  code?: string;
  data?: PageBrandStyleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBehaviorProductRespDTO»» */
export interface BizResponsePageCustomerBehaviorProductRespDTO {
  code?: string;
  data?: PageCustomerBehaviorProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBehaviorShopRespDTO»» */
export interface BizResponsePageCustomerBehaviorShopRespDTO {
  code?: string;
  data?: PageCustomerBehaviorShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBoughtProductRespDTO»» */
export interface BizResponsePageCustomerBoughtProductRespDTO {
  code?: string;
  data?: PageCustomerBoughtProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBoughtShopRespDTO»» */
export interface BizResponsePageCustomerBoughtShopRespDTO {
  code?: string;
  data?: PageCustomerBoughtShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBrandAuthApplyQueryFrontRespDTO»» */
export interface BizResponsePageCustomerBrandAuthApplyQueryFrontRespDTO {
  code?: string;
  data?: PageCustomerBrandAuthApplyQueryFrontRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerBrandAuthApplyQueryRespDTO»» */
export interface BizResponsePageCustomerBrandAuthApplyQueryRespDTO {
  code?: string;
  data?: PageCustomerBrandAuthApplyQueryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFavoriteBrandRespDTO»» */
export interface BizResponsePageCustomerFavoriteBrandRespDTO {
  code?: string;
  data?: PageCustomerFavoriteBrandRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFavoriteProductRespDTO»» */
export interface BizResponsePageCustomerFavoriteProductRespDTO {
  code?: string;
  data?: PageCustomerFavoriteProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFavoriteShopRespDTO»» */
export interface BizResponsePageCustomerFavoriteShopRespDTO {
  code?: string;
  data?: PageCustomerFavoriteShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFocusProduct»» */
export interface BizResponsePageCustomerFocusProduct {
  code?: string;
  data?: PageCustomerFocusProduct;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFootprintProductRespDTO»» */
export interface BizResponsePageCustomerFootprintProductRespDTO {
  code?: string;
  data?: PageCustomerFootprintProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerFootprintShopRespDTO»» */
export interface BizResponsePageCustomerFootprintShopRespDTO {
  code?: string;
  data?: PageCustomerFootprintShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«CustomerStrategyProductRespDTO»» */
export interface BizResponsePageCustomerStrategyProductRespDTO {
  code?: string;
  data?: PageCustomerStrategyProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«MallCategoryRespDTO»» */
export interface BizResponsePageMallCategoryRespDTO {
  code?: string;
  data?: PageMallCategoryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«MallMarketCategoryRespDTO»» */
export interface BizResponsePageMallMarketCategoryRespDTO {
  code?: string;
  data?: PageMallMarketCategoryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«MarketAreaRespDTO»» */
export interface BizResponsePageMarketAreaRespDTO {
  code?: string;
  data?: PageMarketAreaRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«MaterialRespDTO»» */
export interface BizResponsePageMaterialRespDTO {
  code?: string;
  data?: PageMaterialRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductCategoryRespVO»» */
export interface BizResponsePageProductCategoryRespVO {
  code?: string;
  data?: PageProductCategoryRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductCategoryThirdRespDTO»» */
export interface BizResponsePageProductCategoryThirdRespDTO {
  code?: string;
  data?: PageProductCategoryThirdRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductCustomsRespDTO»» */
export interface BizResponsePageProductCustomsRespDTO {
  code?: string;
  data?: PageProductCustomsRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductExtendRespDTO»» */
export interface BizResponsePageProductExtendRespDTO {
  code?: string;
  data?: PageProductExtendRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductHsCodeKeywordMappingRespDTO»» */
export interface BizResponsePageProductHsCodeKeywordMappingRespDTO {
  code?: string;
  data?: PageProductHsCodeKeywordMappingRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductOperatorLogVo»» */
export interface BizResponsePageProductOperatorLogVo {
  code?: string;
  data?: PageProductOperatorLogVo;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductPopularMallRespDTO»» */
export interface BizResponsePageProductPopularMallRespDTO {
  code?: string;
  data?: PageProductPopularMallRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductReferenceRespDTO»» */
export interface BizResponsePageProductReferenceRespDTO {
  code?: string;
  data?: PageProductReferenceRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductRespDTO»» */
export interface BizResponsePageProductRespDTO {
  code?: string;
  data?: PageProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductSameStyleRespVO»» */
export interface BizResponsePageProductSameStyleRespVO {
  code?: string;
  data?: PageProductSameStyleRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«ProductSimilar»» */
export interface BizResponsePageProductSimilar {
  code?: string;
  data?: PageProductSimilar;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«QueryProductAtlasRespVO»» */
export interface BizResponsePageQueryProductAtlasRespVO {
  code?: string;
  data?: PageQueryProductAtlasRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«QueryShareLinkListRespVO»» */
export interface BizResponsePageQueryShareLinkListRespVO {
  code?: string;
  data?: PageQueryShareLinkListRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«RecommendProductSearchRespDTO»» */
export interface BizResponsePageRecommendProductSearchRespDTO {
  code?: string;
  data?: PageRecommendProductSearchRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«RecommendSupplierSearchRespDTO»» */
export interface BizResponsePageRecommendSupplierSearchRespDTO {
  code?: string;
  data?: PageRecommendSupplierSearchRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SearchProductRespDTO»» */
export interface BizResponsePageSearchProductRespDTO {
  code?: string;
  data?: PageSearchProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SearchProductRespVO»» */
export interface BizResponsePageSearchProductRespVO {
  code?: string;
  data?: PageSearchProductRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SearchSupplierRespDTO»» */
export interface BizResponsePageSearchSupplierRespDTO {
  code?: string;
  data?: PageSearchSupplierRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SourceCategoryRespDTO»» */
export interface BizResponsePageSourceCategoryRespDTO {
  code?: string;
  data?: PageSourceCategoryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SourceRespDTO»» */
export interface BizResponsePageSourceRespDTO {
  code?: string;
  data?: PageSourceRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SourceTagRespDTO»» */
export interface BizResponsePageSourceTagRespDTO {
  code?: string;
  data?: PageSourceTagRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SupplierManageListVO»» */
export interface BizResponsePageSupplierManageListVO {
  code?: string;
  data?: PageSupplierManageListVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«SupplierShopRespDTO»» */
export interface BizResponsePageSupplierShopRespDTO {
  code?: string;
  data?: PageSupplierShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«WishListDTO»» */
export interface BizResponsePageWishListDTO {
  code?: string;
  data?: PageWishListDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Page«WishListNeedCreateDTO»» */
export interface BizResponsePageWishListNeedCreateDTO {
  code?: string;
  data?: PageWishListNeedCreateDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductAndSkuRespDTO» */
export interface BizResponseProductAndSkuRespDTO {
  code?: string;
  data?: ProductAndSkuRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductCategoryFrontendRespDTO» */
export interface BizResponseProductCategoryFrontendRespDTO {
  code?: string;
  data?: ProductCategoryFrontendRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductCategoryRespDTO» */
export interface BizResponseProductCategoryRespDTO {
  code?: string;
  data?: ProductCategoryRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductCategoryThirdGroupTreeShortRespDTO» */
export interface BizResponseProductCategoryThirdGroupTreeShortRespDTO {
  code?: string;
  data?: ProductCategoryThirdGroupTreeShortRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductDetailRespDTO» */
export interface BizResponseProductDetailRespDTO {
  code?: string;
  data?: ProductDetailRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductDetailResponse» */
export interface BizResponseProductDetailResponse {
  code?: string;
  data?: ProductDetailResponse;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductDetailVo» */
export interface BizResponseProductDetailVo {
  code?: string;
  data?: ProductDetailVo;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductExtendRespDTO» */
export interface BizResponseProductExtendRespDTO {
  code?: string;
  /** 响应结果 */
  data?: ProductExtendRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductFreightRespDTO» */
export interface BizResponseProductFreightRespDTO {
  code?: string;
  data?: ProductFreightRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductHsCodeKeywordMappingRespDTO» */
export interface BizResponseProductHsCodeKeywordMappingRespDTO {
  code?: string;
  data?: ProductHsCodeKeywordMappingRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductReferenceRespDTO» */
export interface BizResponseProductReferenceRespDTO {
  code?: string;
  data?: ProductReferenceRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductRespDTO» */
export interface BizResponseProductRespDTO {
  code?: string;
  data?: ProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductSameStylePutInRespVO» */
export interface BizResponseProductSameStylePutInRespVO {
  code?: string;
  data?: ProductSameStylePutInRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ProductSimpleRespDTO» */
export interface BizResponseProductSimpleRespDTO {
  code?: string;
  data?: ProductSimpleRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«QueryProductAtlasRespVO» */
export interface BizResponseQueryProductAtlasRespVO {
  code?: string;
  data?: QueryProductAtlasRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«ShopProductRespVO» */
export interface BizResponseShopProductRespVO {
  code?: string;
  data?: ShopProductRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SkuRespDTO» */
export interface BizResponseSkuRespDTO {
  code?: string;
  data?: SkuRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SkuRespVO» */
export interface BizResponseSkuRespVO {
  code?: string;
  data?: SkuRespVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SourceRespDTO» */
export interface BizResponseSourceRespDTO {
  code?: string;
  /** 响应结果 */
  data?: SourceRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«StrategyConfigProductItemVO» */
export interface BizResponseStrategyConfigProductItemVO {
  code?: string;
  data?: StrategyConfigProductItemVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«StrategyConfigShopItemVO» */
export interface BizResponseStrategyConfigShopItemVO {
  code?: string;
  data?: StrategyConfigShopItemVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupplierManageListVO» */
export interface BizResponseSupplierManageListVO {
  code?: string;
  data?: SupplierManageListVO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupplierManageSkuCountInfoVo» */
export interface BizResponseSupplierManageSkuCountInfoVo {
  code?: string;
  data?: SupplierManageSkuCountInfoVo;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupplierProductRespDTO» */
export interface BizResponseSupplierProductRespDTO {
  code?: string;
  data?: SupplierProductRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupplierShopAndProductsRespDTO» */
export interface BizResponseSupplierShopAndProductsRespDTO {
  code?: string;
  data?: SupplierShopAndProductsRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«SupplierShopRespDTO» */
export interface BizResponseSupplierShopRespDTO {
  code?: string;
  data?: SupplierShopRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«UserImageUsageRespDTO» */
export interface BizResponseUserImageUsageRespDTO {
  code?: string;
  /** 用户无水印使用详情 */
  data?: UserImageUsageRespDTO;
  msg?: string;
  success?: boolean;
}

/** BizResponse«Void» */
export interface BizResponseVoid {
  code?: string;
  msg?: string;
  success?: boolean;
}

/** BizResponse«boolean» */
export interface BizResponseBoolean {
  code?: string;
  data?: boolean;
  msg?: string;
  success?: boolean;
}

/** BizResponse«int» */
export interface BizResponseInt {
  code?: string;
  /** @format int32 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«long» */
export interface BizResponseLong {
  code?: string;
  /** @format int64 */
  data?: number;
  msg?: string;
  success?: boolean;
}

/** BizResponse«object» */
export interface BizResponseObject {
  code?: string;
  data?: object;
  msg?: string;
  success?: boolean;
}

/** BizResponse«string» */
export interface BizResponseString {
  code?: string;
  data?: string;
  msg?: string;
  success?: boolean;
}

/** EngineResult«List«HandlerServiceMeta»» */
export interface EngineResultListHandlerServiceMeta {
  /** @format int32 */
  code?: number;
  data?: HandlerServiceMeta[];
  message?: string;
}

/** EngineResult«string» */
export interface EngineResultString {
  /** @format int32 */
  code?: number;
  data?: string;
  message?: string;
}

/** HashMap«string,List«SkuRespDTO»» */
export type HashMapStringListSkuRespDTO = Record<string, any>;

/** IPage«OnlineManageVO» */
export interface IPageOnlineManageVO {
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  pages?: number;
  records?: OnlineManageVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** IPage«StrategyConfigProductVO» */
export interface IPageStrategyConfigProductVO {
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  pages?: number;
  records?: StrategyConfigProductVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** IPage«StrategyConfigShopVo» */
export interface IPageStrategyConfigShopVo {
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  pages?: number;
  records?: StrategyConfigShopVo[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Map«string,TaxInfoDTO» */
export type MapStringTaxInfoDTO = Record<string, TaxInfoDTO>;

/** Map«string,boolean» */
export type MapStringBoolean = Record<string, boolean>;

/** Map«string,object» */
export type MapStringObject = Record<string, object>;

/** PageResult«ProductCollectionRecommendResp» */
export interface PageResultProductCollectionRecommendResp {
  /** @format int64 */
  current?: number;
  records?: ProductCollectionRecommendResp[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** PageResult«ProductHsCodeKeywordRespDTO» */
export interface PageResultProductHsCodeKeywordRespDTO {
  /** @format int64 */
  current?: number;
  records?: ProductHsCodeKeywordRespDTO[];
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
  /** @format int64 */
  totalPage?: number;
}

/** Page«AtlasSupplierRespVO» */
export interface PageAtlasSupplierRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: AtlasSupplierRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«BrandItemDTO» */
export interface PageBrandItemDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: BrandItemDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«BrandManageInfoRespDTO» */
export interface PageBrandManageInfoRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: BrandManageInfoRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«BrandSetInfoRespDTO» */
export interface PageBrandSetInfoRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: BrandSetInfoRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«BrandStyleRespDTO» */
export interface PageBrandStyleRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: BrandStyleRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBehaviorProductRespDTO» */
export interface PageCustomerBehaviorProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBehaviorProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBehaviorShopRespDTO» */
export interface PageCustomerBehaviorShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBehaviorShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBoughtProductRespDTO» */
export interface PageCustomerBoughtProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBoughtProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBoughtShopRespDTO» */
export interface PageCustomerBoughtShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBoughtShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBrandAuthApplyQueryFrontRespDTO» */
export interface PageCustomerBrandAuthApplyQueryFrontRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBrandAuthApplyQueryFrontRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerBrandAuthApplyQueryRespDTO» */
export interface PageCustomerBrandAuthApplyQueryRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerBrandAuthApplyQueryRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFavoriteBrandRespDTO» */
export interface PageCustomerFavoriteBrandRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFavoriteBrandRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFavoriteProductRespDTO» */
export interface PageCustomerFavoriteProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFavoriteProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFavoriteShopRespDTO» */
export interface PageCustomerFavoriteShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFavoriteShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFocusProduct» */
export interface PageCustomerFocusProduct {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFocusProduct[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFootprintProductRespDTO» */
export interface PageCustomerFootprintProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFootprintProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerFootprintShopRespDTO» */
export interface PageCustomerFootprintShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerFootprintShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«CustomerStrategyProductRespDTO» */
export interface PageCustomerStrategyProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: CustomerStrategyProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«MallCategoryRespDTO» */
export interface PageMallCategoryRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: MallCategoryRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«MallMarketCategoryRespDTO» */
export interface PageMallMarketCategoryRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: MallMarketCategoryRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«MarketAreaRespDTO» */
export interface PageMarketAreaRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: MarketAreaRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«MaterialRespDTO» */
export interface PageMaterialRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: MaterialRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductCategoryRespVO» */
export interface PageProductCategoryRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductCategoryRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductCategoryThirdRespDTO» */
export interface PageProductCategoryThirdRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductCategoryThirdRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductCustomsRespDTO» */
export interface PageProductCustomsRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductCustomsRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductExtendRespDTO» */
export interface PageProductExtendRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductExtendRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductHsCodeKeywordMappingRespDTO» */
export interface PageProductHsCodeKeywordMappingRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductHsCodeKeywordMappingRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductOperatorLogVo» */
export interface PageProductOperatorLogVo {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductOperatorLogVo[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductPopularMallRespDTO» */
export interface PageProductPopularMallRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductPopularMallRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductReferenceRespDTO» */
export interface PageProductReferenceRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductReferenceRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductRespDTO» */
export interface PageProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductSameStyleRespVO» */
export interface PageProductSameStyleRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: ProductSameStyleRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«ProductSimilar» */
export interface PageProductSimilar {
  /** @format int32 */
  limit?: number;
  list?: ProductSimilar[];
  /** @format int32 */
  offset?: number;
  /** @format int64 */
  totalCount?: number;
  /** @format int64 */
  totalPage?: number;
}

/** Page«QueryProductAtlasRespVO» */
export interface PageQueryProductAtlasRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: QueryProductAtlasRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«QueryShareLinkListRespVO» */
export interface PageQueryShareLinkListRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: QueryShareLinkListRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«RecommendProductSearchRespDTO» */
export interface PageRecommendProductSearchRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: RecommendProductSearchRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«RecommendSupplierSearchRespDTO» */
export interface PageRecommendSupplierSearchRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: RecommendSupplierSearchRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SearchProductRespDTO» */
export interface PageSearchProductRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SearchProductRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SearchProductRespVO» */
export interface PageSearchProductRespVO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SearchProductRespVO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SearchSupplierRespDTO» */
export interface PageSearchSupplierRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SearchSupplierRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SourceCategoryRespDTO» */
export interface PageSourceCategoryRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SourceCategoryRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SourceRespDTO» */
export interface PageSourceRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SourceRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SourceTagRespDTO» */
export interface PageSourceTagRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SourceTagRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«SupplierManageListVO» */
export interface PageSupplierManageListVO {
  /** @format int32 */
  limit?: number;
  list?: SupplierManageListVO[];
  /** @format int32 */
  offset?: number;
  /** @format int64 */
  totalCount?: number;
  /** @format int64 */
  totalPage?: number;
}

/** Page«SupplierShopRespDTO» */
export interface PageSupplierShopRespDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: SupplierShopRespDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«WishListDTO» */
export interface PageWishListDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: WishListDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

/** Page«WishListNeedCreateDTO» */
export interface PageWishListNeedCreateDTO {
  countId?: string;
  /** @format int64 */
  current?: number;
  hitCount?: boolean;
  /** @format int64 */
  maxLimit?: number;
  optimizeCountSql?: boolean;
  orders?: OrderItem[];
  /** @format int64 */
  pages?: number;
  records?: WishListNeedCreateDTO[];
  searchCount?: boolean;
  /** @format int64 */
  size?: number;
  /** @format int64 */
  total?: number;
}

import axios, { AxiosInstance, AxiosRequestConfig, HeadersDefaults, ResponseType } from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "//master-gateway.theckb.com:443/goods",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title API文档
 * @version v1.0.0
 * @baseUrl //master-gateway.theckb.com:443/goods
 * @contact 史尼芙 (https://www.taobaockb.com/)
 *
 * 史尼芙API文档
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  product = {
    /**
     * No description
     *
     * @tags 商品
     * @name Detail
     * @summary 商品详情
     * @request POST:/product/detail
     */
    detail: (vo: ProductDetailRequVO, params: RequestParams = {}) =>
      this.request<BizResponseProductRespDTO, any>({
        path: `/product/detail`,
        method: "POST",
        body: vo,
        type: ContentType.Json,
        ...params,
      }),
  };
}
